webpackJsonpDotcomWeb([2],{

/***/ "+ANR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__heroGallery__ = __webpack_require__("Rutb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__heroPhoto__ = __webpack_require__("/plJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__heroAttribution__ = __webpack_require__("opmm");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Hero = /** @class */ (function (_super) {
    __extends(Hero, _super);
    function Hero() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hero.mapImagesForPhotoGallery = function (images, imageSize) {
        var items = [];
        var height = imageSize.height, width = imageSize.width;
        images.forEach(function (image) {
            var item = {
                h: height,
                src: image + "?fit=crop&w=" + width + "&h=" + height,
                w: width,
            };
            items.push(item);
        });
        return items;
    };
    Hero.Gallery = __WEBPACK_IMPORTED_MODULE_1__heroGallery__["a" /* default */];
    Hero.Photo = __WEBPACK_IMPORTED_MODULE_2__heroPhoto__["a" /* default */];
    Hero.Attribution = __WEBPACK_IMPORTED_MODULE_3__heroAttribution__["a" /* default */];
    return Hero;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Hero);


/***/ }),

/***/ "+Bcb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"linkAvatar":"styles__linkAvatar___26AD0","linkNavigation":"styles__linkNavigation___BtZzO","linkNavigationTopLevel":"styles__linkNavigationTopLevel___2ivtt","linkNavigationTopLevelIcon":"styles__linkNavigationTopLevelIcon___59tBs","linkShop":"styles__linkShop___1hOeJ","linkShopIndicator":"styles__linkShopIndicator___VsF7V","linkShopIcon":"styles__linkShopIcon___29MDs","linkSkip":"styles__linkSkip___jddX7"};

/***/ }),

/***/ "+nco":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);



var NoResults = function (_a) {
    var keyword = _a.keyword, className = _a.className;
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(className) },
        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__["Heading"], { level: 4, size: 4 },
            "No results found",
            keyword ? " for \u2019" + keyword + "\u2019" : "",
            "."),
        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__["TextBodyArticle"], { style: { marginTop: "24px" } },
            "Is this something we should have on our site? ",
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("a", { href: "https://www.lonelyplanet.com/contact" }, "Let us know"),
            ".")));
};
/* harmony default export */ __webpack_exports__["a"] = (NoResults);


/***/ }),

/***/ "+tt+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonSearch":"styles__buttonSearch___26Z6w","buttonSearchIcon":"styles__buttonSearchIcon___2-ylV"};

/***/ }),

/***/ "+xkD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"activity":"styles__activity___1NAJY","activityName":"styles__activityName___3lYeD","activityPrice":"styles__activityPrice___3_Ebe","activityPriceLabel":"styles__activityPriceLabel___OOEJl","activityButton":"styles__activityButton___34CD6","moreLink":"styles__moreLink___zwMsN"};

/***/ }),

/***/ "/Ls7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"grid":"styles__grid___gMLiL"};

/***/ }),

/***/ "/plJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_styles_mq__ = __webpack_require__("7H8p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_styles_mq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_styles_mq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_picture__ = __webpack_require__("XxOm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__("RoZr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);





var url = function (src, size) { return src + "?fit=crop&w=" + size.width + "&h=" + size.height; };
var srcSet = function (src, size) { return (url(src, size) + ", " +
    (url(src, {
        height: size.height * 2,
        width: size.width * 2,
    }) + " 2x")); };
var HeroPhoto = function (_a) {
    var src = _a.src, sizes = _a.sizes, alt = _a.alt, className = _a.className;
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_picture__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["heroPhoto"], className), srcSet: srcSet(src, sizes[320]), src: url(src, sizes[320]), alt: alt, sources: [
            {
                media: "(min-width: " + __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_styles_mq___default.a.layout.laptopStart + ")",
                srcSet: srcSet(src, sizes[1024]),
            },
            {
                media: "(min-width: " + __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_styles_mq___default.a.layout.tabletStart + ")",
                srcSet: srcSet(src, sizes[768]),
            },
            {
                media: "(min-width: " + __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_styles_mq___default.a.min[480] + ")",
                srcSet: srcSet(src, sizes[480]),
            },
        ] }));
};
/* harmony default export */ __webpack_exports__["a"] = (HeroPhoto);


/***/ }),

/***/ "01s7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__ = __webpack_require__("AemK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("yj6G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);




var SearchInputCancelButton = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("button", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["searchInputCancelButton"], className), onClick: onClick, type: "reset" },
        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__["Close"], { width: 24, height: 24 })));
};
/* harmony default export */ __webpack_exports__["a"] = (SearchInputCancelButton);


/***/ }),

/***/ "0I6n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("sTbe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__ = __webpack_require__("JHeX");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _a;


var NUM_MAP_MARKERS = 4;
var initState = {
    mapMarkers: [],
    pois: {},
};
var nearbyPoisReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["b" /* RECEIVED_NEARBY_POIS */]] = function (state, action) {
        var nearbyPois = action.payload.nearbyPois;
        var mapMarkers = nearbyPois
            .filter(function (p) { return p.location; })
            .map(function (poi) { return ({
            coordinates: poi.location.coordinates.slice(0).reverse(),
            name: poi.name,
            type: poi.poiType,
        }); })
            .slice(0, NUM_MAP_MARKERS);
        var pois = nearbyPois.reduce(function (memo, list) {
            memo[list.id] = list;
            return memo;
        }, {});
        return __assign({}, state, { mapMarkers: mapMarkers,
            pois: pois });
    },
    _a), initState);
/* harmony default export */ __webpack_exports__["a"] = (nearbyPoisReducer);


/***/ }),

/***/ "0Tsv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descriptionColumn__ = __webpack_require__("rYHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__descriptionColumnHeading__ = __webpack_require__("A7M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__descriptionColumns__ = __webpack_require__("q4XW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__descriptionHeading__ = __webpack_require__("CxGs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__descriptionText__ = __webpack_require__("N1Pn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_css__ = __webpack_require__("Fvjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_css__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};







var Description = /** @class */ (function (_super) {
    __extends(Description, _super);
    function Description() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Description.prototype.render = function () {
        var _a = this.props, children = _a.children, rest = __rest(_a, ["children"]);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_6__styles_css__["description"] }, rest), children));
    };
    Description.Column = __WEBPACK_IMPORTED_MODULE_1__descriptionColumn__["a" /* default */];
    Description.ColumnHeading = __WEBPACK_IMPORTED_MODULE_2__descriptionColumnHeading__["a" /* default */];
    Description.Columns = __WEBPACK_IMPORTED_MODULE_3__descriptionColumns__["a" /* default */];
    Description.Heading = __WEBPACK_IMPORTED_MODULE_4__descriptionHeading__["a" /* default */];
    Description.Text = __WEBPACK_IMPORTED_MODULE_5__descriptionText__["a" /* default */];
    return Description;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Description);


/***/ }),

/***/ "1HGh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tag":"styles__tag___3ZkjB","tagLabel":"styles__tagLabel___1J-B9","moreLink":"styles__moreLink___293gJ"};

/***/ }),

/***/ "1HbD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("G5OA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);



var ResultsText = function (_a) {
    var children = _a.children, id = _a.id, className = _a.className, style = _a.style;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id, className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["root"], className), style: style }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (ResultsText);


/***/ }),

/***/ "2UM/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"searchInput":"styles__searchInput___1rY7_"};

/***/ }),

/***/ "2XqC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bookmark__ = __webpack_require__("rwQh");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__bookmark__; });




/***/ }),

/***/ "35nR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("z/Jy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var Panel = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["panel"], className) }, rest), children));
};
/* harmony default export */ __webpack_exports__["a"] = (Panel);


/***/ }),

/***/ "37xT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return schemaPlace; });
var schemaPlace = function (placeData) {
    var place = {
        city: "",
        country: "",
        region: "",
    };
    var regions = [];
    placeData.forEach(function (p) {
        if (p.placeType === "region") {
            regions.push(p.name);
        }
        else {
            place[p.placeType] = p.name;
        }
    });
    if (regions.length) {
        place.region = regions[0];
    }
    return place;
};


/***/ }),

/***/ "3QpJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = filterSmallImages;
/**
 * Will filter small image objects out of an array of IImage image objects.
 * Relies on a suffix of "_s" prior to the file extension to denote smallness.
 * Does not mutate the original array.
 * @param {IImage[]} images array of image objects to be sorted.
 * @returns {IImage[]} a sorted copy of the input images array.
 */
// https://regex101.com/r/gzSd5i/1
var smallImageUrlRegex = /^.+_s\.\w{3,4}$/;
function filterSmallImages(images) {
    return images.filter(function (image) { return !smallImageUrlRegex.test(image.url); });
}


/***/ }),

/***/ "3jnV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"toastContainer":"styles__toastContainer___Jl3nf"};

/***/ }),

/***/ "3nvx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"searchForm":"styles__searchForm___Hi23a","searchInput":"styles__searchInput___2eyJw","searchInputCancelButton":"styles__searchInputCancelButton___2KX2d"};

/***/ }),

/***/ "4XlA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOAST_HIDE = "TOAST_HIDE";
exports.TOAST_SHOW = "TOAST_SHOW";
exports.TOAST_DURATION = 5000;

/***/ }),

/***/ "4c3f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tourAnchor":"styles__tourAnchor___350WD","tourImage":"styles__tourImage___3CuSG","tourMeta":"styles__tourMeta___2kC14","tourPrice":"styles__tourPrice___1hcfi"};

/***/ }),

/***/ "4nSq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("2UM/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);



var SearchInput = function (_a) {
    var id = _a.id, name = _a.name, className = _a.className, value = _a.value, placeholder = _a.placeholder, required = _a.required, onChange = _a.onChange, innerRef = _a.innerRef;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", { id: id, name: name, value: value, className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["searchInput"], className, "js-gtm-search-input"), placeholder: placeholder, required: required, onChange: onChange, ref: innerRef, type: "text", autoCapitalize: "none", autoComplete: "off", autoCorrect: "off", spellCheck: false }));
};
/* harmony default export */ __webpack_exports__["a"] = (SearchInput);


/***/ }),

/***/ "4pXv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AnalyticsEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context__ = __webpack_require__("6lmz");


function AnalyticsEvent(_a) {
    var render = _a.render;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__context__["a" /* Context */].Consumer, null, function (track) { return render(track); }));
}


/***/ }),

/***/ "5HWx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAdTargeting; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__ = __webpack_require__("cRoh");

var slugify = function (value) {
    // allow only basic latin alpha, numeric, / - _ and whitespace
    return __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].deburr(value) // eslint-disable-line no-param-reassign
        .replace(/[^/-\w\s]/gi, "")
        .toLowerCase()
        .replace(/\s/g, "-"); // from rizzo next
};
var createAdTargeting = function (dataLayer) {
    if (dataLayer === void 0) { dataLayer = {}; }
    if (Object.keys(dataLayer).length) {
        var dest = [
            "cd1_Continent",
            "cd2_Country",
            "cd3_City",
            "cd4_Neighborhood",
            "cd5_Region"
        ]
            .filter(function (item) { return dataLayer[item]; })
            .map(function (item) { return dataLayer[item]; }).join(",");
        return {
            city: slugify(dataLayer.cd3_City),
            cnty: slugify(dataLayer.cd2_Country),
            ctt: slugify(dataLayer.cd1_Continent),
            dest: dest,
            destination: dest,
            dfpkey: typeof window !== "undefined" && window.lp.ads
                ? window.lp.ads.dfpkey
                : null,
            interest: typeof window !== "undefined" && window.lp.ads
                ? window.lp.ads.interest
                : null,
            state: slugify(dataLayer.cd5_Region),
        };
    }
    return {};
};


/***/ }),

/***/ "6lmz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var Context = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"](function () { return null; });


/***/ }),

/***/ "6mTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdHero; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("uYDL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var AdHero = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({}, rest, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["ad"], __WEBPACK_IMPORTED_MODULE_2__styles_css__["adHero"], className) }), children));
};


/***/ }),

/***/ "6tpt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var removeHTML = function (html) {
    var text = html;
    if (!text) {
        return;
    }
    if (Array.isArray(text)) {
        text = text.join("");
    }
    if (typeof document === "undefined") {
        return text.replace(/<\/?[^>]+(>|$)/g, "");
    }
    var element = document.createElement("div");
    element.innerHTML = text;
    return element.textContent || element.innerText || "";
};
/* harmony default export */ __webpack_exports__["a"] = (removeHTML);


/***/ }),

/***/ "6z/T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adUnitSuperzone__ = __webpack_require__("gBmD");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Superzone", function() { return __WEBPACK_IMPORTED_MODULE_0__adUnitSuperzone__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adUnitSideRail__ = __webpack_require__("sbiH");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SideRail", function() { return __WEBPACK_IMPORTED_MODULE_1__adUnitSideRail__["a"]; });




/***/ }),

/***/ "71+K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adBounded__ = __webpack_require__("trvs");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Bounded", function() { return __WEBPACK_IMPORTED_MODULE_0__adBounded__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adHero__ = __webpack_require__("6mTi");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Hero", function() { return __WEBPACK_IMPORTED_MODULE_1__adHero__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adLabel__ = __webpack_require__("otJW");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return __WEBPACK_IMPORTED_MODULE_2__adLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__adPrimary__ = __webpack_require__("Abp9");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Primary", function() { return __WEBPACK_IMPORTED_MODULE_3__adPrimary__["a"]; });






/***/ }),

/***/ "8SFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__ = __webpack_require__("AemK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_utils_schema__ = __webpack_require__("gDiJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_utils_schema___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_utils_schema__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__("XPoP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var listMicroData = __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_utils_schema___default()({
    itemType: "BreadcrumbList",
});
var itemMicroData = __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_utils_schema___default()({
    itemProp: "itemListElement",
    itemType: "ListItem",
});
var schemaItemType = {
    lodging: "Thing",
    partner_activity: "Thing",
    place: "Place",
    poi: "Thing",
};
var linkMicroData = function (link) {
    return __assign({ itemId: "//www.lonelyplanet.com" + link.href }, __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_utils_schema___default()({
        itemProp: "item",
        itemType: link && link.type ? schemaItemType[link.type] : "Thing",
    }));
};
var Breadcrumbs = function (_a) {
    var links = _a.links, className = _a.className;
    var items = links.map(function (link, index) { return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", __assign({ className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["breadcrumbsItem"], key: link.href, "data-placeType": link.placeType }, itemMicroData),
        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("a", __assign({ href: "//www.lonelyplanet.com" + link.href, key: link.href }, linkMicroData(link)),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", { itemProp: "name" }, link.title)),
        index < links.length - 1 &&
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__["ChevronRight"], { width: 6 / 14 + "em", height: 6 / 14 + "em" }),
        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("meta", { itemProp: "position", content: "" + (index + 1) }))); });
    return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("nav", __assign({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["breadcrumbs"], className) }, listMicroData), items));
};
/* harmony default export */ __webpack_exports__["a"] = (Breadcrumbs);


/***/ }),

/***/ "8zPH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__("mTna");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__button__; });




/***/ }),

/***/ "97Rg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return opTypeMapping; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__ = __webpack_require__("Jg0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__);
var _a;

var opTypeMapping = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__["article"]] = "Article",
    _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__["lodging"]] = "Hotel",
    _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__["news"]] = "News",
    _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__["partnerActivity"]] = "Activity",
    _a["partner-activity"] = "Activity",
    _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__["place"]] = "Destination",
    _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__["poi"]] = "Thing to do",
    _a.product = "Book",
    _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__["thorntreeForum"]] = "Thorntree forum",
    _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__["thorntreeTopic"]] = "Thorntree topic",
    _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__["video"]] = "Video",
    _a);


/***/ }),

/***/ "9Nd/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"textAccentRed":"styles__textAccentRed___1lcXy","textArticle":"styles__textArticle___OqHJQ","textArticleSmall":"styles__textArticleSmall___2Jm5z","textItalic":"styles__textItalic___15R8L","textMeta":"styles__textMeta___3gOue","textUppercase":"styles__textUppercase___3opG_"};

/***/ }),

/***/ "9OJJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

var TextHtml = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({ dangerouslySetInnerHTML: { __html: children } }, rest)));
};
/* harmony default export */ __webpack_exports__["a"] = (TextHtml);


/***/ }),

/***/ "9yvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fallback":"styles__fallback___3Om8d","error":"styles__error___3wBoZ"};

/***/ }),

/***/ "A7M+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descriptionHeading__ = __webpack_require__("CxGs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("Fvjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var DescriptionColumnHeading = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__descriptionHeading__["a" /* default */], __assign({ className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["descriptionColumnHeading"], weight: "regular" }, rest), children));
};
/* harmony default export */ __webpack_exports__["a"] = (DescriptionColumnHeading);


/***/ }),

/***/ "AEBA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__textAccentRed__ = __webpack_require__("xGcm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__textArticle__ = __webpack_require__("Dy1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__textArticleSmall__ = __webpack_require__("HLpZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__textHtml__ = __webpack_require__("9OJJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__textItalic__ = __webpack_require__("gpAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__textMeta__ = __webpack_require__("k0gy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__textUppercase__ = __webpack_require__("TvgL");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Text.AccentRed = __WEBPACK_IMPORTED_MODULE_1__textAccentRed__["a" /* default */];
    Text.Article = __WEBPACK_IMPORTED_MODULE_2__textArticle__["a" /* default */];
    Text.ArticleSmall = __WEBPACK_IMPORTED_MODULE_3__textArticleSmall__["a" /* default */];
    Text.Html = __WEBPACK_IMPORTED_MODULE_4__textHtml__["a" /* default */];
    Text.Italic = __WEBPACK_IMPORTED_MODULE_5__textItalic__["a" /* default */];
    Text.Meta = __WEBPACK_IMPORTED_MODULE_6__textMeta__["a" /* default */];
    Text.Uppercase = __WEBPACK_IMPORTED_MODULE_7__textUppercase__["a" /* default */];
    return Text;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Text);


/***/ }),

/***/ "Abp9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdPrimary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("uYDL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var AdPrimary = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({}, rest, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["ad"], className) }), children));
};


/***/ }),

/***/ "Ahhh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createRoot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_router__ = __webpack_require__("H7tR");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var createRoot = function (Application) { return function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_router__["a" /* Router */], __assign({}, Object(__WEBPACK_IMPORTED_MODULE_1__components_router__["b" /* getProps */])(props)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Application, __assign({}, props))));
}; };


/***/ }),

/***/ "Apsl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___uzu36"};

/***/ }),

/***/ "B+kQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return removeTopicIdFromString; });
var removeTopicIdFromString = function (topicId, topicString) {
    if (!topicString) {
        return;
    }
    return topicString
        .split(",")
        .filter(function (id) { return id !== topicId; })
        .join(",");
};


/***/ }),

/***/ "B6TH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var TemplatePosition = function (_a) {
    var area = _a.area, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, children));
};
/* harmony default export */ __webpack_exports__["a"] = (TemplatePosition);


/***/ }),

/***/ "B7EN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var create_1 = __webpack_require__("OxjI");
exports.Urls = create_1.Urls;


/***/ }),

/***/ "BIrW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = showDetailsSection;
function showDetailsSection(poi) {
    var _a = poi.address, address = _a === void 0 ? {} : _a, _b = poi.telephone, telephone = _b === void 0 ? {} : _b, _c = poi.emails, emails = _c === void 0 ? [] : _c, website = poi.website, hours = poi.hours, price = poi.price;
    return !!(address.street ||
        address.extras ||
        telephone.national ||
        (emails && emails.length > 0) ||
        website ||
        hours ||
        price);
}


/***/ }),

/***/ "BK2A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_providerLogo__ = __webpack_require__("qqnu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_providerLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_providerLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("meXs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);




var BookingProvider = function (_a) {
    var provider = _a.provider, className = _a.className;
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["bookingProvider"], className) },
        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_providerLogo___default.a, { className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["bookingProviderLogo"], provider: provider })));
};
/* harmony default export */ __webpack_exports__["a"] = (BookingProvider);


/***/ }),

/***/ "BkY2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFullBodyText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stripHtml__ = __webpack_require__("OitI");

var addSpace = function (shouldAddSpace) { return shouldAddSpace ? " " : ""; };
var getFullBodyText = function (_a) {
    var review = _a.review, provider = _a.provider, descriptions = _a.descriptions;
    var bodyText = "";
    if (review && review.essential) {
        bodyText = review.essential +
            addSpace(review.extension !== "") +
            review.extension || "";
    }
    if (provider && provider.data && provider.data.description.length > 0) {
        var fullProviderDescription = provider.data.description.reduce(function (acc, curr, index) { return (acc += "" + (addSpace(bodyText !== "" || index !== 0) + curr.text)); }, "");
        bodyText += fullProviderDescription;
    }
    if (descriptions && (descriptions.longDescription || descriptions.shortDescription)) {
        var short = descriptions.shortDescription, long = descriptions.longDescription;
        // Convert descriptions to strings because they can come back as `null`
        var shortDescription = typeof short === "string" ? short : "";
        var longDescription = typeof long === "string" ? long : "";
        var fullDescription = shortDescription +
            addSpace(shortDescription && longDescription) +
            longDescription || "";
        bodyText += fullDescription;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__stripHtml__["a" /* default */])(bodyText);
};


/***/ }),

/***/ "Bs0H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("Apsl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);



var Container = function (_a) {
    var children = _a.children, id = _a.id, className = _a.className, style = _a.style;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id, className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["container"], className), style: style }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (Container);


/***/ }),

/***/ "BuJs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MultiLine;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function MultiLine(_a) {
    var text = _a.text;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, text.split("\n").map(function (t, i) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { key: i },
            t,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null)));
    })));
}


/***/ }),

/***/ "Bz8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return partnerActivityProviders; });
var _a;
var keys = {
    gadventures: "gadventures",
    viator: "viator",
};
var partnerActivityProviders = (_a = {},
    _a[keys.gadventures] = {
        id: keys.gadventures,
        name: "G Adventures",
    },
    _a[keys.viator] = {
        id: keys.viator,
        name: "Viator",
    },
    _a);


/***/ }),

/***/ "C+Uo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_analytics__ = __webpack_require__("Kx1W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_moreLink__ = __webpack_require__("UMFO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_moreLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_moreLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_utils_typography__ = __webpack_require__("D7WX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_utils_typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_utils_typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_utils_slug__ = __webpack_require__("sn/o");





var SuggestEdit = function (_a) {
    var poi = _a.poi, location = _a.location;
    return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_analytics__["a" /* AnalyticsEvent */], { render: function (track) { return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_moreLink___default.a, { target: "_blank", hideIcon: true, href: Object(__WEBPACK_IMPORTED_MODULE_4__shared_utils_slug__["c" /* createSuggestEditSlug */])(poi, location), style: Object(__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_utils_typography__["textAccent"])(), onClick: function (e) {
                track({
                    event: "suggest edit click",
                    "gtm.element": "suggestEdit",
                    "gtm.elementText": "Suggest an Edit",
                });
            } }, "Suggest an Edit")); } }));
};
/* harmony default export */ __webpack_exports__["a"] = (SuggestEdit);


/***/ }),

/***/ "CEdI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__ = __webpack_require__("cRoh");

var placeTypes = {
    city: "city",
    continent: "continent",
    country: "country",
    neighborhood: "neighborhood",
    region: "region",
};
/**
 * Uses the placeTypes to generate several isPlaceType functions.
 *
 * isCountry(place);
 * isContinent(place);
 * isRegion(place);
 */
var placeTypeUtils = Object.keys(placeTypes).reduce(function (m, pt) {
    var memo = m;
    var key = "" + __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].capitalize(pt);
    memo["is" + key] = function (p) { return p.placeType === placeTypes[pt]; };
    return memo;
}, {});
/* harmony default export */ __webpack_exports__["a"] = (placeTypeUtils);


/***/ }),

/***/ "CPb4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPartnerActivityType; });
var getPartnerActivityType = function (duration, type) {
    if (type === void 0) { type = "plural"; }
    if (!duration) {
        return "";
    }
    if (duration.unit !== "days") {
        return type === "singular" ? "activity" : "activities";
    }
    if (duration.unit === "days" && duration.duration > 3) {
        return type === "singular" ? "tour" : "tours";
    }
    return type === "singular" ? "activity" : "activities";
};


/***/ }),

/***/ "CUEi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__review__ = __webpack_require__("ayG1");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__review__["a" /* default */]);


/***/ }),

/***/ "CxGs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("Fvjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var DescriptionHeading = function (_a) {
    var children = _a.children, _b = _a.weight, weight = _b === void 0 ? "medium" : _b, className = _a.className, rest = __rest(_a, ["children", "weight", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__["Heading"], __assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["descriptionHeading"], className), size: 7, level: 3, weight: weight }, rest), children));
};
/* harmony default export */ __webpack_exports__["a"] = (DescriptionHeading);


/***/ }),

/***/ "D6q0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hero__ = __webpack_require__("+ANR");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__hero__["a" /* default */]);


/***/ }),

/***/ "DNSJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var authRequestBuilder_1 = __webpack_require__("nclR");

var constants_1 = __webpack_require__("RF4c");

exports.authSetupWithDefaults = function (params) {
  if (params === void 0) {
    params = {};
  }

  var defaults = constants_1.authDefaults;
  var options = params.options || {};
  var host = params.host || defaults.host;
  return authRequestBuilder_1.default.build({
    host: host,
    options: __assign({}, options, {
      clientId: options.clientId || defaults.options.clientId,
      scope: options.scope || defaults.options.scope,
      redirectUri: options.redirectUri || host.replace(/http:/, "https:") + "/sso",
      targetLinkUri: options.targetLinkUri || typeof window !== "undefined" && window.location.origin + window.location.pathname
    })
  });
};

exports.default = {
  authSetupWithDefaults: exports.authSetupWithDefaults
};

/***/ }),

/***/ "DTul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placeTypesToHide */
/* unused harmony export validBreadcrumbPlaceTypes */
/* unused harmony export mapPlaceToBreadcrumb */
/* unused harmony export isMissingCity */
/* unused harmony export isMissingCountry */
/* unused harmony export getCityFromPoi */
/* unused harmony export addPoiCityToAncestry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createBreadcrumbsFromAncestry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBreadcrumbFromPoi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lodash__ = __webpack_require__("cRoh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__poi__ = __webpack_require__("s/JD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slug__ = __webpack_require__("sn/o");



var capitalize = __WEBPACK_IMPORTED_MODULE_0__lodash__["b" /* default */].capitalize;
var placeTypesToHide = ["region", "neighborhood"];
var validBreadcrumbPlaceTypes = function (place) {
    return placeTypesToHide.indexOf(place.placeType) < 0;
};
var mapPlaceToBreadcrumb = function (place) { return ({
    href: "/places/" + place.id,
    placeType: place.placeType,
    title: place.name,
    type: place.type,
}); };
var isMissingCity = function (ancestry) {
    return !(__WEBPACK_IMPORTED_MODULE_0__lodash__["b" /* default */].find(ancestry, function (place) { return place.placeType === "city"; }));
};
var isMissingCountry = function (ancestry) {
    return !(__WEBPACK_IMPORTED_MODULE_0__lodash__["b" /* default */].find(ancestry, function (place) { return place.placeType === "country"; }));
};
function getCityFromPoi(poi) {
    return poi.containingPlaceName ? {
        id: poi.containingPlaceId,
        name: poi.containingPlaceName,
        placeType: "city",
        type: poi.type,
    } : false;
}
function addPoiCityToAncestry(ancestry, poi) {
    var cityFromPoi = getCityFromPoi(poi);
    return cityFromPoi ? [cityFromPoi].concat(ancestry) : ancestry.slice();
}
var createBreadcrumbsFromAncestry = function (ancestry, poi, limit) {
    if (limit === void 0) { limit = 3; }
    if (isMissingCity(ancestry) && isMissingCountry(ancestry)) {
        var region = Object(__WEBPACK_IMPORTED_MODULE_2__slug__["d" /* getPlaceType */])(ancestry, "region");
        if (region) {
            return ancestry
                .filter(validBreadcrumbPlaceTypes)
                .concat(region)
                .map(mapPlaceToBreadcrumb)
                .slice(0, limit);
        }
    }
    if (isMissingCity(ancestry)) {
        ancestry = addPoiCityToAncestry(ancestry, poi);
    }
    return ancestry
        .filter(validBreadcrumbPlaceTypes)
        .map(mapPlaceToBreadcrumb)
        .reverse()
        .slice(0, limit);
};
var getPoiBreadcrumbTitle = function (poi) {
    var type = poi.type, poiType = poi.poiType, duration = poi.duration;
    var isPartnerActivity = !poiType && duration;
    return isPartnerActivity ?
        capitalize(Object(__WEBPACK_IMPORTED_MODULE_1__poi__["a" /* getPartnerActivityType */])(poi.duration)) :
        capitalize(__WEBPACK_IMPORTED_MODULE_1__poi__["d" /* poiTypeTitleMap */][poi.poiType]);
};
var createBreadcrumbFromPoi = function (poi, ancestry) {
    if (isMissingCity(ancestry)) {
        ancestry = addPoiCityToAncestry(ancestry, poi);
    }
    var poiBreadcrumb = {
        href: Object(__WEBPACK_IMPORTED_MODULE_2__slug__["b" /* createPoiListSlug */])(poi, ancestry),
        title: getPoiBreadcrumbTitle(poi),
        type: poi.type,
    };
    return poiBreadcrumb;
};


/***/ }),

/***/ "Df23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_polyfills_arrayIncludes__ = __webpack_require__("SZH8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_polyfills_arrayIncludes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_polyfills_arrayIncludes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_polyfills_stringIncludes__ = __webpack_require__("bhYL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_polyfills_stringIncludes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_polyfills_stringIncludes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_polyfills_promise__ = __webpack_require__("t4Id");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_globalComponents__ = __webpack_require__("seTe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_root__ = __webpack_require__("XHb/");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/* tslint:disable */







var initialState = JSON.parse(document.getElementById("initialState").textContent);
window.__initialState = initialState;
Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["hydrate"])(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_root__["a" /* default */], __assign({}, initialState)), document.getElementById("app"));
if (false) {
    module.hot.accept("./shared/root", function () {
        var NewRoot = require("./shared/root").default;
        hydrate(React.createElement(NewRoot, __assign({}, window.__initialState)), document.getElementById("app"));
    });
}
if (!window.__initialState.useLegacyHeader) {
    Object(__WEBPACK_IMPORTED_MODULE_5__shared_globalComponents__["a" /* setupGlobalComponents */])();
}
if (false) {
    module.hot.accept("./shared/globalComponents", function () {
        var setup = require("./shared/globalComponents").setupGlobalComponents;
        setup();
    });
}


/***/ }),

/***/ "Dy1O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("9Nd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var TextArticle = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["textArticle"], className) }, rest), children));
};
/* harmony default export */ __webpack_exports__["a"] = (TextArticle);


/***/ }),

/***/ "FK8g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("sTbe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__ = __webpack_require__("JHeX");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _a;


var initState = {
    id: null,
};
var userReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["f" /* RECEIVED_USER_LOGIN */]] = function (state, action) {
        var user = action.payload.user;
        return __assign({}, state, user);
    },
    _a), initState);
/* harmony default export */ __webpack_exports__["a"] = (userReducer);


/***/ }),

/***/ "FcFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_components_toast_globalToastFromCookie__ = __webpack_require__("WRu6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_core_dist_components_login__ = __webpack_require__("GI8K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lonelyplanet_dotcom_core_dist_containers_dataLayer__ = __webpack_require__("sxtG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lonelyplanet_dotcom_routing_dist_details_routes__ = __webpack_require__("xY00");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lonelyplanet_dotcom_routing_dist_details_routes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lonelyplanet_dotcom_routing_dist_details_routes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lonelyplanet_travel_agent_dist_helmet__ = __webpack_require__("OH7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lonelyplanet_travel_agent_dist_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__lonelyplanet_travel_agent_dist_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_bookmarks__ = __webpack_require__("GpE5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_pois__ = __webpack_require__("vmIt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_pois_store_configureStore__ = __webpack_require__("TmcO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_profile__ = __webpack_require__("z6N1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_search__ = __webpack_require__("buU8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appProviders__ = __webpack_require__("y78e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_asset__ = __webpack_require__("xVEJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__("e9aK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lonelyplanet_lp_analytics__ = __webpack_require__("UtEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lonelyplanet_lp_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__lonelyplanet_lp_analytics__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

















var poiStore = Object(__WEBPACK_IMPORTED_MODULE_10__modules_pois_store_configureStore__["a" /* default */])();
if (typeof window !== "undefined") {
    window.$$store = poiStore;
}
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    App.prototype.render = function () {
        var _a;
        var props = this.props;
        var _b = props.features, features = _b === void 0 ? {} : _b, _c = props.poi, poi = _c === void 0 ? {} : _c;
        return (__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__appProviders__["a" /* AppProviders */], null,
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__lonelyplanet_travel_agent_dist_helmet__["Helmet"], { titleTemplate: "%s - Lonely Planet", defaultTitle: "Lonely Planet" }),
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_dotcom_core_dist_containers_dataLayer__["a" /* default */], { data: {
                        cd22_ApplicationName: "dotcom-web",
                        cd24_LoginState: null,
                    } }),
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__lonelyplanet_lp_analytics__["DataLayerInitializationData"], { data: (_a = {},
                        _a[__WEBPACK_IMPORTED_MODULE_16__lonelyplanet_lp_analytics__["analytics"].applicationName] = __WEBPACK_IMPORTED_MODULE_16__lonelyplanet_lp_analytics__["ApplicationNames"].dotcomWeb,
                        _a), indexForEntirePayload: 1, scriptWrapperForEntirePayload: __WEBPACK_IMPORTED_MODULE_16__lonelyplanet_lp_analytics__["asyncUserStatusWrapper"] }),
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_15__constants__["c" /* bookmarkRoutes */].show, component: __WEBPACK_IMPORTED_MODULE_8__modules_bookmarks__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_15__constants__["g" /* searchRoutes */].show, render: function () { return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__modules_search__["a" /* default */], __assign({}, props.search)); } }),
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Route */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_15__constants__["f" /* profileRoutes */].show, component: __WEBPACK_IMPORTED_MODULE_11__modules_profile__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_15__constants__["c" /* bookmarkRoutes */].show, component: __WEBPACK_IMPORTED_MODULE_8__modules_bookmarks__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Route */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_3__lonelyplanet_dotcom_routing_dist_details_routes__["poisRoutes"].detail, render: function poiRender(route) {
                        return (__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* Provider */], { store: poiStore },
                            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__modules_pois__["a" /* default */], __assign({}, props, { match: route.match }))));
                    } }),
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_core_dist_components_login__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_components_toast_globalToastFromCookie__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__components_asset__["a" /* default */], { src: "app.js" }))));
    };
    return App;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (App);
// import createHistory from "history/createBrowserHistory";
// export default ({
//   message
// }) => (
// <Router
//   history={createHistory()}
// >
//   <Route match="/" render={() => (
//     <AsyncPois
//       message="hell effin yea oh hai!!"
//     />)}
//   />
// </Router>
// );


/***/ }),

/***/ "Fi1p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ad":"styles__ad___1O99x","adLabel":"styles__adLabel___2p_Qf"};

/***/ }),

/***/ "Fvjs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"description":"styles__description___3_Z75","descriptionColumns":"styles__descriptionColumns___3p7Zb","descriptionHeading":"styles__descriptionHeading___2-Jo3","descriptionColumn":"styles__descriptionColumn___5rqvC","descriptionColumnHeading":"styles__descriptionColumnHeading___3U7dE","descriptionText":"styles__descriptionText___PAVMt"};

/***/ }),

/***/ "G5OA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root___2nmws"};

/***/ }),

/***/ "GI8K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__("j9g7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium__ = __webpack_require__("i2KN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers___ = __webpack_require__("DNSJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helpers___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authModal__ = __webpack_require__("kJxK");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Component = __WEBPACK_IMPORTED_MODULE_2_react__["Component"];
var GlobalLogin = /** @class */ (function (_super) {
    __extends(GlobalLogin, _super);
    function GlobalLogin(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            authActions: {},
            isOpen: false,
        };
        _this.close = _this.close.bind(_this);
        return _this;
    }
    GlobalLogin.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener("hashchange", function () {
            _this.setState({
                isOpen: _this.isOpen(),
            });
        }, false);
        var authLinks = Object(__WEBPACK_IMPORTED_MODULE_3__helpers___["authSetupWithDefaults"])(window.lp.auth);
        this.setState({
            authActions: {
                facebook: function () {
                    window.location.href = authLinks.facebookLink;
                },
                twitter: function () {
                    window.location.href = authLinks.twitterLink;
                },
                google: function () {
                    window.location.href = authLinks.googleLink;
                },
                passwordless: function (email) {
                    var magicLink = authLinks.passwordlessLink(email);
                    __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__(magicLink, {
                        method: "post",
                        credentials: "include",
                    });
                },
                password: authLinks.passwordLink,
            },
            isOpen: this.isOpen(),
        });
    };
    GlobalLogin.prototype.isOpen = function () {
        return typeof window !== "undefined" && window.location.hash.indexOf("login") === 1;
    };
    GlobalLogin.prototype.close = function () {
        window.location.hash = "";
    };
    GlobalLogin.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_radium__["a" /* StyleRoot */], null, this.state.isOpen &&
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__authModal__["a" /* default */], { isOpen: this.state.isOpen, closeModal: this.close, authActions: this.state.authActions, isMobile: false })));
    };
    return GlobalLogin;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (GlobalLogin);


/***/ }),

/***/ "GpE5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui__ = __webpack_require__("u9rH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("F8kA");



/* harmony default export */ __webpack_exports__["a"] = (function (_a) {
    var match = _a.match, lists = _a.lists;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui__["Container"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h1", null, "Bookmarks!"),
            JSON.stringify(lists),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "/usa/nashville/a/poi-sig/1234" }, "Nashville POIs")),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "/profile/" + match.params.username + "/lists/more" }, "More"))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Route */], { path: "/profile/" + match.params.username + "/lists/more", render: function () { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h3", null, "More")); } }))));
});


/***/ }),

/***/ "GvR7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__("WDgB");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__button__; });




/***/ }),

/***/ "H7tR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__("ciQf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("F8kA");


var Router = typeof window !== "undefined" ? __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Router */] : __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* StaticRouter */];
var getProps = function (_a) {
    var location = _a.location;
    return typeof window !== "undefined" ? {
        history: __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()(),
    } : {
        context: {},
        location: location,
    };
};



/***/ }),

/***/ "HLH5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"indicator":"styles__indicator___38XNJ"};

/***/ }),

/***/ "HLpZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("9Nd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var TextArticleSmall = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["textArticleSmall"], className) }, rest), children));
};
/* harmony default export */ __webpack_exports__["a"] = (TextArticleSmall);


/***/ }),

/***/ "HZ7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_containers_dataLayer__ = __webpack_require__("sxtG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_travel_agent_dist_helmet__ = __webpack_require__("OH7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_travel_agent_dist_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_travel_agent_dist_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_ad__ = __webpack_require__("W0rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_template__ = __webpack_require__("Pjik");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_patterns_breadcrumbs__ = __webpack_require__("8SFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_utils_lodash__ = __webpack_require__("cRoh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__patterns_booking__ = __webpack_require__("juIJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__patterns_description__ = __webpack_require__("IUL9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__patterns_header__ = __webpack_require__("dieY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__patterns_hero__ = __webpack_require__("D6q0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__patterns_info__ = __webpack_require__("kx1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_pois_css__ = __webpack_require__("YLLQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_pois_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_pois_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__templates_detail__ = __webpack_require__("tpip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_createAdTargeting__ = __webpack_require__("5HWx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_getPartnerActivityPricing__ = __webpack_require__("Jben");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getPartnerActivityType__ = __webpack_require__("CPb4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_heroImageSizes__ = __webpack_require__("kcVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_partnerActivityProviders__ = __webpack_require__("Bz8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics__ = __webpack_require__("UtEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__patterns_tags__ = __webpack_require__("wNbw");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





















var PagePartnerActivity = /** @class */ (function (_super) {
    __extends(PagePartnerActivity, _super);
    function PagePartnerActivity() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.provider = {
            gadventures: "G Adventures",
            viator: "Viator",
        };
        _this.hasInclusions = _this.props.poi.inclusions &&
            _this.props.poi.inclusions.length > 0;
        _this.hasExclusions = _this.props.poi.exclusions &&
            _this.props.poi.exclusions.length > 0;
        _this.hasHighlights = _this.props.poi.highlights &&
            _this.props.poi.highlights.length > 0;
        _this.showActivityFeatures = _this.hasInclusions || _this.hasExclusions || _this.hasHighlights;
        _this.hasMedia = _this.props.poi.media &&
            _this.props.poi.media.images &&
            _this.props.poi.media.images.length > 0;
        _this.hasImages = _this.props.poi.images &&
            _this.props.poi.images.length;
        _this.hasMainImageAttributions = _this.hasImages &&
            Array.isArray(_this.props.poi.images[0].attribution) &&
            _this.props.poi.images[0].attribution.length > 0;
        _this.hasDescription = _this.props.poi.descriptions && (_this.props.poi.descriptions.shortDescription ||
            _this.props.poi.descriptions.longDescription);
        _this.hasEssentialInfo = _this.props.poi.duration ||
            _this.props.poi.departureInfo ||
            _this.props.poi.returnInfo;
        _this.hasItinerary = _this.props.poi.itinerary &&
            _this.props.poi.itinerary.length;
        _this.place = _this.props.places.find(function (p) { return _this.props.match.params.placeId === p.id; });
        return _this;
    }
    Object.defineProperty(PagePartnerActivity.prototype, "providerAttributions", {
        get: function () {
            /**
             * To be used in lieu of actual data from the API when we're using poi.media.images
             * instead of poi.images; the former do not have attribution data, so we substitute in the name of the provider.
             */
            return [
                {
                    name: null,
                    organization: this.provider[this.props.poi.provider],
                },
            ];
        },
        enumerable: true,
        configurable: true
    });
    PagePartnerActivity.prototype.render = function () {
        var _a;
        var _b = this.props, breadcrumbs = _b.breadcrumbs, tags = _b.tags, meta = _b.meta, poi = _b.poi, dataLayer = _b.dataLayer, bookmarked = _b.bookmarked, onClickBookmark = _b.onClickBookmark, lpCurrency = _b.lpCurrency;
        var subtype = Object(__WEBPACK_IMPORTED_MODULE_16__utils_getPartnerActivityType__["a" /* getPartnerActivityType */])(poi.duration);
        var activityRating = poi.rating && __WEBPACK_IMPORTED_MODULE_6__shared_utils_lodash__["b" /* default */].round(parseFloat(poi.rating), 1) + " out of 5";
        var isTour = subtype === "tours";
        var location = isTour ? poi.departureInfo + " to " + poi.returnInfo : this.place.name;
        var _c = Object(__WEBPACK_IMPORTED_MODULE_15__utils_getPartnerActivityPricing__["a" /* getPartnerActivityPricing */])(lpCurrency, poi.prices), regularPrice = _c.regularPrice, discountedPrice = _c.discountedPrice;
        var poiType = poi.activityType;
        var adTargeting = Object(__WEBPACK_IMPORTED_MODULE_14__utils_createAdTargeting__["a" /* createAdTargeting */])(Object.assign({}, dataLayer, { poiType: poiType }));
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_travel_agent_dist_helmet__["Helmet"], null,
                this.hasMedia && [
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { property: "og:image", content: poi.media.images[0] || "" }),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { className: "swiftype", name: "thumbnail", "data-type": "string", content: poi.media.images[0] || "" }),
                ],
                !this.hasMedia && this.hasImages && [
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { property: "og:image", content: poi.images[0].url || "" }),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { className: "swiftype", name: "thumbnail", "data-type": "string", content: poi.images[0].url || "" }),
                ],
                !this.hasMedia && !this.hasImages && [
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { property: "og:image", content: "" }),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { className: "swiftype", name: "thumbnail", "data-type": "string", content: "" }),
                ],
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { className: "swiftype", name: "op-parent-id", "data-type": "string", content: this.place.id }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { className: "swiftype", name: "op-parent-name", "data-type": "string", content: this.place.name }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { className: "swiftype", name: "op-subtype", "data-type": "string", content: subtype }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { className: "swiftype", name: "op-type-partner-activity", "data-type": "integer", content: "100" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { className: "swiftype", name: "top-choice", "data-type": "integer", content: "0" }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { className: "swiftype", name: "grade", "data-type": "float", content: "0" }),
                tags.map(function (tag) { return ([
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { className: "swiftype", name: "tag", "data-type": "string", content: tag.label }),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("meta", { className: "swiftype", name: tag.tag_type + "-id", "data-type": "enum", content: tag.tag_id })
                ]); })),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_containers_dataLayer__["a" /* default */], { data: {
                    cd26_PartnerOfferingDetails: poi.name,
                    cd27_PartnerOfferingKind: poi.activityType,
                    cd28_PartnerName: __WEBPACK_IMPORTED_MODULE_18__utils_partnerActivityProviders__["a" /* partnerActivityProviders */][poi.provider].name,
                    kind: poi.activityType === "tour" ? "tours" : "activities",
                    poiType: poiType,
                } }),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics__["DataLayerInitializationData"], { data: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics__["analytics"].contentCity] = poi.containingCityName,
                    _a[__WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics__["analytics"].contentContinent] = poi.containingContinentName,
                    _a[__WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics__["analytics"].contentCountry] = poi.containingCountryName,
                    _a[__WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics__["analytics"].contentNeighborhood] = poi.containingNeighborhoodName,
                    _a[__WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics__["analytics"].contentRegion] = poi.containingRegionNames && poi.containingRegionNames.join(", "),
                    _a[__WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics__["analytics"].destinationSubNav] = __WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics__["DestinationSubNavs"].activities,
                    _a[__WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics__["analytics"].poiName] = poi.name,
                    _a[__WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics__["analytics"].poiType] = poi.type,
                    _a), indexForEntirePayload: 1, scriptWrapperForEntirePayload: __WEBPACK_IMPORTED_MODULE_19__lonelyplanet_lp_analytics__["asyncUserStatusWrapper"] }),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__templates_detail__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "breadcrumbs" },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__shared_patterns_breadcrumbs__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_12__styles_pois_css__["breadcrumbs"], links: breadcrumbs })),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "header" },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__patterns_header__["a" /* default */], { title: poi.name, type: poi.canonicalCategory, location: location, bookmarked: bookmarked, onClickBookmark: onClickBookmark, isTour: isTour })),
                this.hasMedia &&
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "hero" },
                        poi.media.images.length === 1 &&
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__patterns_hero__["a" /* default */].Photo, { src: poi.media.images[0], alt: "", sizes: __WEBPACK_IMPORTED_MODULE_17__utils_heroImageSizes__["a" /* default */].single.main }),
                        poi.media.images.length > 1 &&
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__patterns_hero__["a" /* default */].Gallery, { images: poi.media.images })),
                !this.hasMedia && this.hasImages &&
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "hero" },
                        poi.images.length === 1 &&
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__patterns_hero__["a" /* default */].Photo, { src: poi.images[0].url, alt: "", sizes: __WEBPACK_IMPORTED_MODULE_17__utils_heroImageSizes__["a" /* default */].single.main }),
                        poi.images.length > 1 &&
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__patterns_hero__["a" /* default */].Gallery, { images: poi.images.map(function (image) { return image.url; }) })),
                this.hasMedia &&
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "heroAttribution" },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__patterns_hero__["a" /* default */].Attribution, { attributions: this.providerAttributions })),
                !this.hasMedia && this.hasMainImageAttributions &&
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "heroAttribution" },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__patterns_hero__["a" /* default */].Attribution, { attributions: poi.images[0].attribution })),
                this.hasDescription &&
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "descriptionPartner" },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */], null,
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */].Heading, null,
                                "Tour description provided by ",
                                this.provider[poi.provider]),
                            poi.descriptions.shortDescription &&
                                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */].Text, null,
                                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: poi.descriptions.shortDescription } })),
                            poi.descriptions.longDescription &&
                                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */].Text, null,
                                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: poi.descriptions.longDescription } })))),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "callToActionMobile" },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__patterns_booking__["a" /* default */].Activity, { activityName: poi.name, activityType: poi.activityType, price: regularPrice, discountedPrice: discountedPrice, url: poi.booking, provider: poi.provider, rating: activityRating })),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "callToActionAside" },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__patterns_booking__["a" /* default */].Activity, { activityName: poi.name, activityType: poi.activityType, price: regularPrice, discountedPrice: discountedPrice, url: poi.booking, provider: poi.provider, rating: activityRating })),
                this.hasEssentialInfo &&
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "infoEssential" },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__patterns_info__["a" /* default */], null,
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__patterns_info__["a" /* default */].Heading, null, "More info"),
                            poi.duration &&
                                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__patterns_info__["a" /* default */].Item, { label: "Duration" },
                                    poi.duration.duration,
                                    " ",
                                    poi.duration.unit),
                            poi.departureInfo &&
                                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__patterns_info__["a" /* default */].Item, { label: "Departs" }, poi.departureInfo),
                            poi.returnInfo &&
                                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__patterns_info__["a" /* default */].Item, { label: "Returns" }, poi.returnInfo))),
                tags && tags.length > 0 &&
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "activityTags" },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__patterns_tags__["a" /* default */], { data: tags })),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "adRail" },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_ad__["a" /* Ad */].Primary, null,
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_ad__["b" /* AdUnit */].SideRail, { adUnit: "poisRightRail", targeting: adTargeting }))),
                this.showActivityFeatures &&
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "activityFeatures" },
                        this.hasInclusions &&
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */], null,
                                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */].Heading, null, "What\u2019s included"),
                                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */].Text, null,
                                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("ul", null, poi.inclusions.map(function (item) { return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("li", { key: item }, item)); })))),
                        this.hasExclusions &&
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */], null,
                                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */].Heading, null, "What\u2019s not included"),
                                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */].Text, null,
                                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("ul", null, poi.exclusions.map(function (item) { return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("li", { key: item }, item)); })))),
                        this.hasHighlights &&
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */], null,
                                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */].Heading, null, "Highlights"),
                                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */].Text, null,
                                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("ul", null, poi.highlights.map(function (item) { return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("li", { key: item }, item)); }))))),
                this.hasItinerary &&
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "tourItinerary" },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */], null,
                            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */].Heading, null, "Itinerary"),
                            poi.itinerary.map(function (item) { return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__patterns_description__["a" /* default */].Text, null,
                                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("strong", null, item.title),
                                " ",
                                item.description)); }))),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_template__["a" /* default */].Position, { area: "adSuperzone" },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_ad__["a" /* Ad */].Bounded, null,
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_ad__["b" /* AdUnit */].Superzone, { adUnit: "poisSuperzone", targeting: adTargeting }))))));
    };
    return PagePartnerActivity;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PagePartnerActivity);


/***/ }),

/***/ "IUL9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__description__ = __webpack_require__("0Tsv");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__description__["a" /* default */]);


/***/ }),

/***/ "JBOk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("sTbe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__ = __webpack_require__("JHeX");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _a;


var initState = {
    bookmarkLists: {},
    bookmarks: {},
    isBookmarked: false,
    resources: {
        lodging: {},
        partner_activity: {},
        poi: {},
    },
};
var bookmarkReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["a" /* RECEIVED_BOOKMARK_LISTS */]] = {
        next: function (state, action) {
            var bookmarks = {};
            var _a = action.payload, bookmarkResponse = _a.bookmarkResponse, poiId = _a.poiId;
            var bookmarkLists = bookmarkResponse.lists
                // Filter out mobile "Favorite" lists (where source is set to "guides")
                .filter(function (_a) {
                var source = _a.source;
                return source !== "guides";
            })
                // Build new list and bookmarks objects
                .reduce(function (memo, list) {
                memo[list.id] = list;
                list.entries.reduce(function (m, entry) {
                    if (entry.checked) {
                        m[entry.id] = entry;
                    }
                    return m;
                }, bookmarks);
                return memo;
            }, {});
            // See if a bookmark exists for the page the user is on.
            var isBookmarked = getBookmarkStatus(bookmarks, poiId);
            return __assign({}, state, { bookmarkLists: bookmarkLists,
                bookmarks: bookmarks,
                isBookmarked: isBookmarked, resources: bookmarkResponse.resources });
        },
    },
    _a[__WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["d" /* RECEIVED_NEW_LIST_AND_BOOKMARK */]] = {
        next: function (state, action) {
            var _a = action.payload, newList = _a.newList, newBookmark = _a.newBookmark, poi = _a.poi;
            var bookmarkLists = __assign({}, state.bookmarkLists);
            var bookmarks = __assign({}, state.bookmarks);
            var resources = __assign({}, state.resources);
            bookmarkLists[newList.id] = newList;
            bookmarkLists[newList.id].entries.push(newBookmark);
            bookmarks[newBookmark.id] = newBookmark;
            resources[poi.type][poi.id] = poi;
            return __assign({}, state, { bookmarkLists: bookmarkLists,
                bookmarks: bookmarks, isBookmarked: true, resources: resources });
        },
    },
    _a[__WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["c" /* RECEIVED_NEW_BOOKMARK */]] = {
        next: function (state, action) {
            var _a = action.payload, listId = _a.listId, newBookmark = _a.newBookmark, poi = _a.poi;
            var bookmarkLists = __assign({}, state.bookmarkLists);
            var bookmarks = __assign({}, state.bookmarks);
            var resources = __assign({}, state.resources);
            bookmarkLists[listId].entries.push(newBookmark);
            bookmarks[newBookmark.id] = newBookmark;
            resources[poi.type][poi.id] = poi;
            return __assign({}, state, { bookmarkLists: bookmarkLists,
                bookmarks: bookmarks, isBookmarked: true, resources: resources });
        },
    },
    _a[__WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["e" /* RECEIVED_UPDATED_BOOKMARK */]] = {
        next: function (state, action) {
            var _a = action.payload, listId = _a.listId, poiId = _a.poiId, updatedBookmark = _a.updatedBookmark;
            var showBookmark = updatedBookmark.checked;
            var bookmarkLists = __assign({}, state.bookmarkLists);
            var bookmarks = __assign({}, state.bookmarks);
            var isBookmarked;
            var index = bookmarkLists[listId].entries.findIndex(function (entry) { return entry.id === updatedBookmark.id; });
            bookmarkLists[listId].entries.splice(index, 1);
            bookmarkLists[listId].entries.push(updatedBookmark);
            // Add/update bookmark in the list
            if (showBookmark) {
                bookmarks[updatedBookmark.id] = updatedBookmark;
                isBookmarked = true;
                // Remove bookmark from the list
            }
            else {
                delete bookmarks[updatedBookmark.id];
                isBookmarked = getBookmarkStatus(bookmarks, poiId);
            }
            return __assign({}, state, { bookmarkLists: bookmarkLists,
                bookmarks: bookmarks,
                isBookmarked: isBookmarked });
        },
    },
    _a), initState);
var getBookmarkStatus = function (bookmarks, poiId) {
    return Object.keys(bookmarks).some(function (bookmarkId) {
        var _a = bookmarks[bookmarkId], checked = _a.checked, target = _a.target;
        return checked && target.id === poiId;
    });
};
/* harmony default export */ __webpack_exports__["a"] = (bookmarkReducer);


/***/ }),

/***/ "JDoo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__ = __webpack_require__("UtEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_form_daterange__ = __webpack_require__("311Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_form_daterange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_form_daterange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_styles_colors__ = __webpack_require__("8LSk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_styles_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_dotLoader__ = __webpack_require__("VdRz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__booking__ = __webpack_require__("P8bB");








var BookingLodging = function (_a) {
    var dates = _a.dates, focusedInput = _a.focusedInput, handleDateChange = _a.handleDateChange, handleFocusChange = _a.handleFocusChange, loading = _a.loading, lodgingName = _a.lodgingName, price = _a.price, nights = _a.nights, url = _a.url, providerName = _a.providerName, providerType = _a.providerType, rating = _a.rating, unavailable = _a.unavailable;
    return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__booking__["a" /* default */], null,
        price ?
            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__booking__["a" /* default */].Price, { labelAfter: nights + " night" + (nights !== 1 ? "s" : "") }, price)
            :
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", null, loading && __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_dotLoader__["a" /* default */], { inline: true }) || __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_text__["Heading"], { level: 4, size: 7, weight: "regular" }, "Check Availability")),
        unavailable &&
            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_text__["Heading"], { level: 4, size: 8, weight: "medium", style: { color: __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_styles_colors___default.a.accentRed } }, "Unavailable at these dates.")),
        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_form_daterange___default.a, { id: "lodging-date-range", numberOfMonths: 1, startDatePlaceholderText: "Check-in", endDatePlaceholderText: "Check-out", soldOut: unavailable, startDate: dates && dates.startDate, endDate: dates && dates.endDate, onDatesChange: handleDateChange, onFocusChange: handleFocusChange, focusedInput: focusedInput, lastSelectableDate: __WEBPACK_IMPORTED_MODULE_5_moment__().add(16, "months") }),
        url &&
            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["AnalyticsEvent"], { render: function (_a) {
                    var track = _a.track;
                    return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__booking__["a" /* default */].Button, { href: url, onClick: function () {
                            var _a;
                            track((_a = {},
                                _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["analytics"].eventName] = __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["EventNames"].partnerClick,
                                _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["analytics"].bookingDepartureDate] = dates.startDate && dates.startDate.format("YYYYMMDD"),
                                _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["analytics"].bookingDestination] = lodgingName,
                                _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["analytics"].bookingPartner] = providerName,
                                _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["analytics"].bookingReturnDate] = dates.endDate && dates.endDate.format("YYYYMMDD"),
                                _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["analytics"].bookingType] = __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["BookingTypes"].hotel,
                                _a));
                            track({
                                /**
                                 * This is the legacy payload.
                                 * Remove once OK to do so.
                                 */
                                bookingProvider: providerType,
                                event: "lodging booking click",
                                "gtm.element": "Booking.Button",
                                "gtm.elementText": "Select your room",
                            });
                        } }, "Select your room"));
                } }),
        rating &&
            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__booking__["a" /* default */].Rating, null, rating),
        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__booking__["a" /* default */].Provider, { provider: providerType })));
};
/* harmony default export */ __webpack_exports__["a"] = (BookingLodging);


/***/ }),

/***/ "JHeX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVED_BOOKMARK_LISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECEIVED_NEW_LIST_AND_BOOKMARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECEIVED_NEW_BOOKMARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECEIVED_UPDATED_BOOKMARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RECEIVED_USER_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVED_NEARBY_POIS; });
var RECEIVED_BOOKMARK_LISTS = "RECEIVED_BOOKMARK_LISTS";
var RECEIVED_NEW_LIST_AND_BOOKMARK = "RECEIVED_NEW_LIST_AND_BOOKMARK";
var RECEIVED_NEW_BOOKMARK = "RECEIVED_NEW_BOOKMARK";
var RECEIVED_UPDATED_BOOKMARK = "RECEIVED_UPDATED_BOOKMARK";
var RECEIVED_USER_LOGIN = "RECEIVED_USER_LOGIN";
var RECEIVED_NEARBY_POIS = "RECEIVED_NEARBY_POIS";


/***/ }),

/***/ "Jben":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPartnerActivityPricing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__ = __webpack_require__("cRoh");

var getPartnerActivityPricing = function (userCurrency, prices) {
    var discountedPrice;
    var regularPrice;
    try {
        discountedPrice = __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].find(prices.discountedPrices, function (priceObject) { return priceObject.currency === userCurrency; }).formattedAmount;
    }
    catch (e) {
        discountedPrice = null;
    }
    try {
        regularPrice = __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].find(prices.regularPrices, function (priceObject) { return priceObject.currency === userCurrency; }).formattedAmount;
    }
    catch (e) {
        regularPrice = null;
    }
    return { discountedPrice: discountedPrice, regularPrice: regularPrice };
};


/***/ }),

/***/ "Jfyc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineOpTypes;
/**
 * Combines an arbitrary number of Open Planet types (strings)
 * into another string that can be used in conjunction with `SearchComponent`s
 * `fetchData` method.
 * @param {...string} types An arbitrary number of string (OP types) arguments
 * @returns {string} a string representation of the combined types to be used with SearchComponent
 */
function combineOpTypes() {
    var types = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        types[_i] = arguments[_i];
    }
    return types.join(",");
}


/***/ }),

/***/ "K49P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schemaBuilderReview__ = __webpack_require__("gyEG");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__schemaBuilderReview__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schemaDate__ = __webpack_require__("aadl");
/* unused harmony reexport schemaDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schemaDescription__ = __webpack_require__("xpuk");
/* unused harmony reexport schemaDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__schemaPlace__ = __webpack_require__("37xT");
/* unused harmony reexport schemaPlace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__schemaPrice__ = __webpack_require__("ec2S");
/* unused harmony reexport schemaPrice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__schemaPriceRange__ = __webpack_require__("gO5h");
/* unused harmony reexport schemaPriceRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__schemaType__ = __webpack_require__("qdOX");
/* unused harmony reexport schemaType */









/***/ }),

/***/ "KPtS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var diacritics = __webpack_require__("JmeQ");
var _ = __webpack_require__("M4fF");
var slugify = __webpack_require__("ORum");
var removeDiacritics = diacritics.remove;
exports.replaceApostrophes = function (str) { return (str || "").replace(/[’ʻʼ]/g, "-"); };
exports.stripAccents = function (str) {
    var reAccents = /[αàáâãäçəèéêëìíîi̇ïñòóôõöùúūûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎİÏÑÒÓÔÕÖÙÚÛÜÝЎʻʼ]/g;
    var replacements = "[aaaaaaceeeeeiiiiiinooooouuuuuyyAAAAACEEEEIIIIINOOOOOUUUUYY'']";
    return str.replace(reAccents, function (match) { return replacements[reAccents.source.indexOf(match)]; });
};
exports.cleanString = _.flow([
    exports.replaceApostrophes,
    _.kebabCase,
    exports.stripAccents,
    removeDiacritics,
    slugify,
]);


/***/ }),

/***/ "KReW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_button__ = __webpack_require__("z7/X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("meXs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);




var BookingButton = function (_a) {
    var children = _a.children, href = _a.href, onClick = _a.onClick, className = _a.className;
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["bookingButton"], className) },
        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_button___default.a, { customStyles: {
                paddingLeft: 0,
                paddingRight: 0,
            }, href: href, onClick: onClick, full: true, rounded: true, target: "_blank", rel: "noopener noreferrer" }, children)));
};
/* harmony default export */ __webpack_exports__["a"] = (BookingButton);


/***/ }),

/***/ "Kbyn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_travel_agent_dist_helmet__ = __webpack_require__("OH7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_travel_agent_dist_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_travel_agent_dist_helmet__);


var BaseMeta = function (_a) {
    var meta = _a.meta, poi = _a.poi, nearbyPois = _a.nearbyPois;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_travel_agent_dist_helmet__["Helmet"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, meta.title),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "title", content: meta.title }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: meta.description.truncated }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { property: "og:title", content: meta.title }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { property: "og:description", content: meta.description.truncated }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { className: "swiftype", name: "title", "data-type": "string", content: meta.title }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { className: "swiftype", name: "body", "data-type": "text", content: meta.description.full }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { className: "swiftype", name: "op-id", "data-type": "string", content: poi.id }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { className: "swiftype", name: "op-type", "data-type": "string", content: poi.type }),
        poi.alternative_names && (poi.alternative_names.map(function (alternativeName) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { key: alternativeName, className: "swiftype", name: "op-alternatives", "data-type": "string", content: alternativeName }));
        })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("link", { rel: "canonical", href: meta.canonical }),
        nearbyPois &&
            nearbyPois.mapMarkers && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("link", { rel: "stylesheet", href: "https://unpkg.com/leaflet@1.3.1/dist/leaflet.css", type: "text/css" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (BaseMeta);


/***/ }),

/***/ "KlaN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookmarkModalAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("Xem7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var BookmarkModalAction = function (_a) {
    var children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b, className = _a.className, rest = __rest(_a, ["children", "disabled", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["bookmarkModalAction"], disabled && __WEBPACK_IMPORTED_MODULE_2__styles_css__["bookmarkModalActionDisabled"], className) }, rest), children));
};


/***/ }),

/***/ "Kx1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consumer__ = __webpack_require__("4pXv");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__consumer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__provider__ = __webpack_require__("m2mg");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__provider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__providers_gtm__ = __webpack_require__("QmVb");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__providers_gtm__["a"]; });





/***/ }),

/***/ "LOUu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"divider":"styles__divider___6PyL7"};

/***/ }),

/***/ "LROA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"photoGallery":"styles__photoGallery___3XRcU"};

/***/ }),

/***/ "LlzR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("Fi1p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);



var Ad = function (_a) {
    var children = _a.children, id = _a.id, className = _a.className, style = _a.style;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id, className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["ad"], className), style: style },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["adLabel"] }, "Advertisement"),
        children));
};
/* harmony default export */ __webpack_exports__["a"] = (Ad);


/***/ }),

/***/ "Lxu2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_photoswipe__ = __webpack_require__("j7jv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_photoswipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_photoswipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("LROA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);



var PhotoGallery = function (_a) {
    var items = _a.items, options = _a.options, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, onClose = _a.onClose;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_photoswipe__["PhotoSwipe"], { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["photoGallery"], isOpen: isOpen, items: items, options: Object.assign({}, options, {
            counterEl: false,
            fullscreenEl: false,
            history: false,
            preloaderEl: false,
            shareEl: false,
            timeToIdle: 0,
            timeToIdleOutside: 0,
            zoomEl: false,
        }), onClose: onClose }));
};
/* harmony default export */ __webpack_exports__["a"] = (PhotoGallery);


/***/ }),

/***/ "M0Qt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatAddressExtras; });
var formatAddressExtras = function (addressExtras) {
    if (typeof addressExtras !== "string") {
        return addressExtras.map(function (item) { return ({
            label: "",
            text: item,
        }); });
    }
    var extras = addressExtras.split("; ").map(function (item) {
        var itemKeyLength = item.indexOf(":") + 1;
        if (itemKeyLength === 0) {
            return {
                label: "",
                text: item,
            };
        }
        var itemKey = item.slice(0, itemKeyLength).replace(":", "");
        var itemValue = item.slice(itemKeyLength + 1);
        return {
            label: itemKey,
            text: itemValue,
        };
    });
    return extras;
};


/***/ }),

/***/ "M5T4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonBookmark; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__ = __webpack_require__("AemK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_gtm__ = __webpack_require__("Meto");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buttonOutline__ = __webpack_require__("jY5B");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};





var ButtonBookmark = function (_a) {
    var _b = _a.bookmarked, bookmarked = _b === void 0 ? false : _b, className = _a.className, onClick = _a.onClick, rest = __rest(_a, ["bookmarked", "className", "onClick"]);
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__buttonOutline__["a" /* ButtonOutline */], __assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames__(Object(__WEBPACK_IMPORTED_MODULE_3__utils_gtm__["a" /* bookmarkButtonGtmClasses */])(bookmarked), className), onClick: onClick }, rest),
        bookmarked ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__["BookmarkActive"], null) : __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__["Bookmark"], null),
        "Save"));
};


/***/ }),

/***/ "Mb82":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reimgix__ = __webpack_require__("gvHC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reimgix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reimgix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lonelyplanet_lp_analytics__ = __webpack_require__("UtEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lonelyplanet_lp_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_lp_analytics__);



var Reimgix = typeof __WEBPACK_IMPORTED_MODULE_1_reimgix__ === "object" ? __WEBPACK_IMPORTED_MODULE_1_reimgix__["default"] : __WEBPACK_IMPORTED_MODULE_1_reimgix__;
var Image = function (_a) {
    var src = _a.src, width = _a.width, height = _a.height, alt = _a.alt, className = _a.className;
    var _b;
    var inBrowser = typeof window !== "undefined";
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_lp_analytics__["DataLayerInitializationData"], { data: (_b = {}, _b[__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_lp_analytics__["analytics"].hasPhoto] = true, _b), indexForEntirePayload: 1, scriptWrapperForEntirePayload: __WEBPACK_IMPORTED_MODULE_2__lonelyplanet_lp_analytics__["asyncUserStatusWrapper"] }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Reimgix, { lqipParams: {
                blur: "200",
                px: 0,
            }, params: {
                fit: "crop",
                h: height,
                w: width,
            }, src: src }, function (_a) {
            var image = _a.src;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: className, src: image, alt: alt || "" }));
        })));
};
/* harmony default export */ __webpack_exports__["a"] = (Image);


/***/ }),

/***/ "Meto":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bookmarkButtonGtmClasses;
/**
 * Return gtm classes for bookmark button
 * @param  {Bool} is poi already marked
 * @return {String}        Class names
 */
function bookmarkButtonGtmClasses(marked) {
    var gtmClass = "js-gtm-bookmark-button";
    return gtmClass + " " + (gtmClass + (marked ? "-remove" : "-add"));
}


/***/ }),

/***/ "N1Pn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_text__ = __webpack_require__("s7mA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("Fvjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var DescriptionText = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__shared_components_text__["a" /* default */].ArticleSmall, __assign({ className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["descriptionText"] }, rest), children));
};
/* harmony default export */ __webpack_exports__["a"] = (DescriptionText);


/***/ }),

/***/ "N28R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_text__ = __webpack_require__("s7mA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("meXs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);




var BookingPrice = function (_a) {
    var children = _a.children, labelBefore = _a.labelBefore, labelAfter = _a.labelAfter, className = _a.className, originalPrice = _a.originalPrice;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["bookingPrice"], className) },
        labelBefore &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["bookingPriceLabel"], __WEBPACK_IMPORTED_MODULE_3__styles_css__["bookingPriceLabelBefore"]) }, labelBefore),
        originalPrice &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["bookingPriceAmount"], __WEBPACK_IMPORTED_MODULE_3__styles_css__["bookingOriginalPriceAmount"]) }, originalPrice),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_components_text__["a" /* default */].AccentRed, { className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["bookingPriceAmount"] }, children),
        labelAfter &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["bookingPriceLabel"], __WEBPACK_IMPORTED_MODULE_3__styles_css__["bookingPriceLabelAfter"]) }, labelAfter)));
};
/* harmony default export */ __webpack_exports__["a"] = (BookingPrice);


/***/ }),

/***/ "NIkM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wireframe":"styles__wireframe___1MlN-","wireframeAnimate":"styles__wireframeAnimate___1uVS0","pulse":"styles__pulse___359Ys","shape":"styles__shape___RWv4Q"};

/***/ }),

/***/ "NpMb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__link__ = __webpack_require__("mFZ8");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__link__; });




/***/ }),

/***/ "OitI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stripHtml;
/**
 * Remove HTML code from a string
 * @param  {String} html Formatted HTML code
 * @return {String}      Plain text
 */
function stripHtml(html) {
    return html.replace(/(<([^>]+)>)/ig, "");
}


/***/ }),

/***/ "OxjI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var openPlanetTypes_1 = __webpack_require__("Jg0a");
var pathToRegexp = __webpack_require__("Ygqm");
var lodging_1 = __webpack_require__("wU4d");
var partnerActivity_1 = __webpack_require__("Uj3B");
var poi_1 = __webpack_require__("taxX");
var lists_1 = __webpack_require__("V4Vm");
var UrlCreator = /** @class */ (function () {
    function UrlCreator() {
        this.urlTypes = new Map();
    }
    UrlCreator.prototype.registerType = function (type, generator) {
        this.urlTypes.set(type, generator);
    };
    UrlCreator.prototype.create = function (model) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var generator = this.urlTypes.get(model.type);
        return generator.generate(model, args);
    };
    UrlCreator.prototype.createList = function (model) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var generator = this.urlTypes.get("list");
        return generator.generate(model, args);
    };
    return UrlCreator;
}());
exports.UrlCreator = UrlCreator;
var creator = new UrlCreator();
creator.registerType(openPlanetTypes_1.poi, new poi_1.PoiUrlGenerator(pathToRegexp.compile));
creator.registerType(openPlanetTypes_1.partnerActivity, new partnerActivity_1.PartnerActivityUrlGenerator(pathToRegexp.compile));
creator.registerType(openPlanetTypes_1.lodging, new lodging_1.LodgingUrlGenerator(pathToRegexp.compile));
creator.registerType("list", new lists_1.PoiListUrlGenerator(pathToRegexp.compile));
exports.Urls = creator;


/***/ }),

/***/ "P8bB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_panel__ = __webpack_require__("35nR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__availabilityFetcher__ = __webpack_require__("zN4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bookingActivity__ = __webpack_require__("eF97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bookingButton__ = __webpack_require__("KReW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bookingLodging__ = __webpack_require__("JDoo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bookingPrice__ = __webpack_require__("N28R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bookingProvider__ = __webpack_require__("BK2A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bookingRating__ = __webpack_require__("Wni0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css__ = __webpack_require__("meXs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_css__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











var Booking = /** @class */ (function (_super) {
    __extends(Booking, _super);
    function Booking() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Booking.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_components_panel__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_10__styles_css__["booking"], className) }, children));
    };
    Booking.Activity = __WEBPACK_IMPORTED_MODULE_4__bookingActivity__["a" /* default */];
    Booking.Button = __WEBPACK_IMPORTED_MODULE_5__bookingButton__["a" /* default */];
    Booking.Lodging = __WEBPACK_IMPORTED_MODULE_6__bookingLodging__["a" /* default */];
    Booking.Price = __WEBPACK_IMPORTED_MODULE_7__bookingPrice__["a" /* default */];
    Booking.Provider = __WEBPACK_IMPORTED_MODULE_8__bookingProvider__["a" /* default */];
    Booking.Rating = __WEBPACK_IMPORTED_MODULE_9__bookingRating__["a" /* default */];
    Booking.AvailabilityFetcher = __WEBPACK_IMPORTED_MODULE_3__availabilityFetcher__["a" /* default */];
    return Booking;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Booking);


/***/ }),

/***/ "Pjik":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template__ = __webpack_require__("myoS");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__template__["a" /* default */]);


/***/ }),

/***/ "PqV5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_analytics__ = __webpack_require__("Kx1W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_routing_dist_create__ = __webpack_require__("OxjI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_routing_dist_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_routing_dist_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_button__ = __webpack_require__("z7/X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_moreLink__ = __webpack_require__("UMFO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_moreLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_moreLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__("+xkD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var Activities = function (_a) {
    var data = _a.data, _b = _a.buttonColor, buttonColor = _b === void 0 ? "blue" : _b, parentActivityName = _a.parentActivityName, _c = _a.url, url = _c === void 0 ? "#" : _c, placeId = _a.placeId, containingPlaces = _a.containingPlaces;
    return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_analytics__["a" /* AnalyticsEvent */], { render: function (track) { return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"], null,
            data.map(function (activity, index) { return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"], { key: activity.name },
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__styles_css__["activity"] },
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__styles_css__["activityName"] }, activity.name),
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__styles_css__["activityPrice"] },
                        activity.pricing.regularPrice.formattedAmount,
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("br", null),
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_5__styles_css__["activityPriceLabel"] }, "and up")),
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__styles_css__["activityButton"] },
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_button___default.a, { href: __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_routing_dist_create__["Urls"].create(__assign({}, activity, { containingPlaceId: placeId, containingPlaces: containingPlaces })), size: "tiny", color: buttonColor, border: true, rounded: true, target: "_blank", onClick: function (e) {
                                track({
                                    bookingName: activity.name,
                                    bookingProvider: "viator",
                                    event: "partner click",
                                    "gtm.element": "activities-button-" + index,
                                });
                            } }, "Details"))))); }),
            url && (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__styles_css__["moreLink"] },
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_moreLink___default.a, { href: url, size: "small", caps: true, rel: "noopener noreferrer", target: "_blank", onClick: function () {
                        track({
                            bookingProvider: "viator",
                            event: "partner click",
                            "gtm.element": "moretickets",
                            "gtm.elementText": "More tickets &amp; tours",
                        });
                    } }, "More tickets & tours"))))); } }));
};
/* harmony default export */ __webpack_exports__["a"] = (Activities);


/***/ }),

/***/ "PtTN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"map":"styles__map___3gA-W","mapStatic":"styles__mapStatic___2xhxW","mapInteractive":"styles__mapInteractive___1Odoc","mapMarkerCenter":"styles__mapMarkerCenter___2zoy8","mapMarker":"styles__mapMarker___3A2QS","mapMarkerBlue":"styles__mapMarkerBlue___16Isl","mapMarkerGray":"styles__mapMarkerGray___3ClxC","mapMarkerGreen":"styles__mapMarkerGreen___2Fyta","mapMarkerOrange":"styles__mapMarkerOrange___1Otqa","mapMarkerPink":"styles__mapMarkerPink___3SuEU","mapMarkerPurple":"styles__mapMarkerPurple___1zCje","mapMarkerRed":"styles__mapMarkerRed___7uq1o","mapMarkerYellow":"styles__mapMarkerYellow___1cXWr"};

/***/ }),

/***/ "QmVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleTagManager; });
var GoogleTagManager = /** @class */ (function () {
    function GoogleTagManager() {
    }
    GoogleTagManager.prototype.send = function (data) {
        if (typeof window !== "undefined") {
            window.lp.analytics.dataLayer.push(data);
        }
    };
    return GoogleTagManager;
}());



/***/ }),

/***/ "R9i6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapStatic__ = __webpack_require__("z5qS");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Static", function() { return __WEBPACK_IMPORTED_MODULE_0__mapStatic__["a"]; });



/***/ }),

/***/ "RF4c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authDefaults = {
  host: "https://connect.lonelyplanet.com",
  options: {
    clientId: "foymu5r6sscxe",
    scope: ["openid"]
  }
};

/***/ }),

/***/ "RkVG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("NIkM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);



var ListItemWireframe = function (_a) {
    var className = _a.className, animate = _a.animate;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["wireframe"], animate && __WEBPACK_IMPORTED_MODULE_2__styles_css__["wireframeAnimate"], className), viewBox: "0 0 740 104", xmlns: "http://www.w3.org/2000/svg", version: "1.1" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("rect", { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["shape"], x: "0", y: "0", width: "520", height: "8" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("rect", { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["shape"], x: "0", y: "20", width: "520", height: "8" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("rect", { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["shape"], x: "0", y: "40", width: "340", height: "8" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("rect", { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["shape"], x: "570", y: "0", width: "170", height: "104" })));
};
/* harmony default export */ __webpack_exports__["a"] = (ListItemWireframe);


/***/ }),

/***/ "RoZr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"hero":"styles__hero___36Mq-","heroPhoto":"styles__heroPhoto___11UU0","heroGallery":"styles__heroGallery___1VqME","heroAttribution":"styles__heroAttribution___1EtYK","heroGalleryPhoto":"styles__heroGalleryPhoto___bFbI0","heroGalleryButton":"styles__heroGalleryButton___2Bv0-","heroGalleryButtonIcon":"styles__heroGalleryButtonIcon___2JIgg"};

/***/ }),

/***/ "RrWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reimgix__ = __webpack_require__("gvHC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reimgix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reimgix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("vrsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);




// Something is up with how they export this thing...
var Reimgix = typeof __WEBPACK_IMPORTED_MODULE_2_reimgix__ === "object" ? __WEBPACK_IMPORTED_MODULE_2_reimgix__["default"] : __WEBPACK_IMPORTED_MODULE_2_reimgix__;
var ListItemImage = function (_a) {
    var src = _a.src, width = _a.width, height = _a.height, alt = _a.alt, className = _a.className;
    var inBrowser = typeof window !== "undefined";
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Reimgix, { lqipParams: {
            blur: "200",
            px: 0,
        }, params: {
            fit: "crop",
            h: height,
            w: width,
        }, src: src }, function (_a) {
        var image = _a.src;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["listItemImage"], className), src: image, alt: alt || "" }));
    }));
};
/* harmony default export */ __webpack_exports__["a"] = (ListItemImage);


/***/ }),

/***/ "Rutb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_analytics__ = __webpack_require__("Kx1W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_icon__ = __webpack_require__("AemK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_photoGallery__ = __webpack_require__("k6Fy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_portal__ = __webpack_require__("Uasl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_heroImageSizes__ = __webpack_require__("kcVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hero__ = __webpack_require__("+ANR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css__ = __webpack_require__("RoZr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_css__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};









var HeroGallery = /** @class */ (function (_super) {
    __extends(HeroGallery, _super);
    function HeroGallery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
        };
        _this.onClick = function () {
            _this.setState({
                isOpen: !_this.state.isOpen,
            });
        };
        return _this;
    }
    HeroGallery.prototype.render = function () {
        var _this = this;
        var _a = this.props, images = _a.images, _b = _a.imageSize, imageSize = _b === void 0 ? { height: 768, width: 1024 } : _b, className = _a.className, rest = __rest(_a, ["images", "imageSize", "className"]);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__(__WEBPACK_IMPORTED_MODULE_8__styles_css__["heroGallery"], className) }, rest),
            images.slice(0, 3).map(function (image, index) {
                if (index === 0) {
                    return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_8__styles_css__["heroGalleryPhoto"], key: image },
                        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__hero__["a" /* default */].Photo, { key: image, src: image, sizes: __WEBPACK_IMPORTED_MODULE_6__utils_heroImageSizes__["a" /* default */].gallery.main })));
                }
                return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_8__styles_css__["heroGalleryPhoto"], key: image },
                    __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__hero__["a" /* default */].Photo, { key: image, src: image, sizes: __WEBPACK_IMPORTED_MODULE_6__utils_heroImageSizes__["a" /* default */].gallery.thumbnail })));
            }),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_analytics__["a" /* AnalyticsEvent */], { render: function (track) { return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("button", { className: __WEBPACK_IMPORTED_MODULE_8__styles_css__["heroGalleryButton"], onClick: function (e) {
                        track({
                            event: "hero gallery see all click",
                            "gtm.element": "HeroGallery",
                            "gtm.elementText": "See all " + images.length,
                        });
                        _this.onClick();
                    } },
                    __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_icon__["Camera"], { className: __WEBPACK_IMPORTED_MODULE_8__styles_css__["heroGalleryButtonIcon"] }),
                    "See all ",
                    images.length)); } }),
            this.state.isOpen && (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__shared_components_portal__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__shared_components_photoGallery__["a" /* default */], { items: __WEBPACK_IMPORTED_MODULE_7__hero__["a" /* default */].mapImagesForPhotoGallery(images, imageSize), isOpen: this.state.isOpen, options: {}, onClose: this.onClick })))));
    };
    return HeroGallery;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (HeroGallery);


/***/ }),

/***/ "Rx5D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_categoryLabelLink__ = __webpack_require__("gOyc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_categoryLabelLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_categoryLabelLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_imageSizes__ = __webpack_require__("qtSn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_removeHTML__ = __webpack_require__("6tpt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__listItemImage__ = __webpack_require__("RrWA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_css__ = __webpack_require__("j3JE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var createMarkup = function (markup) {
    return { __html: markup };
};
var ListItem = function (_a) {
    var category = _a.category, categoryLink = _a.categoryLink, description = _a.description, link = _a.link, thumbnail = _a.thumbnail, title = _a.title, type = _a.type, className = _a.className, onClick = _a.onClick;
    return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("article", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__(__WEBPACK_IMPORTED_MODULE_7__styles_css__["ListItem"], className) },
        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7__styles_css__["textContainer"] },
            category && (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7__styles_css__["category"] },
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_categoryLabelLink___default.a, { href: categoryLink, tabIndex: -1, onClick: onClick }, category))),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("a", { className: __WEBPACK_IMPORTED_MODULE_7__styles_css__["textAnchor"], href: link, onClick: onClick },
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_text__["Heading"], { className: __WEBPACK_IMPORTED_MODULE_7__styles_css__["heading"], level: 3, size: 7, weight: "medium", style: {
                        color: "currentColor",
                    } }, Object(__WEBPACK_IMPORTED_MODULE_5__utils_removeHTML__["a" /* default */])(title)),
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("p", { className: __WEBPACK_IMPORTED_MODULE_7__styles_css__["description"], dangerouslySetInnerHTML: createMarkup(description) }))),
        thumbnail && (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7__styles_css__["thumbnail"] },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("a", { className: __WEBPACK_IMPORTED_MODULE_7__styles_css__["thumbnailAnchor"], href: link, tabIndex: -1, onClick: onClick },
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__listItemImage__["a" /* default */], __assign({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__(type === "thorntree" && __WEBPACK_IMPORTED_MODULE_7__styles_css__["imageRounded"]), src: thumbnail }, __WEBPACK_IMPORTED_MODULE_4__utils_imageSizes__["a" /* default */][type])))))));
};
/* harmony default export */ __webpack_exports__["a"] = (ListItem);


/***/ }),

/***/ "SLLz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"info":"styles__info___1HC4J","infoItem":"styles__infoItem___72gXC","infoItemLabel":"styles__infoItemLabel___2siRm","infoMap":"styles__infoMap___T8zc3"};

/***/ }),

/***/ "SUMG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"inline":"styles__inline___3lKAX","dot":"styles__dot___3J2mU","bookingLoaderFade":"styles__bookingLoaderFade___PiOu1","second":"styles__second___1CMkl","third":"styles__third___3HPpY"};

/***/ }),

/***/ "SZH8":
/***/ (function(module, exports) {

/* tslint:disable:no-bitwise */
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, "includes", {
        value: function (searchElement, fromIndex) {
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            // 1. Let O be ? ToObject(this value).
            var o = Object(this);
            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;
            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }
            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;
            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
            function sameValueZero(x, y) {
                return x === y || (typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y));
            }
            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(searchElement, elementK) is true, return true.
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }
                // c. Increase k by 1.
                k++;
            }
            // 8. Return false
            return false;
        }
    });
}


/***/ }),

/***/ "TDU2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"template":"styles__template___2e06H","templateArea":"styles__templateArea___18YNy","templateAreaLeftRail":"styles__templateAreaLeftRail___Afizb","templateAreaLeftRailModule":"styles__templateAreaLeftRailModule___3o_S1","templateAreaRightRail":"styles__templateAreaRightRail___1Lfuu","templateAreaBreadcrumbs":"styles__templateAreaBreadcrumbs___lgfux","templateAreaHeader":"styles__templateAreaHeader___3b0uJ","templateAreaHero":"styles__templateAreaHero___iT4_-","templateAreaHeroSubGrid":"styles__templateAreaHeroSubGrid___1gvvR","templateAreaHeroAttribution":"styles__templateAreaHeroAttribution___3FbXO","templateAreaCallToActionMobile":"styles__templateAreaCallToActionMobile___27YqD","templateAreaArticle":"styles__templateAreaArticle___21drH","templateAreaRightRailModule":"styles__templateAreaRightRailModule___2UnjT","templateAreaRightRailModulePadded":"styles__templateAreaRightRailModulePadded___3LGIQ","templateAreaRightRailDivider":"styles__templateAreaRightRailDivider___25x_m","templateAreaCallToActionAside":"styles__templateAreaCallToActionAside___1bXBH","templateAreaCallToActionAsideDesktopOnly":"styles__templateAreaCallToActionAsideDesktopOnly___2VroH","templateAreaAdRail":"styles__templateAreaAdRail___SPI4E","templateAreaMap":"styles__templateAreaMap___3AF07","templateAreaRelatedTour":"styles__templateAreaRelatedTour___2i9hq","templateAreaRelatedHotels":"styles__templateAreaRelatedHotels___Dru1y","templateAreaAdSuperzone":"styles__templateAreaAdSuperzone___3K8gN"};

/***/ }),

/***/ "TGOE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_containers_dataLayer__ = __webpack_require__("sxtG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_routing_dist_details_constants__ = __webpack_require__("uuxV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_routing_dist_details_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_routing_dist_details_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lonelyplanet_travel_agent_dist_helmet__ = __webpack_require__("OH7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lonelyplanet_travel_agent_dist_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_travel_agent_dist_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ad__ = __webpack_require__("W0rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_template__ = __webpack_require__("Pjik");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_text__ = __webpack_require__("s7mA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_patterns_breadcrumbs__ = __webpack_require__("8SFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_map_mapInteractiveAsync__ = __webpack_require__("tgVK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_suggestEdit__ = __webpack_require__("C+Uo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_multiLine__ = __webpack_require__("BuJs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__patterns_activities__ = __webpack_require__("PqV5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__patterns_booking__ = __webpack_require__("juIJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__patterns_description__ = __webpack_require__("IUL9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__patterns_header__ = __webpack_require__("dieY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__patterns_hero__ = __webpack_require__("D6q0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__patterns_info__ = __webpack_require__("kx1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__patterns_review__ = __webpack_require__("CUEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_pois_css__ = __webpack_require__("YLLQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_pois_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_pois_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__templates_detail__ = __webpack_require__("tpip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_createAdTargeting__ = __webpack_require__("5HWx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_formatAddressExtras__ = __webpack_require__("M0Qt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_getDistanceToCityCenter__ = __webpack_require__("YAHl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_providerLinkBuilder__ = __webpack_require__("Virx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_cleanPartnerDescriptions__ = __webpack_require__("XxNa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_heroImageSizes__ = __webpack_require__("kcVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_hotelProvider__ = __webpack_require__("mRgh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_lodgingFacilities__ = __webpack_require__("o6zn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_sortMainImagesToFront__ = __webpack_require__("wCv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_filterSmallImages__ = __webpack_require__("3QpJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__ = __webpack_require__("UtEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

































var PageLodging = /** @class */ (function (_super) {
    __extends(PageLodging, _super);
    function PageLodging() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isTopChoice = _this.props.poi.attributes &&
            _this.props.poi.attributes.length &&
            _this.props.poi.attributes[0].name === "top_choice";
        _this.hasProviders = _this.props.poi.providers &&
            PageLodging.hasLength(_this.props.poi.providers);
        _this.hasPartnerDescription = _this.hasProviders &&
            _this.props.poi.providers[0].description &&
            PageLodging.hasLength(_this.props.poi.providers[0].description);
        _this.hasFacilities = _this.hasProviders &&
            _this.props.poi.providers[0].facilities &&
            PageLodging.hasLength(_this.props.poi.providers[0].facilities);
        _this.hasImages = _this.props.poi.images &&
            PageLodging.hasLength(_this.props.poi.images);
        _this.hasMainImageAttributions = _this.hasImages &&
            Array.isArray(_this.props.poi.images[0].attribution) &&
            PageLodging.hasLength(_this.props.poi.images[0].attribution);
        _this.hasActivities = _this.props.related &&
            PageLodging.hasLength(_this.props.related);
        _this.provider = Object(__WEBPACK_IMPORTED_MODULE_27__utils_hotelProvider__["a" /* default */])(_this.props.poi.providers);
        _this.hasNearbyPlaces = function () { return _this.props.nearbyMapMarkers && PageLodging.hasLength(_this.props.nearbyMapMarkers); };
        return _this;
    }
    PageLodging.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, breadcrumbs = _b.breadcrumbs, poi = _b.poi, places = _b.places, activities = _b.related, isDOM = _b.isDOM, dataLayer = _b.dataLayer, location = _b.location, bookmarked = _b.bookmarked, onClickBookmark = _b.onClickBookmark, match = _b.match, related = _b.related;
        var subtype = __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_routing_dist_details_constants__["poiTypes"][poi.poiType.toLowerCase()].displayName;
        var metaImage = this.hasImages ? poi.images[0].url : "";
        var poiAtlas = poi.poi;
        var moreTourLink = related.length > 0 && Object(__WEBPACK_IMPORTED_MODULE_24__utils_providerLinkBuilder__["b" /* viatorMoreLink */])(__assign({}, related[0], {
            containingPlaceId: match.params.placeId,
            containingPlaces: poi.containingPlaces,
        }));
        var cleanDescriptions = this.hasPartnerDescription
            ? Object(__WEBPACK_IMPORTED_MODULE_25__utils_cleanPartnerDescriptions__["a" /* cleanPartnerDescriptions */])(this.provider.type, this.provider.data.description)
            : [];
        /**
         * If this lodging has images, in order:
         * 1.) Filter out small, pixelated images.
         * 2.) Move images that
         *   a.) have tags, and
         *   b.) among them, have the "main" tag
         *   to the front.
         */
        var filteredImages = this.hasImages &&
            Object(__WEBPACK_IMPORTED_MODULE_29__utils_sortMainImagesToFront__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_30__utils_filterSmallImages__["a" /* default */])(poi.images));
        var adTargeting = Object(__WEBPACK_IMPORTED_MODULE_21__utils_createAdTargeting__["a" /* createAdTargeting */])(dataLayer);
        return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_travel_agent_dist_helmet__["Helmet"], null,
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("meta", { property: "og:image", content: metaImage }),
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("meta", { className: "swiftype", name: "op-parent-id", "data-type": "string", content: poi.containingCityId }),
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("meta", { className: "swiftype", name: "op-parent-name", "data-type": "string", content: poi.containingCityName }),
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("meta", { className: "swiftype", name: "op-subtype", "data-type": "string", content: subtype }),
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("meta", { className: "swiftype", name: "op-type-lodging", "data-type": "integer", content: "100" }),
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("meta", { className: "swiftype", name: "top-choice", "data-type": "integer", content: this.isTopChoice ? "1" : "0" }),
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("meta", { className: "swiftype", name: "grade", "data-type": "float", content: (poi.lpInternalScore && poi.lpInternalScore.toString()) || "0" }),
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("meta", { className: "swiftype", name: "thumbnail", "data-type": "string", content: metaImage })),
            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_containers_dataLayer__["a" /* default */], { data: {
                    cd26_PartnerOfferingDetails: poi.name,
                    cd27_PartnerOfferingKind: subtype,
                    cd28_PartnerName: this.provider && this.provider.name,
                    kind: subtype,
                    subtypes: poi.subtypes.join(", "),
                } }),
            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__["DataLayerInitializationData"], { data: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__["analytics"].atlasId] = poiAtlas && poiAtlas.id,
                    _a[__WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__["analytics"].contentCity] = poi.containingCityName,
                    _a[__WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__["analytics"].contentContinent] = poi.containingContinentName,
                    _a[__WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__["analytics"].contentCountry] = poi.containingCountryName,
                    _a[__WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__["analytics"].contentNeighborhood] = poi.containingNeighborhoodName,
                    _a[__WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__["analytics"].contentRegion] = poi.containingRegionNames && poi.containingRegionNames.join(", "),
                    _a[__WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__["analytics"].destinationSubNav] = __WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__["DestinationSubNavs"].hotels,
                    _a[__WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__["analytics"].poiAttributes] = poiAtlas &&
                        poiAtlas.poiAttributes &&
                        poiAtlas.poiAttributes.map(function (_a) {
                            var category = _a.category, name = _a.name;
                            return "{ " + category + ": " + name + " }";
                        }).join(", "),
                    _a[__WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__["analytics"].poiName] = poi.name,
                    _a[__WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__["analytics"].poiType] = poi.type,
                    _a), indexForEntirePayload: 1, scriptWrapperForEntirePayload: __WEBPACK_IMPORTED_MODULE_31__lonelyplanet_lp_analytics__["asyncUserStatusWrapper"] }),
            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__templates_detail__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "breadcrumbs" },
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_patterns_breadcrumbs__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_19__styles_pois_css__["breadcrumbs"], links: breadcrumbs })),
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "header" },
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__patterns_header__["a" /* default */], { title: poi.name, type: poi.subtypes[0], location: poi.containingPlaceName, topChoice: this.isTopChoice, bookmarked: bookmarked, onClickBookmark: onClickBookmark })),
                this.hasImages &&
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "hero" },
                        filteredImages.length === 1 &&
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__patterns_hero__["a" /* default */].Photo, { src: filteredImages[0].url, sizes: __WEBPACK_IMPORTED_MODULE_26__utils_heroImageSizes__["a" /* default */].single.main }),
                        filteredImages.length > 1 &&
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__patterns_hero__["a" /* default */].Gallery, { images: filteredImages.map(function (image) { return image.url; }), imageSize: {
                                    height: 460,
                                    width: 840,
                                } })),
                this.hasMainImageAttributions &&
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "heroAttribution" },
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__patterns_hero__["a" /* default */].Attribution, { attributions: filteredImages[0].attribution })),
                poi.review && poi.review.essential &&
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "reviewEssential" },
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__patterns_review__["a" /* default */].Essential, null,
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__shared_components_text__["a" /* default */].Html, null, poi.review.essential))),
                poi.review && poi.review.extension &&
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "reviewExtension" },
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__patterns_review__["a" /* default */].Extension, null,
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__shared_components_text__["a" /* default */].Html, null, poi.review.extension))),
                (poiAtlas &&
                    poiAtlas.location &&
                    poiAtlas.location.coordinates &&
                    poiAtlas.location.coordinates.length) &&
                    this.hasNearbyPlaces() &&
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "map" }, isDOM &&
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_map_mapInteractiveAsync__["a" /* MapInteractiveAsync */], { center: {
                                coordinates: poiAtlas.location.coordinates.slice(0).reverse(),
                                name: poi.name,
                            }, markers: this.props.nearbyMapMarkers })),
                this.hasPartnerDescription &&
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "descriptionPartner" }, cleanDescriptions.map(function (item, index) { return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__patterns_description__["a" /* default */], { key: item.title },
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__patterns_description__["a" /* default */].Heading, null,
                            item.title,
                            " ",
                            index === 0 && __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("a", { href: Object(__WEBPACK_IMPORTED_MODULE_24__utils_providerLinkBuilder__["a" /* getProviderUrl */])({}, __assign({}, _this.provider.data)), target: "_blank", rel: "noopener" },
                                "via ",
                                _this.provider.name)),
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__patterns_description__["a" /* default */].Text, null,
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_multiLine__["a" /* default */], { text: item.text })))); })),
                this.hasFacilities &&
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "activityFeatures" },
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__patterns_description__["a" /* default */], null,
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__patterns_description__["a" /* default */].Heading, null,
                                "Features of ",
                                poi.name),
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__patterns_description__["a" /* default */].Columns, null, Object(__WEBPACK_IMPORTED_MODULE_28__utils_lodgingFacilities__["a" /* default */])(this.provider.data.facilities).map(function (group) { return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__patterns_description__["a" /* default */].Column, { key: group.title },
                                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__patterns_description__["a" /* default */].ColumnHeading, null, group.title),
                                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__patterns_description__["a" /* default */].Text, null,
                                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("ul", null, group.items.map(function (item) { return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("li", { key: item }, item)); }))))); })))),
                this.hasProviders &&
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "callToActionMobile" },
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__patterns_booking__["a" /* default */].AvailabilityFetcher, { lodgingId: poi.id, provider: this.provider.data, render: function (_a) {
                                var dates = _a.dates, focusedInput = _a.focusedInput, handleDateChange = _a.handleDateChange, handleFocusChange = _a.handleFocusChange, price = _a.price, nights = _a.nights, url = _a.url, unavailable = _a.unavailable, loading = _a.loading;
                                return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__patterns_booking__["a" /* default */].Lodging, { loading: loading, unavailable: unavailable, dates: dates, 
                                    // TODO: get with OP to get the proper hostelworld score
                                    rating: _this.provider.data.score <= 10 ? _this.provider.data.score + " out of 10" : "", providerName: _this.provider.name && _this.provider.name.toLowerCase(), providerType: _this.provider.type, lodgingName: poi.name, nights: nights, handleDateChange: handleDateChange, handleFocusChange: handleFocusChange, focusedInput: focusedInput, price: price, url: url }));
                            } })),
                this.hasProviders &&
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "callToActionAside" },
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__patterns_booking__["a" /* default */].AvailabilityFetcher, { lodgingId: poi.id, provider: this.provider.data, render: function (_a) {
                                var dates = _a.dates, focusedInput = _a.focusedInput, handleDateChange = _a.handleDateChange, handleFocusChange = _a.handleFocusChange, price = _a.price, nights = _a.nights, url = _a.url, unavailable = _a.unavailable, loading = _a.loading;
                                return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__patterns_booking__["a" /* default */].Lodging, { loading: loading, unavailable: unavailable, dates: dates, 
                                    // TODO: get with OP to get the proper hostelworld score
                                    rating: _this.provider.data.score <= 10 ? _this.provider.data.score + " out of 10" : "", providerName: _this.provider.name && _this.provider.name.toLowerCase(), providerType: _this.provider.type, lodgingName: poi.name, nights: nights, handleDateChange: handleDateChange, handleFocusChange: handleFocusChange, focusedInput: focusedInput, price: price, url: url }));
                            } })),
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "infoLocation" },
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Heading, null, "Overview"),
                        (poi.location && poi.location.coordinates && poi.location.coordinates.length) &&
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Map, { coordinates: poi.location.coordinates.join(",") }),
                        (poi.address && poi.address.street) &&
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Item, null, poi.address.street),
                        (poi.address && poi.address.extras) &&
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"], null, Object(__WEBPACK_IMPORTED_MODULE_22__utils_formatAddressExtras__["a" /* formatAddressExtras */])(poi.address.extras).map(function (item) { return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Item, { label: item.label }, item.text)); })),
                        (poi.location && poi.location.coordinates && poi.location.coordinates.length) &&
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Item, null, Object(__WEBPACK_IMPORTED_MODULE_23__utils_getDistanceToCityCenter__["a" /* getDistanceToCityCenter */])(poi.location.coordinates, places)),
                        (poiAtlas && poiAtlas.telephone && poiAtlas.telephone.national) &&
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Item, null,
                                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("a", { href: "tel:" + (poiAtlas.telephone.callingCode || "") +
                                        ("" + poiAtlas.telephone.national.replace(/-|\s/g, "")) }, poiAtlas.telephone.national)),
                        (poiAtlas && poiAtlas.emails && poiAtlas.emails.length) &&
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Item, null, Array.isArray(poiAtlas.emails) ? poiAtlas.emails[0] : poiAtlas.emails),
                        poiAtlas && poiAtlas.website &&
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Item, null,
                                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("a", { href: poiAtlas.website }, "Visit website")))),
                poi.review && poi.review.essential && (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "suggestEdit" },
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_suggestEdit__["a" /* default */], { poi: poi, location: location }))),
                this.hasActivities &&
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "activitiesLodging" },
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", null,
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_text__["Heading"], { size: 7, level: 4, weight: "medium" }, "Nearby activities"),
                            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__patterns_activities__["a" /* default */], { data: activities, url: moreTourLink, containingPlaces: poi.containingPlaces, placeId: match.params.placeId, parentActivityName: poi.name, buttonColor: "gray" }))),
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "adRail" },
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__shared_components_ad__["a" /* Ad */].Primary, null,
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__shared_components_ad__["b" /* AdUnit */].SideRail, { adUnit: "poisRightRail", targeting: adTargeting }))),
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_template__["a" /* default */].Position, { area: "adSuperzone" },
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__shared_components_ad__["a" /* Ad */].Bounded, null,
                        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__shared_components_ad__["b" /* AdUnit */].Superzone, { adUnit: "poisSuperzone", targeting: adTargeting }))))));
    };
    PageLodging.hasLength = function (array) { return array.length > 0; };
    return PageLodging;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PageLodging);


/***/ }),

/***/ "TPfb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"listItem":"styles__listItem___1G_na","adSearchResult":"styles__adSearchResult___1xQF5","adLabel":"styles__adLabel___23vPc"};

/***/ }),

/***/ "TRcX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var redux_actions_1 = __webpack_require__("sTbe");

var toast_1 = __webpack_require__("4XlA");

var showToast = redux_actions_1.createAction(toast_1.TOAST_SHOW, function (message, type, buttonLabel, url) {
  return {
    buttonLabel: buttonLabel,
    message: message,
    type: type,
    url: url
  };
});
var hideToast = redux_actions_1.createAction(toast_1.TOAST_HIDE);

exports.showToastMessage = function (message, type, buttonLabel, url) {
  if (type === void 0) {
    type = "success";
  }

  if (buttonLabel === void 0) {
    buttonLabel = "";
  }

  if (url === void 0) {
    url = "";
  }

  return function (dispatch) {
    dispatch(showToast(message, type, buttonLabel, url));
    setTimeout(function () {
      return dispatch(hideToast());
    }, toast_1.TOAST_DURATION);
  };
};

exports.hideToastMessage = function () {
  return function (dispatch) {
    dispatch(hideToast());
  };
};

/***/ }),

/***/ "TmcO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configureStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("Ol7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__("bEzl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__("dAD3");



function configureStore() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */]));
}


/***/ }),

/***/ "TvgL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("9Nd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);



var TextUppercase = function (_a) {
    var children = _a.children, className = _a.className;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["textUppercase"], className) }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (TextUppercase);


/***/ }),

/***/ "TyI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_map__ = __webpack_require__("uwTI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("SLLz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);



var InfoMap = function (_a) {
    var coordinates = _a.coordinates;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_map__["a" /* Map */].Static, { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["infoMap"], coordinates: coordinates, dimensions: "80x80" }));
};
/* harmony default export */ __webpack_exports__["a"] = (InfoMap);


/***/ }),

/***/ "U04J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.listRoutes = {
    show: "/:slug(.*)*/a/:type/:id",
};


/***/ }),

/***/ "Uasl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    function Portal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Portal.prototype.render = function () {
        if (typeof document === "undefined") {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"](this.props.children, this.props.target || document.body);
    };
    return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Portal);


/***/ }),

/***/ "Uj3B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var partnerActivityType_1 = __webpack_require__("tgy8");
var filterPlaceTypes_1 = __webpack_require__("duHJ");
var string_1 = __webpack_require__("KPtS");
var constants_1 = __webpack_require__("uuxV");
var routes_1 = __webpack_require__("xY00");
// tslint:disable-next-line:max-classes-per-file
var PartnerActivityUrlGenerator = /** @class */ (function () {
    function PartnerActivityUrlGenerator(compiler) {
        this.route = routes_1.poisRoutes.detail;
        this.toUrl = compiler(this.route);
    }
    PartnerActivityUrlGenerator.prototype.generate = function (poi) {
        var activityType = partnerActivityType_1.isTourOrActivity(poi.duration, "plural");
        var abbrev = constants_1.poiKindSlugMap[activityType];
        return this.toUrl({
            id: poi.id,
            placeId: poi.containingPlaceId,
            slug: this.slug(poi.containingPlaces, poi),
            type: "pa-" + abbrev,
        });
    };
    PartnerActivityUrlGenerator.prototype.slug = function (places, poi) {
        var parts = places.filter(filterPlaceTypes_1.filterPlaceTypes)
            .map(function (p) { return p.name; })
            .reverse();
        var activityType = partnerActivityType_1.isTourOrActivity(poi.duration, "plural");
        parts.push(activityType);
        parts.push(poi.name);
        return parts.map(function (p) { return string_1.cleanString(p.toLowerCase()); });
    };
    return PartnerActivityUrlGenerator;
}());
exports.PartnerActivityUrlGenerator = PartnerActivityUrlGenerator;


/***/ }),

/***/ "V4Vm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var openPlanetTypes_1 = __webpack_require__("Jg0a");
var partnerActivityType_1 = __webpack_require__("tgy8");
var pathToRegexp = __webpack_require__("Ygqm");
var constants_1 = __webpack_require__("uuxV");
var filterPlaceTypes_1 = __webpack_require__("duHJ");
var string_1 = __webpack_require__("KPtS");
var routes_1 = __webpack_require__("U04J");
// tslint:disable-next-line:max-classes-per-file
var PoiListUrlGenerator = /** @class */ (function () {
    function PoiListUrlGenerator(compiler) {
        this.route = routes_1.listRoutes.show;
        this.toUrl = compiler(this.route);
    }
    PoiListUrlGenerator.prototype.generate = function (poi) {
        return this.toUrl({
            id: poi.containingPlaceId,
            slug: this.slug(poi.containingPlaces, poi),
            type: this.abbreviatedType(poi),
        });
    };
    PoiListUrlGenerator.prototype.abbreviatedType = function (poi) {
        switch (poi.type) {
            case openPlanetTypes_1.poi:
                return constants_1.poiTypeSlugMap[poi.type] + "-" + constants_1.poiKindSlugMap[poi.poiType];
            case openPlanetTypes_1.lodging:
                return constants_1.poiTypeSlugMap.lodging;
            case openPlanetTypes_1.partnerActivity:
                var activityType = partnerActivityType_1.isTourOrActivity(poi.duration, "plural");
                var abbrev = constants_1.poiKindSlugMap[activityType];
                return "pa-" + abbrev;
        }
    };
    PoiListUrlGenerator.prototype.type = function (poi) {
        switch (poi.type) {
            case openPlanetTypes_1.poi:
                return constants_1.poiTypes[poi.poiType].displayName;
            case openPlanetTypes_1.lodging:
                return constants_1.poiTypes.sleeping.displayName;
            case openPlanetTypes_1.partnerActivity:
                var activityType = partnerActivityType_1.isTourOrActivity(poi.duration, "plural");
                return activityType;
        }
    };
    PoiListUrlGenerator.prototype.slug = function (places, poi) {
        var parts = places.filter(filterPlaceTypes_1.filterPlaceTypes)
            .map(function (p) { return p.name; })
            .reverse();
        var activityType = this.type(poi);
        parts.push(activityType);
        return parts.map(function (p) { return string_1.cleanString(p.toLowerCase()); });
    };
    return PoiListUrlGenerator;
}());
exports.PoiListUrlGenerator = PoiListUrlGenerator;
exports.createPoiUrl = function (options) {
    return new PoiListUrlGenerator(pathToRegexp.compile).generate(options);
};
// pathToRegexp.compile(route);


/***/ }),

/***/ "VFi5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"reviewBodyText":"styles__reviewBodyText___2rexg"};

/***/ }),

/***/ "VdRz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("SUMG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var DotLoader = function (_a) {
    var inline = _a.inline, rest = __rest(_a, ["inline"]);
    var _b;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__("DotLoader", (_b = {}, _b[__WEBPACK_IMPORTED_MODULE_2__styles_css__["inline"]] = inline, _b)) }, rest),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["dot"] }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["dot"], __WEBPACK_IMPORTED_MODULE_2__styles_css__["second"]) }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["dot"], __WEBPACK_IMPORTED_MODULE_2__styles_css__["third"]) })));
};
/* harmony default export */ __webpack_exports__["a"] = (DotLoader);


/***/ }),

/***/ "Virx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProviderTypes */
/* harmony export (immutable) */ __webpack_exports__["a"] = getProviderUrl;
/* unused harmony export bookingDotcomUrl */
/* unused harmony export hostelWorldUrl */
/* harmony export (immutable) */ __webpack_exports__["b"] = viatorMoreLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing__ = __webpack_require__("B7EN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils_lodash__ = __webpack_require__("cRoh");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var lowerUnder = function (str) { return str.replace(/[A-Z]/g, function (n) { return "_" + n.toLowerCase(); }); };
var queryBuilder = function (options) { return __WEBPACK_IMPORTED_MODULE_1__shared_utils_lodash__["b" /* default */].map(options, function (value, key) { return key + "=" + value; }).join("&"); };
/*
Affiliate ID: aid=964005
Hostname: hostname=www.booking.com
Hotel ID: hotel_id=98251
Stage: stage=0
Check-in date (YYYY-mm-dd): checkin=2012-12-14
Check-out date (YYYY-mm-dd): checkout=2012-12-15
Number of rooms: nr_rooms_9825101_8806_0=2
*/
var ProviderTypes;
(function (ProviderTypes) {
    ProviderTypes["BookingDotCom"] = "bdc";
    ProviderTypes["HostelWorld"] = "hw";
})(ProviderTypes || (ProviderTypes = {}));
function getProviderUrl(dates, provider) {
    var providerUrl = "";
    var providerType = provider.provider, id = provider.id, website = provider.website;
    var startDate = dates.startDate, endDate = dates.endDate;
    if (providerType === ProviderTypes.BookingDotCom) {
        providerUrl =
            bookingDotcomUrl({
                checkin: startDate || "",
                checkout: endDate || "",
                hotelId: id,
                label: "dotcom-pois",
            }, website).replace("https", "http");
    }
    if (providerType === ProviderTypes.HostelWorld) {
        providerUrl =
            hostelWorldUrl({
                dateFrom: startDate || "",
                dateTo: endDate || "",
                propNum: id,
            });
    }
    return providerUrl;
}
function bookingDotcomUrl(opts, website) {
    var base = website || "https://secure.booking.com/book.html";
    var defaults = {
        aid: 964005,
        checkin: null,
        checkout: null,
        hostname: "www.booking.com",
        hotelId: null,
        stage: 0,
    };
    var options = __WEBPACK_IMPORTED_MODULE_1__shared_utils_lodash__["b" /* default */].assign({}, defaults, opts);
    options.hotelId = ("" + options.hotelId).replace(/bdc/, "");
    var query = queryBuilder(options);
    return base + "?" + query;
}
function hostelWorldUrl(opts) {
    var base = "www.hostelworld.com/hosteldetails.php";
    var defaults = {
        affiliate: "lonelyplanet.com",
        dateFrom: null,
        dateTo: null,
        propNum: null,
    };
    var options = __WEBPACK_IMPORTED_MODULE_1__shared_utils_lodash__["b" /* default */].pickBy(__WEBPACK_IMPORTED_MODULE_1__shared_utils_lodash__["b" /* default */].assign({}, defaults, opts), __WEBPACK_IMPORTED_MODULE_1__shared_utils_lodash__["b" /* default */].filter);
    options.propNum = ("" + options.propNum).replace(/hw/, "");
    var query = queryBuilder(options);
    return "http://" + base + "?" + query + "#availability";
}
function viatorMoreLink(poi) {
    return __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing__["Urls"].createList(__assign({}, poi));
}


/***/ }),

/***/ "Vkxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_text__ = __webpack_require__("s7mA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("VFi5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);



var ReviewExtension = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__shared_components_text__["a" /* default */].Article, { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["reviewBodyText"] }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (ReviewExtension);


/***/ }),

/***/ "W0rn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ad__ = __webpack_require__("71+K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adUnit__ = __webpack_require__("6z/T");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ad__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__adUnit__; });





/***/ }),

/***/ "W66V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__searchInput__ = __webpack_require__("4nSq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__searchInputCancelButton__ = __webpack_require__("01s7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__("3nvx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var SearchForm = /** @class */ (function (_super) {
    __extends(SearchForm, _super);
    function SearchForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleInputChange = function (e) {
            _this.setState({
                input: e.target.value,
            });
        };
        _this.handleClickCloseButton = function () {
            var onSearch = _this.props.onSearch;
            _this.setState({
                input: "",
            }, function () {
                _this.inputComponent.focus();
                onSearch("");
            });
        };
        _this.handleSearch = function (e) {
            e.preventDefault();
            _this.props.onSearch(_this.state.input);
            _this.inputComponent.blur();
        };
        _this.state = {
            input: props.input || "",
        };
        return _this;
    }
    SearchForm.prototype.componentDidMount = function () {
        if (this.inputComponent) {
            this.inputComponent.focus();
        }
    };
    SearchForm.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            input: nextProps.input,
        });
    };
    SearchForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, placeholder = _a.placeholder;
        var input = this.state.input;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("form", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["searchForm"], className), onSubmit: this.handleSearch },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__searchInput__["a" /* default */], { value: input, className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["searchInput"], placeholder: placeholder || "Search", onChange: this.handleInputChange, innerRef: function (node) { return (_this.inputComponent = node); } }),
            input && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__searchInputCancelButton__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["searchInputCancelButton"], onClick: this.handleClickCloseButton }))));
    };
    return SearchForm;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),

/***/ "WDgB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buttonSearch__ = __webpack_require__("uNWQ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Search", function() { return __WEBPACK_IMPORTED_MODULE_0__buttonSearch__["a"]; });



/***/ }),

/***/ "WRu6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__("l3hU");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var Component = __WEBPACK_IMPORTED_MODULE_1_react__["Component"];
var GlobalToastFromCookie = /** @class */ (function (_super) {
    __extends(GlobalToastFromCookie, _super);
    function GlobalToastFromCookie(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            message: "",
            url: "",
            buttonLabel: "",
            type: "success",
            duration: 5000,
            animationDuration: 200,
            visible: false,
            title: "",
        };
        return _this;
    }
    GlobalToastFromCookie.prototype.componentDidMount = function () {
        var toastCookie = __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"]("lpToast");
        if (toastCookie) {
            return this.setState(__assign({}, this.state, JSON.parse(toastCookie), { visible: true }));
        }
    };
    GlobalToastFromCookie.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */], { message: this.state.message, buttonLabel: this.state.buttonLabel, url: this.state.url, type: this.state.type, duration: this.state.duration, animationDuration: this.state.animationDuration, visible: this.state.visible, title: this.state.title, onClose: function () {
                __WEBPACK_IMPORTED_MODULE_0_js_cookie__["remove"]("lpToast", { domain: ".lonelyplanet.com" });
            } }));
    };
    return GlobalToastFromCookie;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (GlobalToastFromCookie);


/***/ }),

/***/ "Wni0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_text__ = __webpack_require__("s7mA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("meXs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);




var BookingRating = function (_a) {
    var children = _a.children, className = _a.className;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_components_text__["a" /* default */].Italic, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["bookingRating"], className) }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (BookingRating);


/***/ }),

/***/ "WxNj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = distanceTo;
/* harmony export (immutable) */ __webpack_exports__["b"] = distanceUnits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_haversine__ = __webpack_require__("rn45");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_haversine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_haversine__);

function distanceTo(startingCoordinates, endingCoordinates) {
    var start = {
        latitude: startingCoordinates[0],
        longitude: startingCoordinates[1],
    };
    var end = {
        latitude: endingCoordinates[0],
        longitude: endingCoordinates[1],
    };
    var metricDistance = __WEBPACK_IMPORTED_MODULE_0_haversine__(start, end, { unit: "km" });
    var imperialDistance = __WEBPACK_IMPORTED_MODULE_0_haversine__(start, end, { unit: "mile" });
    return {
        imperial: {
            amount: imperialDistance.toFixed(2),
            unit: "miles",
        },
        metric: {
            amount: metricDistance.toFixed(2),
            unit: "km",
        },
    };
}
function readCookie(name) {
    var c = [];
    if (typeof document !== "undefined" && document.cookie) {
        c = document.cookie.split("; ");
    }
    var cookies = {};
    c.forEach(function (cookie) {
        var cookieValue = cookie.split("=");
        cookies[cookieValue[0]] = cookieValue[1];
    });
    return cookies[name];
}
function distanceUnits() {
    if (readCookie("lpCurrency") === "USD") {
        return "imperial";
    }
    return "metric";
}


/***/ }),

/***/ "XHb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__("FcFf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createRoot__ = __webpack_require__("Ahhh");


var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils_createRoot__["a" /* createRoot */])(__WEBPACK_IMPORTED_MODULE_0__app__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (Root);


/***/ }),

/***/ "XMAh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"flyout":"styles__flyout___8f_72"};

/***/ }),

/***/ "XPoP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"styles__breadcrumbs___19mqc","breadcrumbsItem":"styles__breadcrumbsItem___1LjWu"};

/***/ }),

/***/ "Xem7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bookmarkModal":"styles__bookmarkModal___1Yxgr","bookmarkModalStep1":"styles__bookmarkModalStep1___UCRdX","bookmarkModalAction":"styles__bookmarkModalAction___3hJXx","bookmarkModalActionDisabled":"styles__bookmarkModalActionDisabled___3hdZ5","bookmarkAddEditListFieldset":"styles__bookmarkAddEditListFieldset___1_QkU","bookmarkAddEditListFieldsetFooter":"styles__bookmarkAddEditListFieldsetFooter___3FX9S","bookmarkAddEditListField":"styles__bookmarkAddEditListField___1GBeo","bookmarkAddEditListLabel":"styles__bookmarkAddEditListLabel___1whg5","bookmarkAddEditListSwitch":"styles__bookmarkAddEditListSwitch___2DC7r","bookmarkAddEditListSaveButtonDesktop":"styles__bookmarkAddEditListSaveButtonDesktop___3QRsn"};

/***/ }),

/***/ "XxNa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sortProviderDescriptions */
/* unused harmony export filterHWDescriptions */
/* unused harmony export filterBDCDescriptions */
/* harmony export (immutable) */ __webpack_exports__["a"] = cleanPartnerDescriptions;
function sortProviderDescriptions(descriptions, titleOrder) {
    return descriptions.slice().sort(function (a, b) { return titleOrder.indexOf(a.title) - titleOrder.indexOf(b.title); });
}
function filterHWDescriptions(descriptions) {
    var hwDescription = descriptions.find(function (d) { return d.title === "description"; });
    var hwIntro = descriptions.find(function (d) { return d.title === "short introduction"; });
    if (hwDescription && hwDescription.text) {
        return [{
                text: hwDescription.text,
                title: "" + hwDescription.title[0].toUpperCase() + hwDescription.title.substr(1)
            }];
    }
    else if (hwIntro && hwIntro.text) {
        return [{
                text: hwIntro.text,
                title: "" + hwIntro.title[0].toUpperCase() + hwIntro.title.substr(1)
            }];
    }
    else {
        return [];
    }
}
function filterBDCDescriptions(descriptions) {
    return sortProviderDescriptions(descriptions, [
        "Quick description",
        "Important information",
    ]).filter(function (d) { return d.text; });
}
function cleanPartnerDescriptions(type, descriptions) {
    var providers = {
        bdc: filterBDCDescriptions,
        hostelworld: filterHWDescriptions,
    };
    return providers[type](descriptions);
}


/***/ }),

/***/ "XxOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_load_image__ = __webpack_require__("q/xo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_load_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_load_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dotLoader__ = __webpack_require__("VdRz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__("9yvi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lonelyplanet_lp_analytics__ = __webpack_require__("UtEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lonelyplanet_lp_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__lonelyplanet_lp_analytics__);






var ImageError = function (_a) {
    var _b = _a.children, children = _b === void 0 ? "Image unavailable" : _b;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["fallback"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["error"]) },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", null, children)));
};
var ImageLoading = function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["fallback"]) },
    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__dotLoader__["a" /* default */], null))); };
var Picture = function (_a) {
    var sources = _a.sources, src = _a.src, srcSet = _a.srcSet, alt = _a.alt, className = _a.className;
    var _b;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__lonelyplanet_lp_analytics__["DataLayerInitializationData"], { data: (_b = {}, _b[__WEBPACK_IMPORTED_MODULE_5__lonelyplanet_lp_analytics__["analytics"].hasPhoto] = true, _b), indexForEntirePayload: 1, scriptWrapperForEntirePayload: __WEBPACK_IMPORTED_MODULE_5__lonelyplanet_lp_analytics__["asyncUserStatusWrapper"] }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_load_image___default.a, { src: src },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("picture", null,
                sources.map(function (source) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("source", { key: src + " " + source.media, media: source.media, srcSet: source.srcSet })); }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(className), srcSet: srcSet, src: src, alt: alt })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ImageError, null),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ImageLoading, null))));
};
/* harmony default export */ __webpack_exports__["a"] = (Picture);


/***/ }),

/***/ "YAHl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDistanceToCityCenter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__distanceTo__ = __webpack_require__("WxNj");

function getDistanceToCityCenter(poiCoordinates, places) {
    var city = Array.isArray(places) && places.filter(function (containingPlace) { return containingPlace.placeType === "city"; });
    if (!poiCoordinates || city.length === 0 || !city[0].center) {
        return "";
    }
    var cityCenter = city[0].center.coordinates;
    if (!cityCenter || cityCenter.length === 0) {
        return "";
    }
    var distanceToCityCenter = Object(__WEBPACK_IMPORTED_MODULE_0__distanceTo__["a" /* distanceTo */])(poiCoordinates, cityCenter);
    var amount = distanceToCityCenter[Object(__WEBPACK_IMPORTED_MODULE_0__distanceTo__["b" /* distanceUnits */])()].amount;
    var unit = distanceToCityCenter[Object(__WEBPACK_IMPORTED_MODULE_0__distanceTo__["b" /* distanceUnits */])()].unit;
    return amount + " " + unit + " to city center";
}


/***/ }),

/***/ "YIyS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return adUnits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return adSuperzone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return adMobileSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return adMobileRectangle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return adSkyScraper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return adBannerSmall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return adBannerLarge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return adPositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return adViewports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return generateAdTargeting; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var adUnits = {
    pois: "9885583/LonelyPlanet.com/Destinations/POIs",
    poisRightRail: "9885583/LonelyPlanet.com/Destinations/POIs/right-rail",
    poisSuperzone: "9885583/LonelyPlanet.com/Destinations/POIs/superzone",
    search: "/9885583/LonelyPlanet.com/search",
    searchInContent: "/9885583/LonelyPlanet.com/search/in-content",
    special: "9885583/LonelyPlanet.com/Special",
};
var adSuperzone = [1, 1];
var adMobileSquare = [300, 250];
var adMobileRectangle = [320, 50];
var adSkyScraper = [300, 600];
var adBannerSmall = [728, 90];
var adBannerLarge = [970, 250];
var adPositions = {
    hero: "hero",
    inContent: "in-content",
    sideRail: "side-rail",
    superzone: "superzone",
};
var adViewports = {
    desktop: [1354, 0],
    laptop: [1024, 0],
    mobile: [0, 0],
    tablet: [768, 0],
};
var generateAdTargeting = function (_a) {
    var _b = _a.query, query = _b === void 0 ? typeof window !== "undefined" ? window.location.search : "" : _b, _c = _a.pathname, pathname = _c === void 0 ? typeof window !== "undefined" ? window.location.pathname : "" : _c, rest = __rest(_a, ["query", "pathname"]);
    return __assign({ URLPath: pathname, URLQuery: query
            .replace(/\=/ig, ":")
            .split("&") }, rest);
};


/***/ }),

/***/ "YLLQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"divider":"pois__divider___1IoNO","breadcrumbs":"pois__breadcrumbs___20OGQ"};

/***/ }),

/***/ "YRSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schemaReview__ = __webpack_require__("hk/D");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Review", function() { return __WEBPACK_IMPORTED_MODULE_0__schemaReview__["a"]; });



/***/ }),

/***/ "ZSLX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _a;

var redux_actions_1 = __webpack_require__("sTbe");

var toast_1 = __webpack_require__("4XlA");

var toast = redux_actions_1.handleActions((_a = {}, _a[toast_1.TOAST_SHOW] = function (state, action) {
  return __assign({}, state, action.payload, {
    visible: true
  });
}, _a[toast_1.TOAST_HIDE] = function (state) {
  return __assign({}, state, {
    visible: false
  });
}, _a), {
  buttonLabel: "",
  message: "",
  type: "success",
  url: "",
  visible: false
});
exports.default = toast;

/***/ }),

/***/ "a9ep":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__("Fi1p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);


var AdLabel = function (_a) {
    var children = _a.children;
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1__styles_css__["adLabel"] }, children);
};


/***/ }),

/***/ "aVHp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkNavigation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__ = __webpack_require__("AemK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("+Bcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var LinkNavigation = function (_a) {
    var children = _a.children, _b = _a.topLevel, topLevel = _b === void 0 ? false : _b, className = _a.className, rest = __rest(_a, ["children", "topLevel", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("a", __assign({}, rest, { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["linkNavigation"], topLevel && __WEBPACK_IMPORTED_MODULE_3__styles_css__["linkNavigationTopLevel"], className) }),
        children,
        topLevel &&
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__["ChevronDown"], { className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["linkNavigationTopLevelIcon"] })));
};


/***/ }),

/***/ "aadl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return schemaDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chrono_node__ = __webpack_require__("zht0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chrono_node___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chrono_node__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


/*
 * Please see the following:
 * - http://momentjs.com/guides/#/warnings/js-date/
 * - https://github.com/moment/moment/issues/1407
 */
var convertToISOString = function (dateString) {
    return __WEBPACK_IMPORTED_MODULE_1_moment__(new Date(dateString))
        .utc(dateString)
        .toISOString();
};
var schemaDate = function (date) {
    if (!__WEBPACK_IMPORTED_MODULE_0_chrono_node__["parse"](date).length) {
        return {
            endDate: "",
            startDate: "",
        };
    }
    var parsedStartDate = __WEBPACK_IMPORTED_MODULE_0_chrono_node__["parse"](date)[0].start;
    var parsedEndDate = __WEBPACK_IMPORTED_MODULE_0_chrono_node__["parse"](date)[0].end;
    var startDate = typeof parsedStartDate !== "undefined" ?
        convertToISOString(parsedStartDate.date().toString()) : "";
    var endDate = typeof parsedEndDate !== "undefined" ?
        convertToISOString(parsedEndDate.date().toString()) : "";
    return {
        endDate: endDate || startDate,
        startDate: startDate,
    };
};


/***/ }),

/***/ "ayG1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reviewEssential__ = __webpack_require__("hTZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reviewExtension__ = __webpack_require__("Vkxo");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var Review = /** @class */ (function (_super) {
    __extends(Review, _super);
    function Review() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Review.Essential = __WEBPACK_IMPORTED_MODULE_1__reviewEssential__["a" /* default */];
    Review.Extension = __WEBPACK_IMPORTED_MODULE_2__reviewExtension__["a" /* default */];
    return Review;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Review);


/***/ }),

/***/ "bN4f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navigationDesktop__ = __webpack_require__("yScR");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Desktop", function() { return __WEBPACK_IMPORTED_MODULE_0__navigationDesktop__["a"]; });



/***/ }),

/***/ "bhYL":
/***/ (function(module, exports) {

if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        "use strict";
        if (typeof start !== "number") {
            start = 0;
        }
        if (start + search.length > this.length) {
            return false;
        }
        else {
            return this.indexOf(search, start) !== -1;
        }
    };
}


/***/ }),

/***/ "buU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_containers_dataLayer__ = __webpack_require__("sxtG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__ = __webpack_require__("UtEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lonelyplanet_open_planet_node_dist_openPlanetTypes__ = __webpack_require__("Jg0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lonelyplanet_open_planet_node_dist_openPlanetTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_open_planet_node_dist_openPlanetTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lonelyplanet_travel_agent_dist_helmet__ = __webpack_require__("OH7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lonelyplanet_travel_agent_dist_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lonelyplanet_travel_agent_dist_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_styles_colors__ = __webpack_require__("8LSk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_styles_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_tag__ = __webpack_require__("H7ET");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_tagList__ = __webpack_require__("F/rI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_tagList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_tagList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_icon__ = __webpack_require__("AemK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_gpt__ = __webpack_require__("v4Eu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_gpt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_gpt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_stickynode__ = __webpack_require__("3Bsu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_stickynode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_stickynode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_asset__ = __webpack_require__("xVEJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_utils_ads__ = __webpack_require__("YIyS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ad__ = __webpack_require__("LlzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_container__ = __webpack_require__("Bs0H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_grid__ = __webpack_require__("ulkP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_listItemWireframe__ = __webpack_require__("RkVG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_noResults__ = __webpack_require__("+nco");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_resultsText__ = __webpack_require__("1HbD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_searchForm__ = __webpack_require__("W66V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_searchResults__ = __webpack_require__("wdAr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_search_css__ = __webpack_require__("uyig");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_search_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__styles_search_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_cleanQuery__ = __webpack_require__("ij64");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_combineOpenPlanetTypes__ = __webpack_require__("Jfyc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__shared_utils_requests__ = __webpack_require__("zuOK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_topicHelpers__ = __webpack_require__("B+kQ");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





























var tagStyle = {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_styles_colors___default.a.linkPrimary,
    borderColor: __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_styles_colors___default.a.linkPrimary,
};
var SearchComponent = /** @class */ (function (_super) {
    __extends(SearchComponent, _super);
    function SearchComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.contentTypeFilters = [
            [__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_open_planet_node_dist_openPlanetTypes__["place"], "Destinations"],
            [__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_open_planet_node_dist_openPlanetTypes__["lodging"], "Hotels"],
            [__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_open_planet_node_dist_openPlanetTypes__["partnerActivity"], "Activities & Tours"],
            [__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_open_planet_node_dist_openPlanetTypes__["poi"], "Things to Do"],
            ["product", "Books"],
            [__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_open_planet_node_dist_openPlanetTypes__["video"], "Videos"],
            [Object(__WEBPACK_IMPORTED_MODULE_26__utils_combineOpenPlanetTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_open_planet_node_dist_openPlanetTypes__["news"], __WEBPACK_IMPORTED_MODULE_2__lonelyplanet_open_planet_node_dist_openPlanetTypes__["article"]), "News & Articles"],
        ];
        _this.filterByType = function (type) {
            _this.setState({
                type: type,
            }, function () {
                _this.updateQueryString();
                var newSearch = true;
                _this.fetchData(newSearch, false);
            });
        };
        _this.removeTopic = function (topicIdToRemove) {
            var _a = _this.state, topicId = _a.topicId, topics = _a.topics;
            var topic = topics.find(function (t) { return t.id === topicId; });
            _this.setState({
                topicId: Object(__WEBPACK_IMPORTED_MODULE_28__utils_topicHelpers__["a" /* removeTopicIdFromString */])(topicIdToRemove, topicId),
            }, function () {
                var _a;
                if (topic) {
                    var track = Object(__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["getTrackMethod"])();
                    track((_a = {},
                        _a[__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["analytics"].eventName] = __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["EventNames"].unfilterSearchResultsByTag,
                        _a[__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["analytics"].tagId] = topic.id,
                        _a[__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["analytics"].tagLabel] = topic.label,
                        _a[__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["analytics"].tagType] = __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["TagTypes"].topic,
                        _a));
                }
                _this.updateQueryString();
                var newSearch = true;
                _this.fetchData(newSearch, false);
            });
        };
        _this.handleInfiniteScroll = function () {
            if (_this.state.results.length < _this.state.total) {
                _this.setState({
                    page: _this.state.page + 1,
                }, function () {
                    var newSearch = false;
                    _this.fetchData(newSearch, false);
                });
            }
        };
        _this.handleSearch = function (value) {
            _this.setState({
                keyword: value,
                page: 1,
                query: "",
                results: [],
                total: 0,
            }, function () {
                _this.updateQueryString();
                if (value) {
                    var newSearch = true;
                    _this.fetchData(newSearch, false);
                }
            });
        };
        _this.handleOriginalKeywordSearch = function (e) {
            e.preventDefault();
            _this.setState({
                page: 1,
                query: "",
                results: [],
                total: 0,
            }, function () {
                _this.fetchData(true, true);
            });
        };
        _this.handleClickthrough = function (documentId) {
            Object(__WEBPACK_IMPORTED_MODULE_27__shared_utils_requests__["c" /* post */])("/search/clickthrough", { term: _this.state.keyword, id: documentId });
        };
        _this.state = {
            isFetching: false,
            keyword: props.keyword || "",
            page: 1,
            query: props.query || "",
            results: props.results || [],
            topicId: props.topicId || "",
            topics: props.topics || [],
            total: props.total || 0,
            type: props.type,
        };
        return _this;
    }
    SearchComponent.prototype.componentDidMount = function () {
        if (!this.state.results.length) {
            this.initiateSearchFromQueryString();
        }
        if (this.state.keyword || this.state.topicId) {
            this.updateQueryString();
        }
        if (this.state.topics) {
            var track_1 = Object(__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["getTrackMethod"])();
            this.state.topics.forEach(function (topic) {
                var _a;
                track_1((_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["analytics"].eventName] = __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["EventNames"].filterSearchResultsByTag,
                    _a[__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["analytics"].tagId] = topic.id,
                    _a[__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["analytics"].tagLabel] = topic.label,
                    _a[__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["analytics"].tagType] = __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["TagTypes"].topic,
                    _a));
            });
        }
    };
    SearchComponent.prototype.initiateSearchFromQueryString = function () {
        var _this = this;
        var searchQuery = __WEBPACK_IMPORTED_MODULE_9_query_string__["parse"](this.props.location.search);
        var searchKeywordChanged = searchQuery.q && searchQuery.q !== this.state.keyword;
        var topicIdChanged = searchQuery.topic_id && searchQuery.topic_id !== this.state.topicId;
        if (searchKeywordChanged || topicIdChanged) {
            this.setState({
                keyword: searchQuery.q,
                topicId: searchQuery.topic_id || null,
                type: searchQuery.type || null,
            }, function () {
                _this.fetchData(true, false);
            });
        }
    };
    SearchComponent.prototype.fetchData = function (newSearch, enforceSpelling) {
        return __awaiter(this, void 0, void 0, function () {
            var page, url, _a, topics, results;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setState({
                            isFetching: true,
                        });
                        page = newSearch ? 1 : this.state.page;
                        url = "/search/api?q=" + Object(__WEBPACK_IMPORTED_MODULE_25__utils_cleanQuery__["a" /* default */])(this.state.keyword) + "&page=" + page;
                        if (this.state.type) {
                            url += "&type=" + this.state.type;
                        }
                        if (enforceSpelling) {
                            url += "&spelling=strict";
                        }
                        if (this.state.topicId) {
                            url += "&topic_id=" + this.state.topicId;
                        }
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_27__shared_utils_requests__["a" /* get */])(url)];
                    case 1:
                        _a = _b.sent(), topics = _a.topics, results = _a.results;
                        if (newSearch) {
                            window.scrollTo(0, 0);
                            this.setState({
                                isFetching: false,
                                page: 1,
                                query: results.meta.query,
                                results: results.data,
                                topics: topics,
                                total: results.meta.total,
                            }, function () { return _this.updateInitialState(); });
                        }
                        else {
                            this.setState({
                                isFetching: false,
                                query: results.meta.query,
                                results: this.state.results.concat(results.data),
                                topics: topics,
                                total: results.meta.total,
                            }, function () { return _this.updateInitialState(); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchComponent.prototype.updateQueryString = function () {
        this.props.history.replace(this.getQueryString());
    };
    SearchComponent.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.state, results = _b.results, total = _b.total, keyword = _b.keyword, isFetching = _b.isFetching, query = _b.query, topics = _b.topics;
        var searchInputPlaceholder = !keyword && !results.length ? "Search" : "Everything";
        return (__WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__components_container__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_containers_dataLayer__["a" /* default */], { data: {
                    cd7_Topic: "search results",
                    content_group_1: "search",
                    content_group_2: "search results",
                    page_type: "search",
                    site_section: "search",
                } }),
            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["DataLayerInitializationData"], { data: (_a = {}, _a[__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["analytics"].siteSection] = __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["SiteSections"].search, _a), indexForEntirePayload: 1, scriptWrapperForEntirePayload: __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_lp_analytics__["asyncUserStatusWrapper"] }),
            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__shared_components_asset__["a" /* default */], { src: "app.js" }),
            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__lonelyplanet_travel_agent_dist_helmet__["Helmet"], null,
                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("title", null, "Search")),
            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_react_stickynode__, { className: __WEBPACK_IMPORTED_MODULE_24__styles_search_css__["searchBox"], activeClass: __WEBPACK_IMPORTED_MODULE_24__styles_search_css__["searchBoxSticky"] },
                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__components_container__["a" /* default */], null,
                    __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__components_searchForm__["a" /* SearchForm */], { className: __WEBPACK_IMPORTED_MODULE_24__styles_search_css__["searchForm"], onSearch: this.handleSearch, input: keyword, placeholder: searchInputPlaceholder }))),
            !!(keyword || topics.length) && (__WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_24__styles_search_css__["filters"] },
                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_backpack_ui_dist_components_tagList___default.a, { limit: topics.length + this.contentTypeFilters.length, style: { maxHeight: "150px" } },
                    topics.map(function (_a) {
                        var id = _a.id, label = _a.label;
                        return (__WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_tag___default.a, { key: id, selected: true, style: __assign({}, tagStyle, { ":hover": tagStyle, ":active": tagStyle, ":focus": tagStyle }) },
                            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null,
                                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null, label),
                                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("button", { onClick: function () { return _this.removeTopic(id); }, className: __WEBPACK_IMPORTED_MODULE_24__styles_search_css__["topic"] },
                                    __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_backpack_ui_dist_components_icon__["Close"], { fill: "#fff" })))));
                    }),
                    this.contentTypeFilters.map(function (_a) {
                        var type = _a[0], name = _a[1];
                        var handleClick = function () {
                            _this.filterByType(_this.state.type !== type ? type : null);
                        };
                        return (__WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_backpack_ui_dist_components_tag___default.a, { href: "#", selected: _this.state.type === type, key: type, onClick: handleClick }, name));
                    })))),
            total > 0 &&
                query && (__WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__components_resultsText__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_24__styles_search_css__["resultsText"] },
                "Showing ",
                total.toLocaleString("en"),
                " results for \"",
                query,
                "\".",
                query !== keyword && (__WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null,
                    " Search instead for ",
                    __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("a", { href: "#", onClick: this.handleOriginalKeywordSearch },
                        "\"",
                        keyword,
                        "\""),
                    ".")))),
            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__components_grid__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_24__styles_search_css__["contentArea"] },
                (isFetching || results.length > 0) && (__WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__components_ad__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_24__styles_search_css__["ad"] },
                    __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_gpt__["Bling"], { adUnitPath: __WEBPACK_IMPORTED_MODULE_15__shared_utils_ads__["h" /* adUnits */].search, sizeMapping: [
                            { viewport: [0, 0], slot: [__WEBPACK_IMPORTED_MODULE_15__shared_utils_ads__["f" /* adSkyScraper */], __WEBPACK_IMPORTED_MODULE_15__shared_utils_ads__["g" /* adSuperzone */]] },
                        ], targeting: Object(__WEBPACK_IMPORTED_MODULE_15__shared_utils_ads__["j" /* generateAdTargeting */])({
                            position: __WEBPACK_IMPORTED_MODULE_15__shared_utils_ads__["e" /* adPositions */].sideRail,
                            query: this.getQueryString(),
                        }) }))),
                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_24__styles_search_css__["results"] },
                    results &&
                        results.length > 0 && (__WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__components_searchResults__["a" /* SearchResults */], { results: results, onScroll: this.handleInfiniteScroll, onClickthrough: this.handleClickthrough })),
                    !isFetching &&
                        results &&
                        results.length === 0 &&
                        !!(keyword || topics.length) &&
                        __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__components_noResults__["a" /* default */], { keyword: keyword }),
                    isFetching && (__WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__components_listItemWireframe__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_8_classnames__(results && results.length > 0 && __WEBPACK_IMPORTED_MODULE_24__styles_search_css__["wireframe"]), animate: true }))))));
    };
    SearchComponent.prototype.updateInitialState = function () {
        window.__initialState.search = {
            keyword: this.state.keyword,
            query: this.state.query,
            results: this.state.results,
            topicId: this.state.topicId,
            topics: this.state.topics,
            total: this.state.total,
        };
    };
    SearchComponent.prototype.getQueryString = function () {
        var searchQuery = __WEBPACK_IMPORTED_MODULE_9_query_string__["parse"](this.props.location.search);
        Object.assign(searchQuery, {
            q: this.state.keyword || undefined,
            topic_id: this.state.topicId || undefined,
            type: this.state.type || undefined,
        });
        return "?" + __WEBPACK_IMPORTED_MODULE_9_query_string__["stringify"](searchQuery);
    };
    return SearchComponent;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]));
var wrapped = Object(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["e" /* withRouter */])(SearchComponent);
/* harmony default export */ __webpack_exports__["a"] = (wrapped);


/***/ }),

/***/ "bwFx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export replaceApostrophes */
/* unused harmony export stripAccents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cleanString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return joinWords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanAttributionDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasOpVideo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diacritics__ = __webpack_require__("JmeQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diacritics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_diacritics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slugify__ = __webpack_require__("ORum");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lodash__ = __webpack_require__("cRoh");



var removeDiacritics = __WEBPACK_IMPORTED_MODULE_0_diacritics__["remove"];
var replaceApostrophes = function (str) { return (str || "").replace(/[’ʻʼ]/g, "-"); };
var stripAccents = function (str) {
    var reAccents = /[αàáâãäçəèéêëìíîi̇ïñòóôõöùúūûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎİÏÑÒÓÔÕÖÙÚÛÜÝЎʻʼ]/g;
    var replacements = "[aaaaaaceeeeeiiiiiinooooouuuuuyyAAAAACEEEEIIIIINOOOOOUUUUYY'']";
    return str.replace(reAccents, function (match) { return replacements[reAccents.source.indexOf(match)]; });
};
var cleanString = __WEBPACK_IMPORTED_MODULE_2__lodash__["b" /* default */].flow([
    replaceApostrophes,
    __WEBPACK_IMPORTED_MODULE_2__lodash__["b" /* default */].kebabCase,
    stripAccents,
    removeDiacritics,
    __WEBPACK_IMPORTED_MODULE_1_slugify___default.a,
]);
var getConjunctionString = function (currentIndex, numberOfWords) {
    var thereAreNoWords = numberOfWords === 0;
    var isFirstWord = currentIndex === 0;
    var isLastWord = currentIndex === numberOfWords - 1;
    var isOnlyWord = isFirstWord && isLastWord;
    var isSecondToLastWord = currentIndex === numberOfWords - 2;
    var isFirstAmongTwoWords = isFirstWord && isSecondToLastWord;
    if (thereAreNoWords || isOnlyWord || isLastWord) {
        return "";
    }
    if (isFirstAmongTwoWords) {
        return " and ";
    }
    if (isSecondToLastWord) {
        return ", and ";
    }
    return ", ";
};
var joinWords = function () {
    var words = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        words[_i] = arguments[_i];
    }
    var numberOfWords = words.length;
    return words.reduce(function (acc, word, i) {
        return "" + acc + word + getConjunctionString(i, numberOfWords);
    }, "");
};
var removeFromAttributionDisplay = {
    copyrightSymbol: /^\s*\u{00A9}\s*|\u{00A9}|\s*\u{00A9}\s*$/gu,
    imageBy: /^\s*image by\s*/gi,
    photoBy: /^\s*photo by\s*/gi,
};
var cleanAttributionDisplay = function (attribution) {
    return Object
        .values(removeFromAttributionDisplay)
        .reduce(function (acc, regex) { return acc.replace(regex, ""); }, attribution);
};
var matchExists = function (input, regex) {
    var match = input.match(regex);
    return match && match.length > 0 || false;
};
var hasImage = function (html) {
    return matchExists(html, /<img[^>]+src=('|")[^'">]+/gm);
};
var hasOpVideo = function (html) {
    return matchExists(html, /<[^>]+data-op-video-id=('|")[^'">]+/gm);
};


/***/ }),

/***/ "c5JT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__infoHeading__ = __webpack_require__("xHHm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__infoItem__ = __webpack_require__("iawT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__infoMap__ = __webpack_require__("TyI8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__("SLLz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};






var Info = /** @class */ (function (_super) {
    __extends(Info, _super);
    function Info() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Info.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_5__styles_css__["info"], className) }, rest), children));
    };
    Info.Heading = __WEBPACK_IMPORTED_MODULE_2__infoHeading__["a" /* default */];
    Info.Item = __WEBPACK_IMPORTED_MODULE_3__infoItem__["a" /* default */];
    Info.Map = __WEBPACK_IMPORTED_MODULE_4__infoMap__["a" /* default */];
    return Info;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Info);


/***/ }),

/***/ "cRoh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export assign */
/* unused harmony export capitalize */
/* unused harmony export cloneDeep */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compact; });
/* unused harmony export deburr */
/* unused harmony export filter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return find; });
/* unused harmony export flow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return get; });
/* unused harmony export kebabCase */
/* unused harmony export map */
/* unused harmony export omitBy */
/* unused harmony export orderBy */
/* unused harmony export pickBy */
/* unused harmony export range */
/* unused harmony export round */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return trimEnd; });
/* unused harmony export truncate */
/* unused harmony export upperFirst */
var assign = __webpack_require__("BUAs");
var capitalize = __webpack_require__("lGpV");
var cloneDeep = __webpack_require__("kvU2");
var compact = __webpack_require__("C2y9");
var deburr = __webpack_require__("lAob");
var filter = __webpack_require__("RyI1");
var find = __webpack_require__("kbi+");
var flow = __webpack_require__("Kp45");
var get = __webpack_require__("Q7hp");
var kebabCase = __webpack_require__("Ex7i");
var map = __webpack_require__("2247");
var omitBy = __webpack_require__("uN7r");
var orderBy = __webpack_require__("Ba3q");
var pickBy = __webpack_require__("6PBa");
var range = __webpack_require__("tVBY");
var round = __webpack_require__("dAKm");
var trimEnd = __webpack_require__("aQiR");
var truncate = __webpack_require__("GRSR");
var upperFirst = __webpack_require__("xdPp");
var lodash = {
    assign: assign,
    capitalize: capitalize,
    cloneDeep: cloneDeep,
    compact: compact,
    deburr: deburr,
    filter: filter,
    find: find,
    flow: flow,
    get: get,
    kebabCase: kebabCase,
    map: map,
    omitBy: omitBy,
    orderBy: orderBy,
    pickBy: pickBy,
    range: range,
    round: round,
    trimEnd: trimEnd,
    truncate: truncate,
    upperFirst: upperFirst,
};
/* harmony default export */ __webpack_exports__["b"] = (lodash);


/***/ }),

/***/ "dAD3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_reducers_toast__ = __webpack_require__("ZSLX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_reducers_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_reducers_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("Ol7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bookmarks__ = __webpack_require__("JBOk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nearbyPois__ = __webpack_require__("0I6n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user__ = __webpack_require__("FK8g");





var rootReducer = Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({
    bookmarks: __WEBPACK_IMPORTED_MODULE_2__bookmarks__["a" /* default */],
    nearbyPois: __WEBPACK_IMPORTED_MODULE_3__nearbyPois__["a" /* default */],
    toast: __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_reducers_toast___default.a,
    user: __WEBPACK_IMPORTED_MODULE_4__user__["a" /* default */],
});
/* harmony default export */ __webpack_exports__["a"] = (rootReducer);


/***/ }),

/***/ "dieY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_actions_toast__ = __webpack_require__("TRcX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_actions_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_actions_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("Ol7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_text__ = __webpack_require__("s7mA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_utils_lodash__ = __webpack_require__("cRoh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_button__ = __webpack_require__("8zPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_css__ = __webpack_require__("xNQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};










var getPoiUrl = function () { return typeof window !== "undefined" ? window.location.pathname : ""; };
var Header = function (_a) {
    var title = _a.title, type = _a.type, location = _a.location, topChoice = _a.topChoice, className = _a.className, _b = _a.bookmarked, bookmarked = _b === void 0 ? false : _b, _c = _a.isTour, isTour = _c === void 0 ? false : _c, link = _a.link, onClickBookmark = _a.onClickBookmark, showToast = _a.showToast, rest = __rest(_a, ["title", "type", "location", "topChoice", "className", "bookmarked", "isTour", "link", "onClickBookmark", "showToast"]);
    return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("header", __assign({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__(__WEBPACK_IMPORTED_MODULE_9__styles_css__["header"], className) }, rest),
        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_text__["Heading"], { className: __WEBPACK_IMPORTED_MODULE_9__styles_css__["heading"], size: 5, level: 1, weight: "medium" }, title),
        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_text__["a" /* default */].Italic, { className: __WEBPACK_IMPORTED_MODULE_9__styles_css__["italic"] },
            topChoice &&
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_text__["a" /* default */].AccentRed, { element: "em" }, "Top choice"),
            topChoice ? " " + type.toLowerCase() : " " + __WEBPACK_IMPORTED_MODULE_7__shared_utils_lodash__["b" /* default */].upperFirst(type),
            isTour && location && ", " + location,
            !isTour && location && " in " + location),
        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_9__styles_css__["headerButtons"] },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_button__["a" /* Button */].Bookmark, { bookmarked: bookmarked, onClick: onClickBookmark }),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_button__["a" /* Button */].Share, { className: __WEBPACK_IMPORTED_MODULE_9__styles_css__["headerButtonShare"], shareText: title, getPoiUrl: getPoiUrl, showToast: showToast }))));
};
function mapDispatchToProps(dispatch) {
    return {
        showToast: Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_actions_toast__["showToastMessage"], dispatch),
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null, mapDispatchToProps)(Header));


/***/ }),

/***/ "duHJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.filterPlaceTypes = function (p) { return (p.placeType !== "region" &&
    p.placeType !== "neighborhood" &&
    p.placeType !== "continent"); };


/***/ }),

/***/ "e9aK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiBase; });
/* unused harmony export listRoutes */
/* unused harmony export poisRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return profileRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return blogRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return merchRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bookmarkRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return searchRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return imageTags; });
/**
 * Make sure to prefix any AJAX calls with this API base
 */
var apiBase = "/dot-api/";
var listRoutes = {
    show: "/profile/:username/bookmarks",
};
var poisRoutes = {
    detail: ":slug(.*)?/a/:type/:id/:placeId",
    list: "(.*)?/a/:type-:subtype/:id$",
    lodgingAvailability: apiBase + "lodgings/availability/:lodgingId",
    nearby: apiBase + "pois/:id/nearby",
};
var profileRoutes = {
    show: "/profile/:username",
};
var blogRoutes = {
    previewPost: "/blog/preview/:wordpressId/",
    rss: "/blog/feed/atom",
    show: "/blog",
    showCategory: "/blog/category/:slug/:id?",
    showCategoryLatest: "/blog/latest",
    showPost: "/blog/:year/:month/:day/:slug/:id?",
};
var merchRoutes = {
    show: "/outfitter",
    showAbout: "/outfitter/about",
    showReview: "/outfitter/review/:slug",
};
var bookmarkRoutes = {
    show: "/profile/:username/lists/:listId?",
    showList: "/profile/api/:username/lists",
};
var searchRoutes = {
    searchApi: "/search/api",
    searchAutocomplete: "/search/autocomplete",
    searchClickthrough: "/search/clickthrough",
    show: "/search",
    showJson: "/search.json",
    showLegacy: "/searchResult",
    showPreview: "/search-preview",
};
var imageTags = {
    hotelInfo: "Hotel information",
    main: "main",
};


/***/ }),

/***/ "eF97":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__ = __webpack_require__("UtEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__booking__ = __webpack_require__("P8bB");



var BookingActivity = function (_a) {
    var activityName = _a.activityName, activityType = _a.activityType, discountedPrice = _a.discountedPrice, price = _a.price, url = _a.url, provider = _a.provider, rating = _a.rating;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__booking__["a" /* default */], null,
        price &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__booking__["a" /* default */].Price, { labelBefore: "from", originalPrice: discountedPrice ? price : null }, discountedPrice ? discountedPrice : price),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["AnalyticsEvent"], { render: function (_a) {
                var track = _a.track;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__booking__["a" /* default */].Button, { href: url, onClick: function () {
                        var _a;
                        track((_a = {},
                            _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["analytics"].eventName] = __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["EventNames"].partnerClick,
                            _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["analytics"].bookingDepartureDate] = undefined,
                            _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["analytics"].bookingDestination] = activityName,
                            _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["analytics"].bookingPartner] = provider,
                            _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["analytics"].bookingReturnDate] = undefined,
                            _a[__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_lp_analytics__["analytics"].bookingType] = activityType,
                            _a));
                        track({
                            /**
                             * This is the legacy payload.
                             * Remove once OK to do so.
                             */
                            bookingProvider: provider,
                            event: "activity booking click",
                            "gtm.element": "Booking.Button",
                            "gtm.elementText": "Check prices and availability",
                        });
                    } }, "Check prices and availability"));
            } }),
        rating &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__booking__["a" /* default */].Rating, null, rating),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__booking__["a" /* default */].Provider, { provider: provider })));
};
/* harmony default export */ __webpack_exports__["a"] = (BookingActivity);


/***/ }),

/***/ "ec2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export schemaPrice */
var schemaPrice = function (priceString) {
    var price = priceString
        .replace(/[^0-9]/g, " ")
        .split(" ")
        .filter(function (word) { return word.length > 0; })[0];
    return typeof price !== "undefined" ? price : "";
};


/***/ }),

/***/ "f+9y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("keOT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var Container = function (_a) {
    var children = _a.children, _b = _a.element, element = _b === void 0 ? "div" : _b, className = _a.className, rest = __rest(_a, ["children", "element", "className"]);
    var Component = element;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, __assign({}, rest, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["container"], className) }), children));
};
/* harmony default export */ __webpack_exports__["a"] = (Container);


/***/ }),

/***/ "fb/t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonOutline":"styles__buttonOutline___1di8I"};

/***/ }),

/***/ "gBmD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdUnitSuperzone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_gpt__ = __webpack_require__("v4Eu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_gpt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_gpt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ads__ = __webpack_require__("YIyS");



var AdUnitSuperzone = function (_a) {
    var adUnit = _a.adUnit, targeting = _a.targeting;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_gpt__["Bling"], { adUnitPath: __WEBPACK_IMPORTED_MODULE_2__utils_ads__["h" /* adUnits */][adUnit], sizeMapping: [
            { viewport: __WEBPACK_IMPORTED_MODULE_2__utils_ads__["i" /* adViewports */].mobile, slot: [__WEBPACK_IMPORTED_MODULE_2__utils_ads__["c" /* adMobileRectangle */], __WEBPACK_IMPORTED_MODULE_2__utils_ads__["d" /* adMobileSquare */], __WEBPACK_IMPORTED_MODULE_2__utils_ads__["g" /* adSuperzone */]] },
            { viewport: __WEBPACK_IMPORTED_MODULE_2__utils_ads__["i" /* adViewports */].tablet, slot: [__WEBPACK_IMPORTED_MODULE_2__utils_ads__["c" /* adMobileRectangle */], __WEBPACK_IMPORTED_MODULE_2__utils_ads__["d" /* adMobileSquare */], __WEBPACK_IMPORTED_MODULE_2__utils_ads__["g" /* adSuperzone */]] },
            { viewport: __WEBPACK_IMPORTED_MODULE_2__utils_ads__["i" /* adViewports */].laptop, slot: [__WEBPACK_IMPORTED_MODULE_2__utils_ads__["a" /* adBannerLarge */], __WEBPACK_IMPORTED_MODULE_2__utils_ads__["b" /* adBannerSmall */], __WEBPACK_IMPORTED_MODULE_2__utils_ads__["g" /* adSuperzone */]] },
        ], targeting: Object(__WEBPACK_IMPORTED_MODULE_2__utils_ads__["j" /* generateAdTargeting */])(Object.assign({}, targeting, {
            position: __WEBPACK_IMPORTED_MODULE_2__utils_ads__["e" /* adPositions */].hero,
        })) }));
};


/***/ }),

/***/ "gEgO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkSkip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("+Bcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var LinkSkip = function (_a) {
    var _b = _a.href, href = _b === void 0 ? "#main" : _b, className = _a.className, rest = __rest(_a, ["href", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", __assign({ href: href, className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["linkSkip"], className) }, rest), "Skip to main content"));
};


/***/ }),

/***/ "gO5h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return schemaPriceRange; });
var schemaPriceRange = function (priceRange) {
    if (!priceRange) {
        return "";
    }
    var definitions = {
        budget: "$",
        "mid-range": "$$",
        "top-end": "$$$",
    };
    return definitions[priceRange] || "";
};


/***/ }),

/***/ "gpAu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("9Nd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var TextItalic = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["textItalic"], className) }, rest), children));
};
/* harmony default export */ __webpack_exports__["a"] = (TextItalic);


/***/ }),

/***/ "gyEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return schemaBuilderReview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing_dist_details_constants__ = __webpack_require__("uuxV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing_dist_details_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing_dist_details_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schemaDate__ = __webpack_require__("aadl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schemaDescription__ = __webpack_require__("xpuk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__schemaPlace__ = __webpack_require__("37xT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__schemaPriceRange__ = __webpack_require__("gO5h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__schemaType__ = __webpack_require__("qdOX");






var schemaBuilderReview = function (_a) {
    var poi = _a.poi, canonicalUrl = _a.canonicalUrl;
    var address = poi.address, city = poi.containingCityName, country = poi.containingCountryName, places = poi.containingPlaces, hours = poi.hours, _b = poi.images, images = _b === void 0 ? [] : _b, location = poi.location, name = poi.name, poiType = poi.poiType, priceRange = poi.priceRange, datePublished = poi.publishedAt, review = poi.review, subtypes = poi.subtypes, telephone = poi.telephone, website = poi.website;
    var poiImages = images.length ? images[0].url : "";
    var typeOfSchema = Object(__WEBPACK_IMPORTED_MODULE_5__schemaType__["a" /* schemaType */])(poiType, subtypes) || __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing_dist_details_constants__["poiTypes"][poiType].schemaType || "Place";
    var schemaPlaces = places && places.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_3__schemaPlace__["a" /* schemaPlace */])(places) : {};
    var schemaImage = poiImages;
    var hasCoordinates = location && location.coordinates.length === 2;
    var hasCuisine = poiType === __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing_dist_details_constants__["poiTypes"].eating.name && typeOfSchema !== "GroceryStore";
    var url = canonicalUrl ? "https://www.lonelyplanet.com" + canonicalUrl : "";
    var dates = Object(__WEBPACK_IMPORTED_MODULE_1__schemaDate__["a" /* schemaDate */])(hours);
    var isEvent = typeOfSchema === "Event";
    var schemaAddress = {
        "@type": "PostalAddress",
        addressCountry: country || schemaPlaces.country,
        addressLocality: city || schemaPlaces.city,
        addressRegion: schemaPlaces.region,
        postalCode: "",
        streetAddress: address.street,
    };
    var schemaLocation = {
        "@type": "Place",
        address: schemaAddress,
        name: name,
    };
    var description = (review && review.essential) ?
        Object(__WEBPACK_IMPORTED_MODULE_2__schemaDescription__["a" /* schemaDescription */])(review.essential, poiType) :
        "";
    var schemaReview = {
        "@type": "Review",
        author: {
            "@type": "Organization",
            name: "Lonely Planet",
            sameAs: "https://www.lonelyplanet.com",
        },
        datePublished: datePublished || "",
        description: description,
        inLanguage: "en",
        publisher: {
            "@type": "Organization",
            name: "Lonely Planet",
            sameAs: "https://www.lonelyplanet.com",
        },
        url: url,
    };
    var schema = {
        "@context": "http://schema.org",
        "@id": website || url,
        "@type": typeOfSchema,
        image: schemaImage || "https://s3.amazonaws.com/static-asset/poi-type-" + poiType + ".png",
        name: name,
        priceRange: Object(__WEBPACK_IMPORTED_MODULE_4__schemaPriceRange__["a" /* schemaPriceRange */])(priceRange),
        telephone: (telephone && telephone.national) ?
            (poi.telephone.callingCode || "") + " " + telephone.national : "",
    };
    if (isEvent) {
        schema.description = description;
        schema.endDate = dates.endDate;
        schema.location = schemaLocation;
        schema.startDate = dates.startDate;
    }
    else {
        schema.address = schemaAddress;
        schema.review = schemaReview;
    }
    if (website) {
        schema.sameAs = website;
    }
    if (hasCoordinates && !isEvent) {
        schema.geo = {
            "@type": "GeoCoordinates",
            latitude: location.coordinates[1],
            longitude: location.coordinates[0],
        };
    }
    if (hasCuisine && subtypes && subtypes.length) {
        schema.servesCuisine = subtypes.join(", ");
    }
    return JSON.stringify(schema);
};


/***/ }),

/***/ "hTZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_text__ = __webpack_require__("s7mA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("VFi5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);



var ReviewEssential = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__shared_components_text__["a" /* default */].Article, { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["reviewBodyText"] }, children)));
};
/* harmony default export */ __webpack_exports__["a"] = (ReviewEssential);


/***/ }),

/***/ "hk/D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SchemaReview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_schema__ = __webpack_require__("K49P");


var SchemaReview = function (_a) {
    var poi = _a.poi, canonicalUrl = _a.canonicalUrl;
    var schema = Object(__WEBPACK_IMPORTED_MODULE_1__utils_schema__["a" /* schemaBuilderReview */])({ poi: poi, canonicalUrl: canonicalUrl });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: schema } }));
};


/***/ }),

/***/ "iawT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("SLLz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var InfoItem = function (_a) {
    var children = _a.children, label = _a.label, className = _a.className, rest = __rest(_a, ["children", "label", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["infoItem"], className) }, rest),
        label &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["infoItemLabel"] }, label),
        children));
};
/* harmony default export */ __webpack_exports__["a"] = (InfoItem);


/***/ }),

/***/ "ij64":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export replaceApostrophes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diacritics__ = __webpack_require__("JmeQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diacritics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_diacritics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils_lodash__ = __webpack_require__("cRoh");


function replaceApostrophes(str) {
    return str.replace(/[ʻʼ’‘`´]/g, "'");
}
var removeDiacritics = __WEBPACK_IMPORTED_MODULE_0_diacritics__["remove"];
var cleanQuery = __WEBPACK_IMPORTED_MODULE_1__shared_utils_lodash__["b" /* default */].flow([
    replaceApostrophes,
    removeDiacritics,
    encodeURIComponent,
]);
/* harmony default export */ __webpack_exports__["a"] = (cleanQuery);


/***/ }),

/***/ "j3JE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ListItem":"styles__ListItem___R3ydY","textAnchor":"styles__textAnchor___1Ucw3","textContainer":"styles__textContainer___JSbiH","category":"styles__category___eAy2z","heading":"styles__heading___vDzID","description":"styles__description___308E6","thumbnail":"styles__thumbnail___2buk9","thumbnailAnchor":"styles__thumbnailAnchor___3hxzg","imageRounded":"styles__imageRounded___2UNcm"};

/***/ }),

/***/ "jY5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonOutline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_button__ = __webpack_require__("z7/X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("fb/t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var ButtonOutline = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, rest = __rest(_a, ["children", "className", "onClick"]);
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_button___default.a, __assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["buttonOutline"], className), onClick: onClick, color: "gray", size: "small", border: true, rounded: true }, rest), children));
};


/***/ }),

/***/ "jsBX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getBookmarkListUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showBookmarkSuccessToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return showBookmarkErrorToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return showBookmarkListErrorToast; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_actions_toast__ = __webpack_require__("TRcX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_actions_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_actions_toast__);

var getBookmarkListUrl = function (profileHost, username, listId) { return profileHost + "/profile/" + username + "/lists/" + listId; };
var showBookmarkSuccessToast = function (isBookmarked, profileHost, username, list) {
    var msg = isBookmarked
        ? "Added to " + list.name + "."
        : "Removed from " + list.name + ".";
    var url = getBookmarkListUrl(profileHost, username, list.id);
    return Object(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_actions_toast__["showToastMessage"])(msg, "success", "See list", url);
};
var showBookmarkErrorToast = function (isBookmarked, profileHost, username, list) {
    var msg = isBookmarked
        ? "Failed to add to " + list.name + "."
        : "Failed to remove from " + list.name + ".";
    var url = getBookmarkListUrl(profileHost, username, list.id);
    return Object(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_actions_toast__["showToastMessage"])(msg, "error", "See list", url);
};
var showBookmarkListErrorToast = function (list) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_actions_toast__["showToastMessage"])("Failed to create " + list.name + ".", "error");
};


/***/ }),

/***/ "juIJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__booking__ = __webpack_require__("P8bB");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__booking__["a" /* default */]);


/***/ }),

/***/ "k0gy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("9Nd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__textUppercase__ = __webpack_require__("TvgL");




var TextMeta = function (_a) {
    var children = _a.children, className = _a.className;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__textUppercase__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["textMeta"], className) }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (TextMeta);


/***/ }),

/***/ "k6Fy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__photoGallery__ = __webpack_require__("Lxu2");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__photoGallery__["a" /* default */]);


/***/ }),

/***/ "kJxK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__ = __webpack_require__("AemK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_modal__ = __webpack_require__("Cam2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_multiStep__ = __webpack_require__("t460");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_multiStep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_multiStep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_multiStep_multiStepLogin__ = __webpack_require__("6H7B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_multiStep_multiStepLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_multiStep_multiStepLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_utils_grid__ = __webpack_require__("mY3E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_utils_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_utils_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var AuthModal = /** @class */ (function (_super) {
    __extends(AuthModal, _super);
    function AuthModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onModalClose = _this.onModalClose.bind(_this);
        return _this;
    }
    AuthModal.shouldModalClose = function (currentStep) {
        return (currentStep === 1 || currentStep === 4);
    };
    AuthModal.modalTitle = function () {
        return {
            1: null,
            2: "Sign in / Sign up",
            3: "Sign in / Sign up",
            4: null,
        };
    };
    AuthModal.prototype.onModalClose = function (currentStep, setCurrentStep) {
        var _this = this;
        return AuthModal.shouldModalClose(currentStep) ? function () {
            _this.props.closeModal();
            setCurrentStep(1);
        } : function () {
            setCurrentStep(1);
        };
    };
    AuthModal.prototype.render = function () {
        var _this = this;
        var _a = this.props, authActions = _a.authActions, closeModal = _a.closeModal, isMobile = _a.isMobile;
        return (__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_multiStep__["MultiStepWrapper"], { totalSteps: 4 }, function (currentStep, goToNextStep, goToPreviousStep, setCurrentStep) {
            return (__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_modal___default.a, { isOpen: _this.props.isOpen, leftAction: _this.onModalClose(currentStep, setCurrentStep), leftActionContent: AuthModal.shouldModalClose(currentStep) ?
                    __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__["Close"], { width: 24, height: 24 }) :
                    __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__["ArrowLeft"], { width: 24, height: 24 }), closeModal: function () {
                    closeModal();
                    setCurrentStep(1);
                }, desktopMaxHeight: "650px", desktopWidth: Object(__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_utils_grid__["span"])(6, "static"), title: AuthModal.modalTitle()[currentStep] },
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_multiStep_multiStepLogin___default.a, { currentStep: currentStep, setStep: setCurrentStep, authActions: authActions, showLogo: !isMobile, doneAction: function () { _this.onModalClose(currentStep, setCurrentStep)(); } })));
        }));
    };
    return AuthModal;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AuthModal);


/***/ }),

/***/ "kYuW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkAvatar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_avatar__ = __webpack_require__("ZJCA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("+Bcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var LinkAvatar = function (_a) {
    var imageSrc = _a.imageSrc, className = _a.className, rest = __rest(_a, ["imageSrc", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("a", __assign({}, rest, { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["linkAvatar"], className) }),
        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_avatar___default.a, { src: imageSrc, size: 40 })));
};


/***/ }),

/***/ "kbrp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__ = __webpack_require__("cRoh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__placeTypeUtils__ = __webpack_require__("CEdI");


var isContinent = __WEBPACK_IMPORTED_MODULE_1__placeTypeUtils__["a" /* default */].isContinent, isCountry = __WEBPACK_IMPORTED_MODULE_1__placeTypeUtils__["a" /* default */].isCountry, isCity = __WEBPACK_IMPORTED_MODULE_1__placeTypeUtils__["a" /* default */].isCity, isNeighborhood = __WEBPACK_IMPORTED_MODULE_1__placeTypeUtils__["a" /* default */].isNeighborhood, isRegion = __WEBPACK_IMPORTED_MODULE_1__placeTypeUtils__["a" /* default */].isRegion;
function buildPlaceDimensions(places) {
    if (places === void 0) { places = []; }
    var continent = __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].find(places, isContinent);
    var country = __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].find(places, isCountry);
    var city = __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].find(places, isCity);
    var neighborhood = __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].find(places, isNeighborhood);
    var region = __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].find(places, isRegion);
    var placeDimensions = {
        cd1_Continent: continent ? continent.name : null,
        cd2_Country: country ? country.name : null,
        cd3_City: city ? city.name : null,
        cd4_Neighborhood: neighborhood ? neighborhood.name : null,
        cd5_Region: region ? region.name : null,
        city_atlas_id: city ? city.id : null,
    };
    return placeDimensions;
}
/* harmony default export */ __webpack_exports__["a"] = (buildPlaceDimensions);


/***/ }),

/***/ "kcVI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    gallery: {
        main: {
            1024: {
                height: 416,
                width: 740,
            },
            768: {
                height: 296,
                width: 464,
            },
            480: {
                height: 260,
                width: 600,
            },
            320: {
                height: 140,
                width: 248,
            },
        },
        thumbnail: {
            1024: {
                height: 200,
                width: 204,
            },
            768: {
                height: 68,
                width: 68,
            },
            480: {
                height: 68,
                width: 68,
            },
            320: {
                height: 68,
                width: 68,
            },
        },
    },
    single: {
        main: {
            1024: {
                height: 416,
                width: 960,
            },
            768: {
                height: 296,
                width: 464,
            },
            480: {
                height: 260,
                width: 600,
            },
            320: {
                height: 140,
                width: 320,
            },
        },
    },
});


/***/ }),

/***/ "keOT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___2ya5p"};

/***/ }),

/***/ "kx1O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__info__ = __webpack_require__("c5JT");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__info__["a" /* default */]);


/***/ }),

/***/ "l3hU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_toast__ = __webpack_require__("YVkh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Component = __WEBPACK_IMPORTED_MODULE_1_react__["Component"];
var GlobalToast = /** @class */ (function (_super) {
    __extends(GlobalToast, _super);
    function GlobalToast(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasAnimated: props.visible,
            isVisible: props.visible,
        };
        _this.open = _this.open.bind(_this);
        _this.close = _this.close.bind(_this);
        _this.triggerAnimation = _this.triggerAnimation.bind(_this);
        return _this;
    }
    GlobalToast.prototype.componentDidMount = function () {
        var _a = this.props, message = _a.message, type = _a.type;
        if (message && type) {
            this.triggerAnimation();
        }
    };
    GlobalToast.prototype.triggerAnimation = function () {
        var _this = this;
        this.open();
        setTimeout(function () {
            _this.close();
        }, this.props.duration);
    };
    GlobalToast.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.visible !== this.props.visible) {
            if (nextProps.visible) {
                this.triggerAnimation();
            }
        }
    };
    GlobalToast.prototype.open = function () {
        var _this = this;
        var animationDuration = this.props.animationDuration;
        this.setState({
            isVisible: true,
        });
        setTimeout(function () {
            _this.setState({
                hasAnimated: true,
            });
        }, animationDuration);
    };
    GlobalToast.prototype.close = function () {
        var _this = this;
        var _a = this.props, onClose = _a.onClose, animationDuration = _a.animationDuration;
        this.setState({
            hasAnimated: false,
        });
        setTimeout(function () {
            _this.setState({
                isVisible: false,
            });
            if (onClose && (typeof onClose === "function")) {
                onClose();
            }
        }, animationDuration);
    };
    GlobalToast.prototype.render = function () {
        var _a = this.props, message = _a.message, title = _a.title, type = _a.type, buttonLabel = _a.buttonLabel, url = _a.url;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_toast___default.a, { visible: this.state.hasAnimated, onClose: this.close, direction: "bottom", title: title, buttonLabel: buttonLabel, url: url, type: type, affixed: true }, message));
    };
    return GlobalToast;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (GlobalToast);


/***/ }),

/***/ "lUuM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schema__ = __webpack_require__("YRSo");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__; });




/***/ }),

/***/ "m2mg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnalyticsProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context__ = __webpack_require__("6lmz");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var AnalyticsProvider = /** @class */ (function (_super) {
    __extends(AnalyticsProvider, _super);
    function AnalyticsProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.track = function (payload) {
            _this.trackers.forEach(function (tracker) { return tracker.send(payload); });
        };
        _this.trackers = _this.props.trackers.map(function (Tracker) { return new Tracker(); });
        return _this;
    }
    AnalyticsProvider.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__context__["a" /* Context */].Provider, { value: this.track }, this.props.children));
    };
    return AnalyticsProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));



/***/ }),

/***/ "mAV3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("LOUu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var Divider = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("hr", __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["divider"], className) }, rest)));
};
/* harmony default export */ __webpack_exports__["a"] = (Divider);


/***/ }),

/***/ "mFZ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linkAvatar__ = __webpack_require__("kYuW");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Avatar", function() { return __WEBPACK_IMPORTED_MODULE_0__linkAvatar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linkNavigation__ = __webpack_require__("aVHp");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Navigation", function() { return __WEBPACK_IMPORTED_MODULE_1__linkNavigation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linkShop__ = __webpack_require__("mY+9");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Shop", function() { return __WEBPACK_IMPORTED_MODULE_2__linkShop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linkSkip__ = __webpack_require__("gEgO");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Skip", function() { return __WEBPACK_IMPORTED_MODULE_3__linkSkip__["a"]; });






/***/ }),

/***/ "mRgh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hotelProvider;
function hotelProvider(providers) {
    var booking = providers ? providers.filter(function (provider) {
        return provider.id.includes("bdc");
    }) : [];
    var hostelworld = providers ? providers.filter(function (provider) {
        return provider.id.includes("hw");
    }) : [];
    // Show Booking.com records first
    if (booking.length) {
        return {
            data: booking[0],
            name: "booking.com",
            type: "bdc",
        };
    }
    else if (hostelworld.length) {
        return {
            data: hostelworld[0],
            name: "Hostelworld",
            type: "hostelworld",
        };
    }
    return null;
}


/***/ }),

/***/ "mTna":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buttonOutline__ = __webpack_require__("jY5B");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Outline", function() { return __WEBPACK_IMPORTED_MODULE_0__buttonOutline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buttonBookmark__ = __webpack_require__("M5T4");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Bookmark", function() { return __WEBPACK_IMPORTED_MODULE_1__buttonBookmark__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buttonShare__ = __webpack_require__("oSA5");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Share", function() { return __WEBPACK_IMPORTED_MODULE_2__buttonShare__["a"]; });





/***/ }),

/***/ "mY+9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkShop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__ = __webpack_require__("AemK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_indicator__ = __webpack_require__("oZdA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__("+Bcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};





var LinkShop = function (_a) {
    var _b = _a.hasItems, hasItems = _b === void 0 ? false : _b, _c = _a.href, href = _c === void 0 ? "https://shop.lonelyplanet.com/cart" : _c, className = _a.className, rest = __rest(_a, ["hasItems", "href", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("a", __assign({}, rest, { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["linkShop"], className), href: href, title: "View shopping cart", "aria-label": "View shopping cart" }),
        hasItems &&
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_indicator__["a" /* Indicator */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["linkShopIndicator"], "aria-label": "Shopping cart has items" }),
        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__["Cart"], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["linkShopIcon"] })));
};


/***/ }),

/***/ "mdye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookmarkModalAdd; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_listItemBookmark__ = __webpack_require__("OEi0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_listItemBookmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_listItemBookmark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_modal__ = __webpack_require__("Cam2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_multiStep__ = __webpack_require__("t460");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_multiStep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_multiStep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bookmarkAddEditList__ = __webpack_require__("sueZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bookmarkModalAction__ = __webpack_require__("KlaN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_css__ = __webpack_require__("Xem7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_css__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var BookmarkModalAdd = /** @class */ (function (_super) {
    __extends(BookmarkModalAdd, _super);
    function BookmarkModalAdd(props) {
        var _this = _super.call(this, props) || this;
        _this.onSaveList = function () {
            var bookmarkData = _this.getBookmarkData(_this.props.poi);
            var listData = {
                name: _this.state.name,
                visibility: _this.state.visibility,
            };
            _this.props.updateBookmark(bookmarkData, listData);
            _this.props.toggle();
            _this.props.goToPreviousStep();
            _this.clearListData();
        };
        _this.onListClick = function (bookmark, list) {
            var bookmarkData = _this.getBookmarkData(_this.props.poi, bookmark);
            _this.props.updateBookmark(bookmarkData, list);
            _this.closeModal();
        };
        _this.getBookmarkData = function (poi, bookmark) {
            if (bookmark === void 0) { bookmark = null; }
            return {
                checked: bookmark ? !bookmark.checked : true,
                id: bookmark && bookmark.id,
                note: "",
                target: {
                    id: poi.id,
                    type: poi.type,
                },
            };
        };
        _this.getListImage = function (list) {
            var pois = _this.props.pois;
            if (!pois) {
                return "";
            }
            var entry = list.entries
                .filter(function (en) { return en.checked; })
                .sort(function (a, b) { return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(); })
                .find(function (e) {
                return pois[e.target.type] &&
                    pois[e.target.type][e.target.id] &&
                    pois[e.target.type][e.target.id].images &&
                    pois[e.target.type][e.target.id].images.length;
            });
            if (entry) {
                var images = pois[entry.target.type][entry.target.id].images;
                if (images) {
                    var url = images[0].url
                        .replace(/media.lonelyplanet.com/, "lonelyplanetimages.imgix.net");
                    return url + "?w=78&h=72&fit=crop";
                }
            }
            return "";
        };
        _this.leftAction = function () {
            if (_this.props.currentStep === 1) {
                _this.props.toggle();
            }
            else {
                _this.props.goToPreviousStep();
                _this.clearListData();
            }
        };
        _this.rightAction = function () {
            if (_this.props.currentStep === 1) {
                _this.props.toggle();
            }
            else {
                _this.props.updateBookmark({}, {
                    name: _this.state.name,
                    visibility: _this.state.visibility,
                });
                _this.props.toggle();
                _this.props.goToPreviousStep();
                _this.clearListData();
            }
        };
        _this.rightActionContent = function () {
            var disableSaveButton = _this.state.name === "" || _this.state.name.length < 2;
            if (_this.props.currentStep === 1) {
                return null;
            }
            return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__bookmarkModalAction__["a" /* BookmarkModalAction */], { disabled: disableSaveButton }, "Create"));
        };
        _this.leftActionContent = function () {
            if (_this.props.currentStep === 1) {
                return null;
            }
            return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__bookmarkModalAction__["a" /* BookmarkModalAction */], null, "Cancel"));
        };
        _this.closeModal = function () {
            _this.props.toggle();
            _this.props.setCurrentStep(1);
            _this.clearListData();
        };
        _this.nameChangeHandler = function (event) {
            _this.setState({
                name: event.target.value,
            });
        };
        _this.privacyClickHandler = function () {
            _this.setState({
                visibility: _this.state.visibility === "public" ? "private" : "public",
            });
        };
        _this.clearListData = function () {
            _this.setState({
                name: "",
                visibility: "public",
            });
        };
        _this.state = {
            name: "",
            visibility: "public",
        };
        return _this;
    }
    BookmarkModalAdd.prototype.render = function () {
        var _this = this;
        var _a = this.props, currentStep = _a.currentStep, goToNextStep = _a.goToNextStep, isOpen = _a.isOpen, lists = _a.lists, poi = _a.poi;
        var disableSaveButton = this.state.name === "" || this.state.name.length < 2;
        var hasLists = lists && Object.keys(lists).length > 0;
        var visibility = {
            private: "Private",
            public: "Public",
        };
        var listIds = hasLists ? Object.keys(lists) : [];
        var title = {
            step1: "Save to list",
            step2: "New list",
        };
        return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_modal___default.a, { className: __WEBPACK_IMPORTED_MODULE_3_classnames__("BookmarkListModal", __WEBPACK_IMPORTED_MODULE_7__styles_css__["bookmarkModal"], currentStep === 1 && __WEBPACK_IMPORTED_MODULE_7__styles_css__["bookmarkModalStep1"]), isOpen: isOpen, rightAction: this.rightAction, rightActionContent: this.rightActionContent(), rightActionDisabled: (currentStep === 1) ? false : disableSaveButton, leftAction: this.leftAction, leftActionContent: this.leftActionContent(), closeModal: this.closeModal, title: (currentStep === 1) ? title.step1 : title.step2, disableContentPadding: true, showTitle: true },
            __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_multiStep__["MultiStep"], { currentStep: currentStep, style: { height: "100%" } },
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { style: { height: "100%" }, key: title.step1 },
                    hasLists && listIds.map(function (listId, index) {
                        var list = _this.props.lists[listId];
                        var bookmark;
                        var entriesCount = 0;
                        var listImage = "";
                        if (list.entries && list.entries.length > 0) {
                            bookmark = list.entries.find(function (e) { return e.target.id === poi.id; });
                            entriesCount = list.entries.filter(function (e) { return e.checked; }).length;
                            listImage = _this.getListImage(list);
                        }
                        return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_listItemBookmark___default.a, { key: listId, name: list.name, thumbnail: listImage, entriesCount: entriesCount, visibility: visibility[list.visibility], onClick: function () { return _this.onListClick(bookmark, list); }, checked: bookmark && bookmark.checked }));
                    }),
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_listItemBookmark___default.a, { key: "New list", name: "New list", onClick: goToNextStep, hideDetail: true, addItem: true })),
                __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", { style: { height: "100%" }, key: title.step2 },
                    __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__bookmarkAddEditList__["a" /* BookmarkAddEditList */], { nameOnChange: this.nameChangeHandler, nameValue: this.state.name, privacyToggle: this.privacyClickHandler, privacyChecked: this.state.visibility === "public", onSave: this.onSaveList, onCancel: this.leftAction, disableSaveButton: disableSaveButton })))));
    };
    return BookmarkModalAdd;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]));



/***/ }),

/***/ "meXs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"booking":"styles__booking___2ksaN","bookingPrice":"styles__bookingPrice___2XSj1","bookingPriceAmount":"styles__bookingPriceAmount___3zEfs","bookingPriceLabel":"styles__bookingPriceLabel___b_bek","bookingPriceLabelBefore":"styles__bookingPriceLabelBefore___3gWTk","bookingPriceLabelAfter":"styles__bookingPriceLabelAfter___23rU5","bookingOriginalPriceAmount":"styles__bookingOriginalPriceAmount___24tAJ","bookingButton":"styles__bookingButton___2KwwX","bookingRating":"styles__bookingRating___onore","bookingProvider":"styles__bookingProvider___2Vmsh","bookingProviderLogo":"styles__bookingProviderLogo___btOLW"};

/***/ }),

/***/ "myoS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__container__ = __webpack_require__("f+9y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templateArea__ = __webpack_require__("vqre");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__templatePosition__ = __webpack_require__("B6TH");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Template = /** @class */ (function (_super) {
    __extends(Template, _super);
    function Template() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Template.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: className },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__container__["a" /* default */], null, children)));
    };
    Template.Area = __WEBPACK_IMPORTED_MODULE_2__templateArea__["a" /* default */];
    Template.Position = __WEBPACK_IMPORTED_MODULE_3__templatePosition__["a" /* default */];
    return Template;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Template);


/***/ }),

/***/ "n5Zo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receivedNearbyPois", function() { return receivedNearbyPois; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchNearbyPois", function() { return fetchNearbyPois; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_constants__ = __webpack_require__("e9aK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils_requests__ = __webpack_require__("zuOK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__("JHeX");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;



var receivedNearbyPois = function (nearbyPois) { return ({
    payload: {
        nearbyPois: nearbyPois,
    },
    type: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["b" /* RECEIVED_NEARBY_POIS */],
}); };
var fetchNearbyPois = function (poiId) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var nearbyPois;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils_requests__["a" /* get */])(__WEBPACK_IMPORTED_MODULE_0__shared_constants__["a" /* apiBase */] + "pois/" + poiId + "/nearby")];
            case 1:
                nearbyPois = _a.sent();
                return [2 /*return*/, dispatch(receivedNearbyPois(nearbyPois))];
        }
    });
}); }; };


/***/ }),

/***/ "nYNN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__ = __webpack_require__("Jg0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opTypeMapping__ = __webpack_require__("97Rg");


/**
 * Get the category label for a search result
 * @param result {ISearch} The search result
 */
var getResultCategory = function (result) {
    var opType = result.opType, poiSubtypes = result.poiSubtypes, parentName = result.parentName;
    if (opType === __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__["poi"] && poiSubtypes && parentName) {
        return parentName + " | " + poiSubtypes.join(",");
    }
    else if (opType === __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__["poi"] && poiSubtypes) {
        return poiSubtypes.join(",");
    }
    else if (opType === __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__["place"] && parentName) {
        return parentName;
    }
    else if (parentName) {
        return parentName + " | " + __WEBPACK_IMPORTED_MODULE_1__opTypeMapping__["a" /* opTypeMapping */][opType];
    }
    else {
        return __WEBPACK_IMPORTED_MODULE_1__opTypeMapping__["a" /* opTypeMapping */][opType] || "";
    }
};
/* harmony default export */ __webpack_exports__["a"] = (getResultCategory);


/***/ }),

/***/ "o6zn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__ = __webpack_require__("cRoh");

var addItemToFacilitiesGroup = function (title, item, groups) {
    var group = __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].find(groups, function (i) { return i.title === title; });
    if (group) {
        group.items.push(__WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].upperFirst(item));
    }
    else {
        groups.push({
            items: [__WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].upperFirst(item)],
            title: title,
        });
    }
    return groups;
};
var lodgingFacilities = function (facilities) {
    return facilities.reduce(function (memo, accItem) {
        switch (accItem) {
            case "pets allowed":
                memo.push({
                    items: ["Pets are allowed. Charges may apply."],
                    title: "Pets",
                });
                break;
            case "fitness centre":
            case "indoor pool (all year)":
            case "indoor pool":
            case "sauna":
            case "spa and wellness centre":
            case "massage":
            case "hot tub/jacuzzi":
            case "outdoor pool (seasonal)":
            case "outdoor pool":
            case "golf course (within 3 km)":
                addItemToFacilitiesGroup("Activities", accItem, memo);
                break;
            case "free wifi":
                memo.push({
                    items: ["Free WiFi available"],
                    title: "Internet",
                });
                break;
            case "private parking":
            case "valet parking":
                addItemToFacilitiesGroup("Parking", accItem, memo);
                break;
            case "restaurant":
            case "bar":
            case "restaurant (buffet)":
            case "restaurant (à la carte)":
                addItemToFacilitiesGroup("Food and drink", accItem, memo);
                break;
            case "room service":
            case "dry cleaning":
            case "business centre":
            case "luggage storage":
            case "24-hour front desk":
            case "fax/photocopying":
            case "express check-in/check-out":
            case "meeting/banquet facilities":
            case "vip room facilities":
            case "shoeshine":
            case "airport shuttle (surcharge)":
            case "airport shuttle (free)":
            case "shuttle service (surcharge)":
            case "concierge service":
            case "car hire":
            case "ironing service":
            case "laundry":
            case "daily maid service":
                addItemToFacilitiesGroup("Services", accItem, memo);
                break;
            case "newspapers":
            case "vending machine (drinks)":
            case "safety deposit box":
            case "atm/cash machine on site":
            case "non-smoking rooms":
            case "facilities for disabled guests":
            case "non-smoking throughout":
            case "air conditioning":
            case "heating":
            case "lift":
                addItemToFacilitiesGroup("General", accItem, memo);
                break;
            default:
                addItemToFacilitiesGroup("Other", accItem, memo);
                break;
        }
        return memo;
    }, []);
};
/* harmony default export */ __webpack_exports__["a"] = (lodgingFacilities);


/***/ }),

/***/ "oSA5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonShare; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_bookmarkListMenu__ = __webpack_require__("CTMf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_bookmarkListMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_bookmarkListMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_bookmarkListMenu_option__ = __webpack_require__("0wDe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_bookmarkListMenu_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_bookmarkListMenu_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_icon__ = __webpack_require__("AemK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_shareMenu_shareSettings__ = __webpack_require__("kl/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_shareMenu_shareSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_shareMenu_shareSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__buttonOutline__ = __webpack_require__("jY5B");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var ButtonShare = /** @class */ (function (_super) {
    __extends(ButtonShare, _super);
    function ButtonShare() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shareContent = {
            text: "",
            twitterContent: "",
            url: "",
            via: "",
        };
        return _this;
    }
    ButtonShare.prototype.componentDidMount = function () {
        var _a = this.props, shareText = _a.shareText, getPoiUrl = _a.getPoiUrl;
        this.shareContent = {
            text: shareText,
            twitterContent: "Check out the " + shareText + " via @lonelyplanet https://www.lonelyplanet.com" + getPoiUrl(),
            url: "https://www.lonelyplanet.com" + getPoiUrl(),
            via: "lonelyplanet",
        };
    };
    ButtonShare.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, showToast = _a.showToast;
        return (__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_bookmarkListMenu___default.a, { iconName: "Share", iconLabel: "Share", button: __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__buttonOutline__["a" /* ButtonOutline */], { className: __WEBPACK_IMPORTED_MODULE_4_classnames__(className) },
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_icon__["Share"], null),
                " Share") },
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_shareMenu_shareSettings___default.a, { shareContent: this.shareContent, handleClipboardSuccess: function () { return showToast("Sucessfully copied to clipboard"); }, handleClipboardError: function () { return showToast("There was an error, please copy URL manually", "error"); } }, function (shareActions, __, ClipboardWrapper) { return (__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("span", null,
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_bookmarkListMenu_option___default.a, { onClick: function () { return shareActions.twitter(); } }, "Share on Twitter"),
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_bookmarkListMenu_option___default.a, { onClick: function () { return shareActions.facebook(); } }, "Share on Facebook"),
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](ClipboardWrapper, { text: _this.shareContent.url },
                    __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_bookmarkListMenu_option___default.a, { onClick: function () { return null; } }, "Copy link")))); })));
    };
    return ButtonShare;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]));



/***/ }),

/***/ "oZdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Indicator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("HLH5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var Indicator = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", __assign({}, rest, { viewBox: "0 0 8 8", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["indicator"], className) }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { fill: "currentColor", cx: "4", cy: "4", r: "4" })));
};


/***/ }),

/***/ "okSK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receivedBookmarkLists", function() { return receivedBookmarkLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receivedNewBookmark", function() { return receivedNewBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receivedUpdatedBookmark", function() { return receivedUpdatedBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receivedNewListAndBookmark", function() { return receivedNewListAndBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createBookmarkFetch", function() { return createBookmarkFetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createListFetch", function() { return createListFetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchBookmarkLists", function() { return fetchBookmarkLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createBookmark", function() { return createBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateBookmark", function() { return updateBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createListAndAddBookmark", function() { return createListAndAddBookmark; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("sTbe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils_requests__ = __webpack_require__("zuOK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_toasts__ = __webpack_require__("jsBX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__("JHeX");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;




var receivedBookmarkLists = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* RECEIVED_BOOKMARK_LISTS */], function (bookmarkResponse, poiId) { return ({
    bookmarkResponse: bookmarkResponse,
    poiId: poiId,
}); });
var receivedNewBookmark = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* RECEIVED_NEW_BOOKMARK */], function (newBookmark, listId, poi) { return ({
    listId: listId,
    newBookmark: newBookmark,
    poi: poi,
}); });
var receivedUpdatedBookmark = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* RECEIVED_UPDATED_BOOKMARK */], function (updatedBookmark, listId, poiId) { return ({
    listId: listId,
    poiId: poiId,
    updatedBookmark: updatedBookmark,
}); });
var receivedNewListAndBookmark = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* RECEIVED_NEW_LIST_AND_BOOKMARK */], function (newList, newBookmark, poi) { return ({
    newBookmark: newBookmark,
    newList: newList,
    poi: poi,
}); });
var createBookmarkFetch = function (profileHost, userId, listId, bookmarkData) { return __awaiter(_this, void 0, void 0, function () {
    var url, list;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = profileHost + "/profile/api/" + userId + "/lists/" + listId + "/entries";
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils_requests__["c" /* post */])(url, bookmarkData)];
            case 1:
                list = _a.sent();
                return [2 /*return*/, list];
        }
    });
}); };
var createListFetch = function (profileHost, userId, listData) { return __awaiter(_this, void 0, void 0, function () {
    var list;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils_requests__["c" /* post */])(profileHost + "/profile/api/" + userId + "/lists", listData)];
            case 1:
                list = _a.sent();
                return [2 /*return*/, list];
        }
    });
}); };
var fetchBookmarkLists = function (profileHost, userId, poiId) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var bookmarkResponse, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils_requests__["a" /* get */])(profileHost + "/profile/api/" + userId + "/lists.json")];
            case 1:
                bookmarkResponse = _a.sent();
                return [2 /*return*/, dispatch(receivedBookmarkLists(bookmarkResponse, poiId))];
            case 2:
                e_1 = _a.sent();
                return [2 /*return*/, dispatch(receivedBookmarkLists(e_1))];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var createBookmark = function (profileHost, user, list, bookmarkData, poi) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var bookmark, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, createBookmarkFetch(profileHost, user.id, list.id, bookmarkData)];
            case 1:
                bookmark = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__utils_toasts__["c" /* showBookmarkSuccessToast */])(true, profileHost, user.username, list));
                return [2 /*return*/, dispatch(receivedNewBookmark(bookmark, list.id, poi))];
            case 2:
                e_2 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__utils_toasts__["a" /* showBookmarkErrorToast */])(true, profileHost, user.username, list));
                return [2 /*return*/, dispatch(receivedNewBookmark(e_2))];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var updateBookmark = function (profileHost, user, list, bookmarkData, poiId) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var url, isBookmarked, bookmark, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = profileHost + "/profile/api/" + user.id + "/lists/" + list.id + "/entries/" + bookmarkData.id;
                isBookmarked = bookmarkData.checked;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils_requests__["b" /* patch */])(url, bookmarkData)];
            case 2:
                bookmark = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__utils_toasts__["c" /* showBookmarkSuccessToast */])(isBookmarked, profileHost, user.username, list));
                return [2 /*return*/, dispatch(receivedUpdatedBookmark(bookmark, list.id, poiId))];
            case 3:
                e_3 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__utils_toasts__["a" /* showBookmarkErrorToast */])(isBookmarked, profileHost, user.username, list));
                return [2 /*return*/, dispatch(receivedUpdatedBookmark(e_3))];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var createListAndAddBookmark = function (profileHost, user, listData, bookmarkData, poi) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var list, bookmark, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                list = listData;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, createListFetch(profileHost, user.id, listData)];
            case 2:
                list = _a.sent();
                return [4 /*yield*/, createBookmarkFetch(profileHost, user.id, list.id, bookmarkData)];
            case 3:
                bookmark = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__utils_toasts__["c" /* showBookmarkSuccessToast */])(true, profileHost, user.username, list));
                return [2 /*return*/, dispatch(receivedNewListAndBookmark(list, bookmark, poi))];
            case 4:
                e_4 = _a.sent();
                if (!list.id) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__utils_toasts__["b" /* showBookmarkListErrorToast */])(list));
                }
                else {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__utils_toasts__["a" /* showBookmarkErrorToast */])(true, profileHost, user.username, list));
                }
                return [2 /*return*/, dispatch(receivedNewListAndBookmark(e_4))];
            case 5: return [2 /*return*/];
        }
    });
}); }; };


/***/ }),

/***/ "opmm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export attributionCopy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("RoZr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils_image__ = __webpack_require__("txaO");




var attributionCopy = "Image by";
var HeroAttribution = function (_a) {
    var _b = _a.attributions, attributions = _b === void 0 ? [] : _b, className = _a.className;
    var formattedAttribution = Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils_image__["a" /* formatAttributions */])(attributions);
    var attributionDisplay = formattedAttribution ? attributionCopy + " " + formattedAttribution : "";
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["heroAttribution"], className) }, attributionDisplay));
};
/* harmony default export */ __webpack_exports__["a"] = (HeroAttribution);


/***/ }),

/***/ "otJW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("uYDL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var AdLabel = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({}, rest, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["adLabel"], className) }), children));
};


/***/ }),

/***/ "p6kL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receivedUser", function() { return receivedUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUser", function() { return fetchUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_userLogin__ = __webpack_require__("uZtB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__("JHeX");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;


var userStatus = new __WEBPACK_IMPORTED_MODULE_0__services_userLogin__["a" /* default */]();
var receivedUser = function (user) { return ({
    payload: {
        user: user,
    },
    type: __WEBPACK_IMPORTED_MODULE_1__actionTypes__["f" /* RECEIVED_USER_LOGIN */],
}); };
var fetchUser = function (authHost) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var user;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, userStatus.fetch(authHost)];
            case 1:
                user = _a.sent();
                return [2 /*return*/, dispatch(receivedUser(user))];
        }
    });
}); }; };


/***/ }),

/***/ "q4XW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("Fvjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var DescriptionColumns = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["descriptionColumns"], className) }, rest), children));
};
/* harmony default export */ __webpack_exports__["a"] = (DescriptionColumns);


/***/ }),

/***/ "qdOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return schemaType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing_dist_details_constants__ = __webpack_require__("uuxV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing_dist_details_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing_dist_details_constants__);
var _a;

var keys = {
    drinking_nightlife: "drinking_nightlife",
    eating: "eating",
    sleeping: "sleeping",
};
var types = (_a = {},
    _a[keys.drinking_nightlife] = {
        Brewery: "Brewery",
        Cafe: "CafeOrCoffeeShop",
        Club: "NightClub",
        Coffee: "CafeOrCoffeeShop",
        Distillery: "Distillery",
        Juice: "FoodEstablishment",
        "Juice Bar": "FoodEstablishment",
        Karaoke: "EntertainmentBusiness",
        Microbrewery: "Brewery",
        Teahouse: "CafeOrCoffeeShop",
        Vineyard: "Winery",
        Winery: "Winery",
    },
    _a[keys.eating] = {
        Bakery: "Bakery",
        Cafe: "CafeOrCoffeeShop",
        "Fast Food": "FastFoodRestaurant",
        "Ice Cream": "IceCreamShop",
        Market: "GroceryStore",
        Pastries: "Bakery",
        Patisserie: "Bakery",
        Supermarket: "GroceryStore",
    },
    _a[keys.sleeping] = {
        "2 star hotel": "Hotel",
        "3 star hotel": "Hotel",
        "4 star hotel": "Hotel",
        "5 star hotel": "Hotel",
        apartment: "Apartment",
        "b&b": "BedAndBreakfast",
        "bed and breakfast": "BedAndBreakfast",
        "boutique hotel": "Hotel",
        campground: "Campground",
        "historic hotel": "Hotel",
        hostel: "Hostel",
        hotel: "Hotel",
        motel: "Motel",
        residence: "Residence",
        resort: "Resort",
    },
    _a);
var schemaType = function (type, subtypes) {
    var typeOfPoi = types[type];
    if (typeof typeOfPoi === "undefined") {
        return "";
    }
    if (typeOfPoi && typeof typeOfPoi[subtypes[0]] === "undefined") {
        return __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing_dist_details_constants__["poiTypes"][type].schemaType;
    }
    return typeOfPoi[subtypes[0]];
};


/***/ }),

/***/ "qtSn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    article: {
        height: 160,
        width: 108,
    },
    lodging: {
        height: 104,
        width: 170,
    },
    partner_activity: {
        height: 104,
        width: 170,
    },
    place: {
        height: 170,
        width: 170,
    },
    poi: {
        height: 104,
        width: 170,
    },
    thorntree: {
        height: 78,
        width: 78,
    },
    unknown: {
        height: 104,
        width: 170,
    },
});


/***/ }),

/***/ "rDgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_containers_dataLayer__ = __webpack_require__("sxtG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_routing_dist_create__ = __webpack_require__("OxjI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_routing_dist_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_routing_dist_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lonelyplanet_dotcom_routing_dist_details_constants__ = __webpack_require__("uuxV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lonelyplanet_dotcom_routing_dist_details_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lonelyplanet_dotcom_routing_dist_details_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lonelyplanet_travel_agent_dist_helmet__ = __webpack_require__("OH7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lonelyplanet_travel_agent_dist_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lonelyplanet_travel_agent_dist_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_ad__ = __webpack_require__("W0rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_panel__ = __webpack_require__("35nR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_template__ = __webpack_require__("Pjik");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_patterns_breadcrumbs__ = __webpack_require__("8SFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_utils_lodash__ = __webpack_require__("cRoh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_utils_slug__ = __webpack_require__("sn/o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_map_mapInteractiveAsync__ = __webpack_require__("tgVK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_suggestEdit__ = __webpack_require__("C+Uo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__patterns_activities__ = __webpack_require__("PqV5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__patterns_header__ = __webpack_require__("dieY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__patterns_hero__ = __webpack_require__("D6q0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__patterns_info__ = __webpack_require__("kx1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__patterns_review__ = __webpack_require__("CUEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__patterns_tour__ = __webpack_require__("tEfT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_pois_css__ = __webpack_require__("YLLQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_pois_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_pois_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__templates_detail__ = __webpack_require__("tpip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_createAdTargeting__ = __webpack_require__("5HWx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_formatAddressExtras__ = __webpack_require__("M0Qt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_heroImageSizes__ = __webpack_require__("kcVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_providerLinkBuilder__ = __webpack_require__("Virx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_showDetailsSection__ = __webpack_require__("BIrW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__shared_components_divider__ = __webpack_require__("mAV3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__ = __webpack_require__("UtEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__patterns_tags_index__ = __webpack_require__("wNbw");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






























var PagePoi = function (_a) {
    var poi = _a.poi, related = _a.related, tour = _a.tour, tags = _a.tags, breadcrumbs = _a.breadcrumbs, isDOM = _a.isDOM, dataLayer = _a.dataLayer, nearbyMapMarkers = _a.nearbyMapMarkers, bookmarked = _a.bookmarked, onClickBookmark = _a.onClickBookmark, location = _a.location, match = _a.match;
    var _b;
    var isTopChoice = poi.poiAttributes &&
        poi.poiAttributes.length &&
        poi.poiAttributes[0].name === "top_choice";
    var hasNearbyPlaces = nearbyMapMarkers && nearbyMapMarkers.length > 0;
    var hasImages = poi.images && poi.images.length > 0;
    var hasMainImageAttributions = hasImages &&
        Array.isArray(poi.images[0].attribution) &&
        poi.images[0].attribution.length > 0;
    var subtype = __WEBPACK_IMPORTED_MODULE_2__lonelyplanet_dotcom_routing_dist_details_constants__["poiTypes"][poi.poiType.toLowerCase()].displayName;
    var metaImage = hasImages ? poi.images[0].url : "";
    var moreTourLink = related.length > 0 && Object(__WEBPACK_IMPORTED_MODULE_25__utils_providerLinkBuilder__["b" /* viatorMoreLink */])(__assign({}, related[0], {
        containingPlaceId: match.params.placeId,
        containingPlaces: poi.containingPlaces,
    }));
    var adTargeting = Object(__WEBPACK_IMPORTED_MODULE_22__utils_createAdTargeting__["a" /* createAdTargeting */])(dataLayer);
    var destinationSubNav = (function () {
        switch (poi.poiType) {
            case "eating":
                return __WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["DestinationSubNavs"].restaurants;
            case "sleeping":
                return __WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["DestinationSubNavs"].hotels;
            default:
                return __WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["DestinationSubNavs"].experiences;
        }
    })();
    var primaryTour = tour && tour[0];
    return (__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__lonelyplanet_travel_agent_dist_helmet__["Helmet"], null,
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("meta", { property: "og:image", content: metaImage }),
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("meta", { className: "swiftype", name: "op-parent-id", "data-type": "string", content: poi.containingCityId }),
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("meta", { className: "swiftype", name: "op-parent-name", "data-type": "string", content: poi.containingCityName }),
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("meta", { className: "swiftype", name: "op-subtype", "data-type": "string", content: subtype }),
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("meta", { className: "swiftype", name: "op-type-poi", "data-type": "integer", content: "100" }),
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("meta", { className: "swiftype", name: "top-choice", "data-type": "integer", content: isTopChoice ? "1" : "0" }),
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("meta", { className: "swiftype", name: "grade", "data-type": "float", content: (poi.lpInternalScore && poi.lpInternalScore.toString()) || "0" }),
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("meta", { className: "swiftype", name: "thumbnail", "data-type": "string", content: metaImage }),
            tags.map(function (tag) { return ([
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("meta", { className: "swiftype", name: "tag", "data-type": "string", content: tag.label }),
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("meta", { className: "swiftype", name: tag.tag_type + "-id", "data-type": "enum", content: tag.tag_id })
            ]); })),
        __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_containers_dataLayer__["a" /* default */], { data: {
                kind: poi.poiType,
                subtypes: poi.subtypes.join(", "),
            } }),
        __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["DataLayerInitializationData"], { data: (_b = {},
                _b[__WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["analytics"].atlasId] = poi.id,
                _b[__WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["analytics"].contentCity] = poi.containingCityName,
                _b[__WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["analytics"].contentContinent] = poi.containingContinentName,
                _b[__WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["analytics"].contentCountry] = poi.containingCountryName,
                _b[__WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["analytics"].contentNeighborhood] = poi.containingNeighborhoodName,
                _b[__WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["analytics"].contentRegion] = poi.containingRegionNames && poi.containingRegionNames.join(", "),
                _b[__WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["analytics"].destinationSubNav] = destinationSubNav,
                _b[__WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["analytics"].poiName] = poi.name,
                _b[__WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["analytics"].poiType] = poi.poiType,
                _b[__WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["analytics"].poiAttributes] = poi.poiAttributes &&
                    poi.poiAttributes.map(function (_a) {
                        var category = _a.category, name = _a.name;
                        return "{ " + category + ": " + name + " }";
                    }).join(", "),
                _b), indexForEntirePayload: 1, scriptWrapperForEntirePayload: __WEBPACK_IMPORTED_MODULE_28__lonelyplanet_lp_analytics__["asyncUserStatusWrapper"] }),
        __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__templates_detail__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "breadcrumbs" },
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__shared_patterns_breadcrumbs__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_20__styles_pois_css__["breadcrumbs"], links: breadcrumbs })),
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "header" },
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__patterns_header__["a" /* default */], { title: poi.name, type: poi.subtypes[0], location: poi.containingPlaceName || poi.containingCityName, topChoice: isTopChoice, bookmarked: bookmarked, onClickBookmark: onClickBookmark, link: location })),
            hasImages &&
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "hero" },
                    poi.images.length === 1 &&
                        __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__patterns_hero__["a" /* default */].Photo, { src: poi.images[0].url, sizes: __WEBPACK_IMPORTED_MODULE_24__utils_heroImageSizes__["a" /* default */].single.main }),
                    poi.images.length > 1 &&
                        __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__patterns_hero__["a" /* default */].Gallery, { images: poi.images.map(function (image) { return image.url; }) })),
            hasMainImageAttributions &&
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "heroAttribution" },
                    __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__patterns_hero__["a" /* default */].Attribution, { attributions: poi.images[0].attribution })),
            poi.review && poi.review.essential &&
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "reviewEssential" },
                    __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__patterns_review__["a" /* default */].Essential, null,
                        __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: poi.review.essential } }))),
            related && related.length > 0 &&
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "callToActionAside" },
                    __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__shared_components_panel__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_backpack_ui_dist_components_text__["Heading"], { size: 5, level: 4, weight: "medium" }, "Tickets & tours"),
                        __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__patterns_activities__["a" /* default */], { data: related, url: moreTourLink, parentActivityName: poi.name, placeId: Object(__WEBPACK_IMPORTED_MODULE_11__shared_utils_slug__["a" /* containingPlaceForRelatedActivities */])(poi.containingPlaces) || match.params.placeId, containingPlaces: poi.containingPlaces }),
                        __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_27__shared_components_divider__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_20__styles_pois_css__["divider"] }))),
            tags && tags.length > 0 &&
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "poiTags" },
                    __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29__patterns_tags_index__["a" /* default */], { data: tags })),
            Object(__WEBPACK_IMPORTED_MODULE_26__utils_showDetailsSection__["a" /* showDetailsSection */])(poi) &&
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "infoLocation" },
                    __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Heading, null, "Details"),
                        (poi.address && poi.address.street) &&
                            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Item, null, poi.address.street),
                        (poi.address && poi.address.extras) &&
                            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"], null, Object(__WEBPACK_IMPORTED_MODULE_23__utils_formatAddressExtras__["a" /* formatAddressExtras */])(poi.address.extras).map(function (item) { return (__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Item, { label: item.label }, item.text)); })),
                        (poi.telephone && poi.telephone.national) &&
                            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Item, null,
                                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("a", { href: "tel:" + (poi.telephone.callingCode || "") +
                                        ("" + poi.telephone.national.replace(/-|\s/g, "")) }, poi.telephone.national)),
                        (poi.emails && poi.emails.length) &&
                            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Item, null, Array.isArray(poi.emails) ? poi.emails[0] : poi.emails),
                        poi.website &&
                            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Item, null,
                                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("a", { href: poi.website }, "Visit website")),
                        poi.hours &&
                            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Item, { label: "Hours" }, poi.hours),
                        poi.price &&
                            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__patterns_info__["a" /* default */].Item, { label: "Price" }, poi.price))),
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "adRail" },
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_ad__["a" /* Ad */].Primary, null,
                    __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_ad__["b" /* AdUnit */].SideRail, { adUnit: "poisRightRail", targeting: adTargeting }))),
            (poi.location && poi.location.coordinates && poi.location.coordinates.length) && hasNearbyPlaces &&
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "map" }, isDOM &&
                    __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_map_mapInteractiveAsync__["a" /* MapInteractiveAsync */], { center: {
                            coordinates: poi.location.coordinates.slice(0).reverse(),
                            name: poi.name,
                        }, markers: nearbyMapMarkers })),
            poi.review && poi.review.extension &&
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "reviewExtension" },
                    __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__patterns_review__["a" /* default */].Extension, null,
                        __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: poi.review.extension } }))),
            primaryTour && (__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "tour" },
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__patterns_tour__["a" /* default */], { image: Object(__WEBPACK_IMPORTED_MODULE_10__shared_utils_lodash__["d" /* get */])(primaryTour, "images[0].url") || "", title: primaryTour.name, duration: Object(__WEBPACK_IMPORTED_MODULE_10__shared_utils_lodash__["d" /* get */])(primaryTour, "duration.duration") + " " + Object(__WEBPACK_IMPORTED_MODULE_10__shared_utils_lodash__["d" /* get */])(primaryTour, "duration.unit"), destinations: primaryTour.departureInfo + " to " + primaryTour.returnInfo, price: Object(__WEBPACK_IMPORTED_MODULE_10__shared_utils_lodash__["d" /* get */])(primaryTour, "pricing.regularPrice.amount") &&
                        Object(__WEBPACK_IMPORTED_MODULE_10__shared_utils_lodash__["d" /* get */])(primaryTour, "pricing.regularPrice.formattedAmount"), url: __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_dotcom_routing_dist_create__["Urls"].create(__assign({}, primaryTour, { containingPlaces: poi.containingPlaces })) }))),
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "suggestEdit" },
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_suggestEdit__["a" /* default */], { poi: poi, location: location })),
            __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__shared_components_template__["a" /* default */].Position, { area: "adSuperzone" },
                __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_ad__["a" /* Ad */].Bounded, null,
                    __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__shared_components_ad__["b" /* AdUnit */].Superzone, { adUnit: "poisSuperzone", targeting: adTargeting }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (PagePoi);


/***/ }),

/***/ "rRvx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Flyout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("XMAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var Flyout = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({}, rest, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["flyout"], className) }), children));
};


/***/ }),

/***/ "rYHZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("Fvjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var DescriptionColumn = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["descriptionColumn"], className) }, rest), children));
};
/* harmony default export */ __webpack_exports__["a"] = (DescriptionColumn);


/***/ }),

/***/ "rwQh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bookmarkAddEditList__ = __webpack_require__("sueZ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AddEditList", function() { return __WEBPACK_IMPORTED_MODULE_0__bookmarkAddEditList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bookmarkModalAction__ = __webpack_require__("KlaN");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalAction", function() { return __WEBPACK_IMPORTED_MODULE_1__bookmarkModalAction__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bookmarkModalAdd__ = __webpack_require__("mdye");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalAdd", function() { return __WEBPACK_IMPORTED_MODULE_2__bookmarkModalAdd__["a"]; });





/***/ }),

/***/ "s/JD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return poiTypeTitleMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return poiTypeSlugMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return poiKindSlugMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPartnerActivityType; });
/**
 * Maps POI types to friendly SEO names
 */
var poiTypeTitleMap = {
    activities: "activities",
    drinking_nightlife: "nightlife",
    eating: "restaurants",
    entertainment: "entertainment",
    festivals_events: "events",
    info: "information",
    shopping: "shopping",
    sights: "attractions",
    sleeping: "hotels",
    transport: "transportation",
};
/**
 * Map Open Planet Types to abbreviations
 */
var poiTypeSlugMap = {
    articles: "art",
    collections: "col",
    lodging: "lod",
    narrative: "nar",
    partner_activity: "pa",
    poi: "poi",
};
/**
 * We use "kind" to describe the second half of the types in the url
 * e.g. poi-sig, pa-tou
 */
var poiKindSlugMap = {
    activities: "act",
    drinking_nightlife: "dri",
    eating: "eat",
    entertainment: "ent",
    festivals_events: "fes",
    info: "inf",
    shopping: "sho",
    sights: "sig",
    tours: "tou",
    transport: "tra",
};
/**
 * Determine whether a given partner activity should be listed as tour or activity
 */
var getPartnerActivityType = function (duration, type) {
    if (type === void 0) { type = "plural"; }
    if (!duration) {
        return "";
    }
    var isActivity = duration.unit !== "days";
    var isTour = duration.unit === "days" && duration.duration > 3;
    if (isActivity) {
        return type === "singular" ? "activity" : "activities";
    }
    if (isTour) {
        return type === "singular" ? "tour" : "tours";
    }
    return type === "singular" ? "activity" : "activities";
};


/***/ }),

/***/ "s7mA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__text__ = __webpack_require__("AEBA");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__text__["a" /* default */]);


/***/ }),

/***/ "sbiH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdUnitSideRail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_gpt__ = __webpack_require__("v4Eu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_gpt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_gpt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ads__ = __webpack_require__("YIyS");



var AdUnitSideRail = function (_a) {
    var adUnit = _a.adUnit, targeting = _a.targeting;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_gpt__["Bling"], { adUnitPath: __WEBPACK_IMPORTED_MODULE_2__utils_ads__["h" /* adUnits */][adUnit], sizeMapping: [
            { viewport: __WEBPACK_IMPORTED_MODULE_2__utils_ads__["i" /* adViewports */].mobile, slot: [__WEBPACK_IMPORTED_MODULE_2__utils_ads__["c" /* adMobileRectangle */], __WEBPACK_IMPORTED_MODULE_2__utils_ads__["d" /* adMobileSquare */], __WEBPACK_IMPORTED_MODULE_2__utils_ads__["g" /* adSuperzone */]] },
            { viewport: __WEBPACK_IMPORTED_MODULE_2__utils_ads__["i" /* adViewports */].tablet, slot: [__WEBPACK_IMPORTED_MODULE_2__utils_ads__["d" /* adMobileSquare */], __WEBPACK_IMPORTED_MODULE_2__utils_ads__["g" /* adSuperzone */]] },
            { viewport: __WEBPACK_IMPORTED_MODULE_2__utils_ads__["i" /* adViewports */].laptop, slot: [__WEBPACK_IMPORTED_MODULE_2__utils_ads__["d" /* adMobileSquare */], __WEBPACK_IMPORTED_MODULE_2__utils_ads__["f" /* adSkyScraper */]] },
        ], targeting: Object(__WEBPACK_IMPORTED_MODULE_2__utils_ads__["j" /* generateAdTargeting */])(Object.assign({}, targeting, {
            position: __WEBPACK_IMPORTED_MODULE_2__utils_ads__["e" /* adPositions */].sideRail,
        })) }));
};


/***/ }),

/***/ "seTe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setupGlobalComponents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__patterns_global_header__ = __webpack_require__("xyyh");



var components = [
    ["global-header-container", __WEBPACK_IMPORTED_MODULE_2__patterns_global_header__["a" /* GlobalHeader */]],
];
var setupGlobalComponents = function () {
    for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
        var _a = components_1[_i], id = _a[0], Component = _a[1];
        Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["hydrate"])(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component, null), document.getElementById(id));
    }
};


/***/ }),

/***/ "sn/o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createSlug */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPoiListSlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createSuggestEditSlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPlaceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return containingPlaceForRelatedActivities; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__ = __webpack_require__("Jg0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils_lodash__ = __webpack_require__("cRoh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__poi__ = __webpack_require__("s/JD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__string__ = __webpack_require__("bwFx");




/**
 * Take an array of strings, clean it up, and convert it to a slug
 * @example
 * ```ts
 * createSlug(["usa", "nashville", "attractions"])
 * ```
 */
function createSlug(parts) {
    return "/" + parts.map(function (part) { return Object(__WEBPACK_IMPORTED_MODULE_3__string__["b" /* cleanString */])(part); }).join("/");
}
/**
 * Creates a slug for the list pages
 */
var createPoiListSlug = function (poi, ancestry) {
    var country = getPlaceType(ancestry, "country");
    var city = getPlaceType(ancestry, "city");
    var region = getPlaceType(ancestry, "region");
    var partnerActivityType = poi.type === __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_open_planet_node_dist_openPlanetTypes__["partnerActivity"] && Object(__WEBPACK_IMPORTED_MODULE_2__poi__["a" /* getPartnerActivityType */])(poi.duration);
    var seoFriendlyType = poi.poiType
        ? __WEBPACK_IMPORTED_MODULE_2__poi__["d" /* poiTypeTitleMap */][poi.poiType]
        : partnerActivityType;
    var abbreviatedType = __WEBPACK_IMPORTED_MODULE_2__poi__["c" /* poiTypeSlugMap */][poi.type];
    var poiKind = __WEBPACK_IMPORTED_MODULE_2__poi__["b" /* poiKindSlugMap */][poi.poiType || partnerActivityType];
    var locationList = [country && country.name, city && city.name].filter(function (x) { return x; });
    var locationListRegion = [region && region.name].filter(function (x) { return x; });
    var locationSection = city && country ? createSlug(locationList) : createSlug(locationListRegion);
    var placeId = (city && city.id) || (country && country.id) || (region && region.id);
    return locationSection + "/" + seoFriendlyType + "/a/" + abbreviatedType + (poiKind ? "-" + poiKind : "") + "/" + placeId;
};
var createSuggestEditSlug = function (poi, location) {
    var country = poi.containingCountryName || getPlaceType(poi.containingPlaces, "country");
    var city = poi.containingCityName ||
        getPlaceType(poi.containingPlaces, "city") ||
        poi.containingPlaceName;
    var neighborhood = getPlaceType(poi.containingPlaces, "neighborhood");
    var businessListingCity = (city && country) ? city + ", " + country : city;
    var placeFullName = getPlaceFullName(poi.containingPlaces);
    var baseUrl = "http://www.lonelyplanet.com/contact/business_listings/new_correction";
    var businessListing = {
        business_name: poi.name,
        business_type: poi.poiType,
        city: businessListingCity || "Not Provided",
        email: "",
        neighbourhood: neighborhood ? neighborhood.name : "",
        operating_hours: poi.hours || "",
        place_full_name: placeFullName.join(" -> "),
        place_id: poi.containingPlaceId || "",
        poi_id: poi.id,
        postal_code: "",
        street: poi.address.street || "",
        telephone: (poi.telephone && poi.telephone.national) || "",
        typical_prices: poi.price,
        website: poi.url || poi.website || "",
    };
    var urlParams = Object.keys(businessListing).map(function (param) {
        return encodeURIComponent("business_listing[" + param + "]") + "=" + encodeURIComponent(businessListing[param]);
    });
    var poiUrl = encodeURIComponent("http://www.lonelyplanet.com" + location);
    urlParams.push("poi_url=" + poiUrl);
    return baseUrl + "?" + urlParams.join("&");
};
var getPlaceFullName = function (ancestry) {
    if (ancestry === void 0) { ancestry = []; }
    return ancestry.map(function (p) { return p.name; }).reverse();
};
var getPlaceType = function (ancestry, type) {
    return __WEBPACK_IMPORTED_MODULE_1__shared_utils_lodash__["b" /* default */].find(ancestry, function (place) { return place.placeType === type; });
};
var containingPlaceForRelatedActivities = function (places) {
    var city = places.find(function (p) { return p.placeType === "city"; });
    if (city) {
        return city.id;
    }
    var country = places.find(function (p) { return p.placeType === "country"; });
    if (country) {
        return country.id;
    }
    return null;
};


/***/ }),

/***/ "sueZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookmarkAddEditList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_button__ = __webpack_require__("z7/X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_switch__ = __webpack_require__("5gvZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_textarea__ = __webpack_require__("3nRs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__("Xem7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);





var BookmarkAddEditList = function (_a) {
    var disableSaveButton = _a.disableSaveButton, _b = _a.nameValue, nameValue = _b === void 0 ? "" : _b, privacyChecked = _a.privacyChecked, nameOnChange = _a.nameOnChange, onCancel = _a.onCancel, onSave = _a.onSave, privacyToggle = _a.privacyToggle;
    return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["bookmarkAddEditListFieldset"] },
        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("label", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["bookmarkAddEditListLabel"], htmlFor: "list-name" }, "List name"),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_textarea___default.a, { id: "list-name", name: "list_name", placeholder: "List name", onChange: nameOnChange, value: nameValue, maxLines: 3, autofocus: true, autogrow: true })),
        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["bookmarkAddEditListField"] },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["bookmarkAddEditListLabel"] }, "Privacy"),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["bookmarkAddEditListSwitch"] },
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("label", { htmlFor: "privacy-control" }, "Appears in your public profile"),
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_backpack_ui_dist_components_switch___default.a, { id: "privacy-control", name: "privacy_control", value: "private", checked: privacyChecked, onClick: privacyToggle }))),
        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("footer", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["bookmarkAddEditListFieldsetFooter"] },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_button___default.a, { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["bookmarkAddEditListSaveButtonDesktop"], onClick: onCancel, color: "gray", rounded: true, border: true }, "Cancel"),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_button___default.a, { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["bookmarkAddEditListSaveButtonDesktop"], onClick: onSave, disabled: disableSaveButton, rounded: true }, "Save"))));
};


/***/ }),

/***/ "sxtG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reducePropsToState */
/* unused harmony export handleStateChangeOnClient */
/* unused harmony export createDataLayerScript */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_side_effect__ = __webpack_require__("vAAJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_side_effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_side_effect__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var legacyDataLayerInitPayloadIndex = 0;
var reducePropsToState = function (propsList) { return propsList.reduce(function (memo, m) { return (__assign({}, memo, m.data)); }, {}); };
var handleStateChangeOnClient = function (state) {
    if (typeof window !== "undefined" && window.lp && window.lp.analytics && window.lp.analytics.dataLayer) {
        window.lp.analytics.dataLayer[legacyDataLayerInitPayloadIndex] = state;
    }
};
var createDataLayerScript = function (state) { return "\n  window.lp = window.lp || {};\n  window.lp.analytics = window.lp.analytics || {};\n  window.lp.analytics.dataLayer = window.lp.analytics.dataLayer || [];\n  window.lp.analytics.dataLayer[" + legacyDataLayerInitPayloadIndex + "] = " + JSON.stringify(state) + ";\n  " + ( false ? "window.lp.analytics.send = function(options) {\n    console.group(\"GTM\"); console.info(options); console.groupEnd(\"GTM\");\n  }" : "") + "\n  window.dataLayer = window.lp.analytics.dataLayer;\n"; };
var mapStateOnServer = function (state) { return createDataLayerScript(state); };
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_side_effect__(reducePropsToState, handleStateChangeOnClient, mapStateOnServer)(function () { return null; }));


/***/ }),

/***/ "t4Id":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);



/***/ }),

/***/ "tEfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_image__ = __webpack_require__("Mb82");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_text__ = __webpack_require__("s7mA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__("4c3f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};





var Tour = function (_a) {
    var destinations = _a.destinations, duration = _a.duration, image = _a.image, price = _a.price, title = _a.title, url = _a.url, className = _a.className, rest = __rest(_a, ["destinations", "duration", "image", "price", "title", "url", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({ className: className }, rest),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__["Heading"], { size: 6, level: 4, weight: "medium" }, "Related tour"),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["tourAnchor"], href: url },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_components_image__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["tourImage"], width: 630, height: 315, src: image, alt: "" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__["Heading"], { size: 5, level: 3, weight: "medium" }, title),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_text__["a" /* default */].Meta, { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["tourMeta"] },
                duration,
                " \u2022 ",
                destinations),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_text__["a" /* default */].AccentRed, { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["tourPrice"] }, price))));
};
/* harmony default export */ __webpack_exports__["a"] = (Tour);


/***/ }),

/***/ "tW0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildHeadTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__ = __webpack_require__("cRoh");

function buildHeadTitle(poiName, breadcrumbs) {
    var pipe = poiName ? "|" : "";
    var city = (Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["c" /* find */])(breadcrumbs, { placeType: "city" }) || {}).title;
    var country = (Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["c" /* find */])(breadcrumbs, { placeType: "country" }) || {}).title;
    var type = (Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["c" /* find */])(breadcrumbs, { type: "poi" }) || {}).title;
    return Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["e" /* trimEnd */])(Object(__WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["a" /* compact */])([
        poiName,
        pipe,
        (city && country) ? city.concat(",") : city,
        country,
        type,
    ])
        .join(" "));
}


/***/ }),

/***/ "taxX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var pathToRegexp = __webpack_require__("Ygqm");
var filterPlaceTypes_1 = __webpack_require__("duHJ");
var string_1 = __webpack_require__("KPtS");
var constants_1 = __webpack_require__("uuxV");
var routes_1 = __webpack_require__("xY00");
// tslint:disable-next-line:max-classes-per-file
var PoiUrlGenerator = /** @class */ (function () {
    function PoiUrlGenerator(compiler) {
        this.route = routes_1.poisRoutes.detail;
        this.toUrl = compiler(this.route);
    }
    PoiUrlGenerator.prototype.generate = function (poi) {
        return this.toUrl({
            id: poi.id,
            placeId: poi.containingPlaceId,
            slug: this.slug(poi.containingPlaces, poi),
            type: constants_1.poiTypeSlugMap[poi.type] + "-" + constants_1.poiKindSlugMap[poi.poiType],
        });
    };
    PoiUrlGenerator.prototype.slug = function (places, poi) {
        var parts = places.filter(filterPlaceTypes_1.filterPlaceTypes)
            .map(function (p) { return p.name; })
            .reverse();
        parts.push(constants_1.poiTypes[poi.poiType].displayName);
        parts.push(poi.name);
        return parts.map(function (p) { return string_1.cleanString(p.toLowerCase()); });
    };
    return PoiUrlGenerator;
}());
exports.PoiUrlGenerator = PoiUrlGenerator;
exports.createPoiUrl = function (options) {
    return new PoiUrlGenerator(pathToRegexp.compile).generate(options);
};
// pathToRegexp.compile(route);


/***/ }),

/***/ "tgVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MapInteractiveAsync; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_containers_asyncComponent__ = __webpack_require__("vHTu");

var MapInteractiveAsync = Object(__WEBPACK_IMPORTED_MODULE_0__shared_containers_asyncComponent__["a" /* default */])(function () {
    return new Promise(function (resolve) {
        __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "58Lh")).then(function (component) {
            resolve(component.MapInteractive);
        });
    });
});


/***/ }),

/***/ "tpip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_divider__ = __webpack_require__("mAV3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_template__ = __webpack_require__("Pjik");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__("TDU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var TemplateDetail = function (_a) {
    var children = _a.children;
    var _b;
    var areas = {
        activitiesLodging: null,
        activityFeatures: null,
        activityTags: null,
        adRail: null,
        adSuperzone: null,
        breadcrumbs: null,
        callToActionAside: null,
        callToActionMobile: null,
        descriptionPartner: null,
        header: null,
        hero: null,
        heroAttribution: null,
        hotels: null,
        infoEssential: null,
        infoLocation: null,
        map: null,
        poiTags: null,
        reviewEssential: null,
        reviewExtension: null,
        suggestEdit: null,
        tour: null,
        tourItinerary: null,
    };
    if (children) {
        var theChildren = {};
        if (Array.isArray(children)) {
            theChildren = children.reduce(function (acc, child) {
                var area = child ? child.props.area : null;
                if (area) {
                    acc[area] = child;
                }
                return acc;
            }, areas);
        }
        else {
            if (children.props.area) {
                var child = children;
                var area = child.props.area;
                theChildren = (_b = {},
                    _b[area] = child,
                    _b);
            }
        }
        areas = __assign({}, areas, theChildren);
    }
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["template"], key: "poiDetail" },
        areas.breadcrumbs &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "breadcrumbs", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaBreadcrumbs"]) }, areas.breadcrumbs),
        areas.header &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "header", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaHeader"]) }, areas.header),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRail"]) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRail"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaHeroSubGrid"]) },
                areas.hero &&
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "hero", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaHero"]) }, areas.hero),
                areas.heroAttribution &&
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "heroAttribution", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaHeroAttribution"]) }, areas.heroAttribution)),
            areas.callToActionMobile &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "callToActionMobile", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaCallToActionMobile"]) }, areas.callToActionMobile),
            areas.reviewEssential &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "reviewEssential", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaArticle"]) }, areas.reviewEssential)),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("aside", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRail"] },
            areas.callToActionAside &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "callToActionAside", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaCallToActionAside"], areas.callToActionMobile && __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaCallToActionAsideDesktopOnly"]) }, areas.callToActionAside),
            areas.poiTags &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "poiTags", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailModulePadded"]) }, areas.poiTags),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_components_divider__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailDivider"] })),
            areas.infoLocation &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "infoLocation", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailModulePadded"]) }, areas.infoLocation),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_components_divider__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailDivider"] })),
            areas.infoEssential &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "infoEssential", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailModulePadded"]) }, areas.infoEssential),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_components_divider__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailDivider"] })),
            areas.activityTags &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "activityTags", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailModulePadded"]) }, areas.activityTags),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_components_divider__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailDivider"] })),
            areas.activitiesLodging &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "activitiesLodging", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailModule"]) }, areas.activitiesLodging),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_components_divider__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailDivider"] })),
            areas.adRail &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "adRail", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRightRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaAdRail"]) }, areas.adRail)),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRail"]) },
            areas.map &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "map", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaHero"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaMap"]) }, areas.map),
            areas.reviewExtension &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "reviewExtension", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaArticle"]) }, areas.reviewExtension),
            areas.descriptionPartner &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "descriptionPartner", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaArticle"]) }, areas.descriptionPartner),
            areas.suggestEdit &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "suggestEdit", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaArticle"]) }, areas.suggestEdit),
            areas.activityFeatures &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_components_divider__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRailModule"] }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "activityFeatures", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaArticle"]) }, areas.activityFeatures)),
            areas.tourItinerary &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_components_divider__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRailModule"] }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "tourItinerary", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaArticle"]) }, areas.tourItinerary)),
            areas.tour &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_components_divider__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRailModule"] }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "tour", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRailModule"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRelatedTour"]) }, areas.tour))),
        areas.hotels &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_components_divider__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaLeftRailModule"] }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "hotels", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaRelatedHotels"]) }, areas.hotels)),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__shared_components_template__["a" /* default */].Area, { key: "adSuperzone", className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["templateArea"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["templateAreaAdSuperzone"]) }, areas.adSuperzone)));
};
/* harmony default export */ __webpack_exports__["a"] = (TemplateDetail);


/***/ }),

/***/ "trvs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdBounded; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adLabel__ = __webpack_require__("otJW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("uYDL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var AdBounded = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({}, rest, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["ad"], __WEBPACK_IMPORTED_MODULE_3__styles_css__["adBounded"], className) }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__adLabel__["a" /* AdLabel */], null, "Advertisement"),
        children));
};


/***/ }),

/***/ "txaO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatAttributions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__string__ = __webpack_require__("bwFx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lodash__ = __webpack_require__("cRoh");


var getAttributionDisplay = function (_a) {
    var name = _a.name, organization = _a.organization;
    return (name && organization && name + " " + organization) || name || organization || "";
};
var formatAttributions = function (attributions) {
    if (attributions === void 0) { attributions = []; }
    return __WEBPACK_IMPORTED_MODULE_0__string__["e" /* joinWords */].apply(void 0, __WEBPACK_IMPORTED_MODULE_1__lodash__["b" /* default */].orderBy(attributions, 
    // Move attributions with names to the front, so that they'll all be displayed prior to any organizations.
    [function (_a) {
            var name = _a.name;
            return !!name;
        }], ["desc"]).map(function (singleAttribution) {
        // swap out attribution objects with their display values
        return Object(__WEBPACK_IMPORTED_MODULE_0__string__["a" /* cleanAttributionDisplay */])(getAttributionDisplay(singleAttribution));
    }).filter(function (attributionDisplayValue) {
        // filter out any empty attribution display values
        return !!attributionDisplayValue;
    }));
};


/***/ }),

/***/ "uNWQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__ = __webpack_require__("AemK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__("+tt+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var ButtonSearch = function (_a) {
    var _b = _a.children, children = _b === void 0 ? "Find a destination" : _b, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("button", __assign({}, rest, { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__styles_css__["buttonSearch"], className) }),
        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_icon__["Search"], { className: __WEBPACK_IMPORTED_MODULE_3__styles_css__["buttonSearchIcon"] }),
        children));
};


/***/ }),

/***/ "uXBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailPageInitialState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing_dist_create__ = __webpack_require__("OxjI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing_dist_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing_dist_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils_breadcrumb__ = __webpack_require__("DTul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_utils_lodash__ = __webpack_require__("cRoh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils_slug__ = __webpack_require__("sn/o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getFullBodyText__ = __webpack_require__("BkY2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_hotelProvider__ = __webpack_require__("mRgh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_buildHeadTitle__ = __webpack_require__("tW0E");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var maxRelatedActivities = 3;
var maxRelatedTours = 3;
var DetailPageInitialState = /** @class */ (function () {
    function DetailPageInitialState(options) {
        this.poi = options.poi;
        this.location = options.location;
        this.related = options.related.slice(0, maxRelatedActivities);
        this.tour = options.tour.slice(0, maxRelatedTours);
        this.places = options.places;
        this.match = options.match;
        this.isMobile = options.isMobile;
        if (options.places) {
            this.breadcrumbs = Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils_breadcrumb__["b" /* createBreadcrumbsFromAncestry */])(this.places, this.poi).concat([
                Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils_breadcrumb__["a" /* createBreadcrumbFromPoi */])(this.poi, this.places),
            ]);
        }
        this.nearby = options.nearby;
        this.profileHost = options.profileHost;
        this.authHost = options.authHost;
        this.tags = options.tags;
    }
    Object.defineProperty(DetailPageInitialState.prototype, "meta", {
        get: function () {
            var _a = this.poi, descriptions = _a.descriptions, name = _a.name, providers = _a.providers, review = _a.review;
            var provider = providers && providers.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_5__utils_hotelProvider__["a" /* default */])(providers) : {};
            var bodyText = Object(__WEBPACK_IMPORTED_MODULE_4__utils_getFullBodyText__["a" /* getFullBodyText */])({
                descriptions: descriptions,
                provider: provider,
                review: review,
            });
            return {
                canonical: "https://www.lonelyplanet.com" + this.getCanonicalUrl(__assign({}, this.poi, { containingPlaceId: this.placeIdForCanonical(this.poi.containingPlaces) })),
                description: {
                    full: bodyText,
                    truncated: __WEBPACK_IMPORTED_MODULE_2__shared_utils_lodash__["b" /* default */].truncate(bodyText, {
                        length: 300,
                        omission: "…",
                    }),
                },
                title: Object(__WEBPACK_IMPORTED_MODULE_6__utils_buildHeadTitle__["a" /* default */])(name, this.breadcrumbs),
            };
        },
        enumerable: true,
        configurable: true
    });
    DetailPageInitialState.prototype.getCanonicalUrl = function (poi) {
        return __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_routing_dist_create__["Urls"].create(poi);
    };
    DetailPageInitialState.prototype.placeIdForCanonical = function (places) {
        var city = Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils_slug__["d" /* getPlaceType */])(this.poi.containingPlaces, "city");
        var country = Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils_slug__["d" /* getPlaceType */])(this.poi.containingPlaces, "country");
        var continent = Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils_slug__["d" /* getPlaceType */])(this.poi.containingPlaces, "continent");
        var place = city || country || continent;
        if (place) {
            return place.id;
        }
        return this.poi.containingPlaceId;
    };
    return DetailPageInitialState;
}());



/***/ }),

/***/ "uYDL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ad":"styles__ad___1isGr","adBounded":"styles__adBounded___3V5Oe","adHero":"styles__adHero___3BmVy","adLabel":"styles__adLabel___1DXUD"};

/***/ }),

/***/ "uZtB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__("j9g7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var UserLoginService = /** @class */ (function () {
    function UserLoginService() {
    }
    UserLoginService.prototype.fetch = function (authHost) {
        return __awaiter(this, void 0, void 0, function () {
            var response, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(authHost + "/users/status.json", {
                            credentials: "include",
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        user = _a.sent();
                        return [2 /*return*/, user];
                }
            });
        });
    };
    return UserLoginService;
}());
/* harmony default export */ __webpack_exports__["a"] = (UserLoginService);


/***/ }),

/***/ "ueTX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_components_toast__ = __webpack_require__("l3hU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("3jnV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var ToastComponent = function (_a) {
    var buttonLabel = _a.buttonLabel, message = _a.message, type = _a.type, url = _a.url, visible = _a.visible, rest = __rest(_a, ["buttonLabel", "message", "type", "url", "visible"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__styles_css__["toastContainer"] },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_components_toast__["a" /* default */], { animationDuration: 200, buttonLabel: buttonLabel, direction: "bottom", duration: 5000, message: message, type: type, url: url, visible: visible, affixed: true })));
};
/* harmony default export */ __webpack_exports__["a"] = (ToastComponent);


/***/ }),

/***/ "ulkP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("/Ls7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);



var Grid = function (_a) {
    var id = _a.id, children = _a.children, className = _a.className, style = _a.style;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id, className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["grid"], className), style: style }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (Grid);


/***/ }),

/***/ "uqb7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navigation__ = __webpack_require__("bN4f");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__navigation__; });




/***/ }),

/***/ "uuxV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _a;
exports.poiTypeSlugMap = {
    articles: "art",
    collections: "col",
    lodging: "lod",
    narrative: "nar",
    partner_activity: "pa",
    poi: "poi",
};
exports.poiKindSlugMap = {
    activities: "act",
    drinking_nightlife: "dri",
    eating: "eat",
    entertainment: "ent",
    festivals_events: "fes",
    info: "inf",
    shopping: "sho",
    sights: "sig",
    sleeping: "sle",
    tours: "tou",
    transport: "tra",
};
exports.keys = {
    activities: "activities",
    drinking_nightlife: "drinking_nightlife",
    eating: "eating",
    entertainment: "entertainment",
    festivals_events: "festivals_events",
    info: "info",
    shopping: "shopping",
    sights: "sights",
    sleeping: "sleeping",
    transport: "transport",
};
var poiTypes = (_a = {},
    _a[exports.keys.sleeping] = {
        displayName: "Hotels",
        name: exports.keys.sleeping,
        schemaType: "LodgingBusiness",
    },
    _a[exports.keys.drinking_nightlife] = {
        displayName: "Nightlife",
        name: exports.keys.drinking_nightlife,
        schemaType: "BarOrPub",
    },
    _a[exports.keys.transport] = {
        displayName: "Transportation",
        name: exports.keys.transport,
        schemaType: "Place",
    },
    _a[exports.keys.activities] = {
        displayName: "Activities",
        name: exports.keys.activities,
        schemaType: "TouristAttraction",
    },
    _a[exports.keys.entertainment] = {
        displayName: "Entertainment",
        name: exports.keys.entertainment,
        schemaType: "EntertainmentBusiness",
    },
    _a[exports.keys.shopping] = {
        displayName: "Shopping",
        name: exports.keys.shopping,
        schemaType: "Store",
    },
    _a[exports.keys.eating] = {
        displayName: "Restaurants",
        name: exports.keys.eating,
        schemaType: "Restaurant",
    },
    _a[exports.keys.sights] = {
        displayName: "Attractions",
        name: exports.keys.sights,
        schemaType: "TouristAttraction",
    },
    _a[exports.keys.info] = {
        displayName: "Information",
        name: exports.keys.info,
        schemaType: "Place",
    },
    _a[exports.keys.festivals_events] = {
        displayName: "Events",
        name: exports.keys.festivals_events,
        schemaType: "Event",
    },
    _a);
exports.poiTypes = poiTypes;


/***/ }),

/***/ "uwTI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__("R9i6");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__map__; });




/***/ }),

/***/ "uyig":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contentArea":"search__contentArea___rHWvd","resultsText":"search__resultsText___3sPii","filters":"search__filters___22R2y","topic":"search__topic___3LFQw","searchBox":"search__searchBox___ce5_s","searchBoxSticky":"search__searchBoxSticky___1zTZr","searchForm":"search__searchForm___2bJQp","results":"search__results___xdCa0","ad":"search__ad___FOCs8","wireframe":"search__wireframe___3D_Ci"};

/***/ }),

/***/ "vHTu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

function asyncComponent(getComponent) {
    var ComponentCache = null;
    return /** @class */ (function (_super) {
        __extends(AsyncComponent, _super);
        function AsyncComponent(props) {
            var _this = _super.call(this, props) || this;
            _this.state = { Component: ComponentCache };
            return _this;
        }
        AsyncComponent.prototype.componentDidMount = function () {
            var _this = this;
            if (!this.state.Component) {
                getComponent().then(function (component) {
                    var Component = component;
                    if (component.default) {
                        Component = component.default;
                    }
                    ComponentCache = Component;
                    _this.setState({ Component: Component });
                });
            }
        };
        AsyncComponent.prototype.render = function () {
            var Component = this.state.Component;
            if (Component) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component, __assign({}, this.props));
            }
            return null;
        };
        return AsyncComponent;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
}


/***/ }),

/***/ "vmIt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DetailComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_containers_dataLayer__ = __webpack_require__("sxtG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_open_planet_node_dist_openPlanetTypes__ = __webpack_require__("Jg0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_open_planet_node_dist_openPlanetTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lonelyplanet_open_planet_node_dist_openPlanetTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_modal_wrapper__ = __webpack_require__("g5th");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_modal_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_modal_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_multiStep__ = __webpack_require__("t460");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_multiStep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_multiStep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_photoswipe_dist_photoswipe_css__ = __webpack_require__("2jnm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_photoswipe_dist_photoswipe_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_photoswipe_dist_photoswipe_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_radium__ = __webpack_require__("i2KN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__("Ol7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_asset__ = __webpack_require__("xVEJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_bookmark__ = __webpack_require__("2XqC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_containers_withInitialState__ = __webpack_require__("yvDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_bookmarks__ = __webpack_require__("okSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_nearbyPois__ = __webpack_require__("n5Zo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_user__ = __webpack_require__("p6kL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_schema__ = __webpack_require__("lUuM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_baseMeta__ = __webpack_require__("Kbyn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__initialState_detailPageInitialState__ = __webpack_require__("uXBU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lodging__ = __webpack_require__("TGOE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__partnerActivity__ = __webpack_require__("HZ7U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__patterns_toast__ = __webpack_require__("ueTX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__poi__ = __webpack_require__("rDgH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_buildPlaceDimensions__ = __webpack_require__("kbrp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lonelyplanet_lp_analytics__ = __webpack_require__("UtEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lonelyplanet_lp_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__lonelyplanet_lp_analytics__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






 /* TODO Remove this as soon as possible */


















var components = {
    lodging: __WEBPACK_IMPORTED_MODULE_19__lodging__["a" /* default */],
    partner_activity: __WEBPACK_IMPORTED_MODULE_20__partnerActivity__["a" /* default */],
    poi: __WEBPACK_IMPORTED_MODULE_22__poi__["a" /* default */],
};
var DetailComponent = /** @class */ (function (_super) {
    __extends(DetailComponent, _super);
    function DetailComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.updateBookmark = _this.updateBookmark.bind(_this);
        _this.state = {
            error: false,
            isDOM: typeof window !== "undefined",
            lpCurrency: "USD",
        };
        return _this;
    }
    DetailComponent.prototype.componentDidCatch = function (error) {
        this.setState({
            error: error,
        });
    };
    DetailComponent.prototype.componentDidMount = function () {
        var view = this.props.view;
        if ((view.poi.type === __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_open_planet_node_dist_openPlanetTypes__["lodging"] || view.poi.type === __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_open_planet_node_dist_openPlanetTypes__["poi"]) &&
            this.state.isDOM &&
            !this.props.nearbyPois.mapMarkers.length) {
            var id = view.poi.type === __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_open_planet_node_dist_openPlanetTypes__["lodging"] ? (view.poi.poi && view.poi.poi.id) : view.poi.id;
            if (id) {
                this.props.nearbyActions.fetchNearbyPois(id);
            }
        }
        if (this.state.isDOM) {
            this.setState({ lpCurrency: __WEBPACK_IMPORTED_MODULE_4_js_cookie__["get"]("lpCurrency") || "USD" });
        }
        this.props.userActions.fetchUser(view.authHost);
    };
    DetailComponent.prototype.componentWillReceiveProps = function (nextProps, prevState) {
        // Fetch bookmarks after the user id is fetched
        if (!this.props.user.id && nextProps.user.id) {
            this.fetchBookmarks(nextProps.user.id);
        }
    };
    DetailComponent.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.state, error = _b.error, isDOM = _b.isDOM, lpCurrency = _b.lpCurrency;
        if (error) {
            return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", null, error);
        }
        var _c = this.props, bookmarks = _c.bookmarks, nearbyPois = _c.nearbyPois, user = _c.user, view = _c.view;
        var Component = components[view.poi.type];
        var dataLayer = __assign({ cd10_ArticleName: null, cd21_AtlasDestination: null, cd6_SiteSection: "destinations", cd7_Topic: "Things to Do", cd8_BookingType: null, cd9_TestExperience: null, content_group_1: "content", content_group_2: "pois", content_group_3: null, content_group_4: null, content_group_5: null, page_type: "content page", poiName: view.poi.name, poiType: view.poi.poiType, poi_atlas_id: view.poi.id, resource: view.poi.type, site_section: "destinations" }, Object(__WEBPACK_IMPORTED_MODULE_23__utils_buildPlaceDimensions__["a" /* default */])(view.places));
        return (__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__components_baseMeta__["a" /* default */], { meta: view.meta, poi: view.poi, nearbyPois: nearbyPois }),
            __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_core_dist_containers_dataLayer__["a" /* default */], { data: dataLayer }),
            __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__lonelyplanet_lp_analytics__["DataLayerInitializationData"], { data: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_24__lonelyplanet_lp_analytics__["analytics"].destinationDirectory] = __WEBPACK_IMPORTED_MODULE_24__lonelyplanet_lp_analytics__["DestinationDirectories"].poi,
                    _a[__WEBPACK_IMPORTED_MODULE_24__lonelyplanet_lp_analytics__["analytics"].siteSection] = __WEBPACK_IMPORTED_MODULE_24__lonelyplanet_lp_analytics__["SiteSections"].destinations,
                    _a), indexForEntirePayload: 1, scriptWrapperForEntirePayload: __WEBPACK_IMPORTED_MODULE_24__lonelyplanet_lp_analytics__["asyncUserStatusWrapper"] }),
            __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_backpack_ui_dist_components_modal_wrapper___default.a, null, function (isOpen, toggle) { return (__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react__["Fragment"], null,
                (view.poi.type === __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_open_planet_node_dist_openPlanetTypes__["poi"] || view.poi.type === __WEBPACK_IMPORTED_MODULE_1__lonelyplanet_open_planet_node_dist_openPlanetTypes__["lodging"]) && (__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__components_schema__["a" /* Schema */].Review, { poi: view.poi, canonicalUrl: view.location.pathname })),
                __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](Component, __assign({}, view, { isDOM: isDOM, dataLayer: dataLayer, lpCurrency: lpCurrency, nearbyMapMarkers: nearbyPois && nearbyPois.mapMarkers, bookmarked: bookmarks.isBookmarked, onClickBookmark: function () {
                        if (!user.id) {
                            window.location.hash = "#login";
                        }
                        else {
                            toggle();
                        }
                    } })),
                __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_multiStep__["MultiStepWrapper"], { totalSteps: 2 }, function (currentStep, goToNextStep, goToPreviousStep, setCurrentStep) { return (__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_radium__["a" /* StyleRoot */], null,
                    __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__shared_components_bookmark__["a" /* Bookmark */].ModalAdd, { currentStep: currentStep, goToNextStep: goToNextStep, goToPreviousStep: goToPreviousStep, setCurrentStep: setCurrentStep, isOpen: isOpen, toggle: toggle, updateBookmark: _this.updateBookmark, lists: bookmarks.bookmarkLists, poi: view.poi, pois: bookmarks.resources }))); }))); }),
            __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__patterns_toast__["a" /* default */], { buttonLabel: this.props.toast.buttonLabel, message: this.props.toast.message, type: this.props.toast.type, url: this.props.toast.url, visible: this.props.toast.visible }),
            __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__shared_components_asset__["a" /* default */], { src: "app.js" })));
    };
    DetailComponent.prototype.fetchBookmarks = function (userId) {
        var _a = this.props, actions = _a.bookmarkActions, _b = _a.view, profileHost = _b.profileHost, item = _b.poi;
        actions.fetchBookmarkLists(profileHost, userId, item.id);
    };
    DetailComponent.prototype.updateBookmark = function (bookmark, list) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, actions, _b, profileHost, item, user;
            return __generator(this, function (_c) {
                _a = this.props, actions = _a.bookmarkActions, _b = _a.view, profileHost = _b.profileHost, item = _b.poi, user = _a.user;
                // The user is adding a bookmark to a new list
                if (!list.id) {
                    actions.createListAndAddBookmark(profileHost, user, list, bookmark, item);
                    // The user is adding a bookmark to an existing list which has previously contained the bookmark
                }
                else if (bookmark.id) {
                    actions.updateBookmark(profileHost, user, list, bookmark, item.id);
                    // The user is adding a new bookmark to an existing list
                }
                else {
                    actions.createBookmark(profileHost, user, list, bookmark, item);
                }
                return [2 /*return*/];
            });
        });
    };
    return DetailComponent;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]));

function mapStateToProps(state) {
    return {
        bookmarks: state.bookmarks,
        nearbyPois: state.nearbyPois,
        toast: state.toast,
        user: state.user,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        bookmarkActions: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_13__actions_bookmarks__, dispatch),
        nearbyActions: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_14__actions_nearbyPois__, dispatch),
        userActions: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_15__actions_user__, dispatch),
    };
}
var app = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(DetailComponent);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__shared_containers_withInitialState__["a" /* withInitialState */])(app, function (props) { return new __WEBPACK_IMPORTED_MODULE_18__initialState_detailPageInitialState__["a" /* DetailPageInitialState */](props); }));


/***/ }),

/***/ "vqre":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var TemplateArea = function (_a) {
    var children = _a.children, className = _a.className;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: className }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (TemplateArea);


/***/ }),

/***/ "vrsw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"listItemImage":"styles__listItemImage___1hWhb"};

/***/ }),

/***/ "wCv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortMainImagesToFront;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__ = __webpack_require__("cRoh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_constants__ = __webpack_require__("e9aK");


/**
 * If an image object has tags, and one of them is "main",
 * move it to the front.
 * Otherwise leave the order alone.
 * Does not mutate the original array.
 * @param {IImage[]} images array of image objects to be sorted.
 * @returns {IImage[]} a sorted copy of the input images array.
 */
function sortMainImagesToFront(images) {
    return __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].orderBy(images, [function (image) { return image.tags.includes(__WEBPACK_IMPORTED_MODULE_1__shared_constants__["d" /* imageTags */].main); }], ["desc"]);
}


/***/ }),

/***/ "wNbw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__("1HGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_button_buttonOutline__ = __webpack_require__("jY5B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_moreLink__ = __webpack_require__("UMFO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_moreLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_moreLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_querystring__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var tagsCountCollapsed = 10;
var tagsCountExpanded = 20;
var Tags = /** @class */ (function (_super) {
    __extends(Tags, _super);
    function Tags(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { expanded: false };
        _this.handleMoreLinkClick = _this.handleMoreLinkClick.bind(_this);
        return _this;
    }
    Tags.prototype.render = function () {
        var _this = this;
        var data = this.props.data;
        var expanded = this.state.expanded;
        var tagsToShow = expanded ?
            data.slice(0, tagsCountExpanded) :
            data.slice(0, tagsCountCollapsed);
        var hasMore = expanded ? false : data.length > tagsCountCollapsed;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            tagsToShow.map(function (tag) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_button_buttonOutline__["a" /* ButtonOutline */], { key: tag.id, className: __WEBPACK_IMPORTED_MODULE_1__styles_css__["tag"], onClick: function () { return _this.searchByTag(tag); } }, tag.label)); }),
            hasMore &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1__styles_css__["moreLink"] },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_backpack_ui_dist_components_moreLink___default.a, { href: "#", size: "small", caps: true, onClick: this.handleMoreLinkClick }, "Show more tags"))));
    };
    Tags.prototype.searchByTag = function (tag) {
        var query = tag.tag_type === "topic" ? { topic_id: tag.tag_id } : { q: tag.label };
        window.location.assign("/search?" + __WEBPACK_IMPORTED_MODULE_4_querystring__["stringify"](query));
    };
    Tags.prototype.handleMoreLinkClick = function (e) {
        e.preventDefault();
        this.setState({
            expanded: !this.state.expanded,
        });
    };
    return Tags;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Tags);


/***/ }),

/***/ "wU4d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var filterPlaceTypes_1 = __webpack_require__("duHJ");
var string_1 = __webpack_require__("KPtS");
var constants_1 = __webpack_require__("uuxV");
var routes_1 = __webpack_require__("xY00");
// tslint:disable-next-line:max-classes-per-file
var LodgingUrlGenerator = /** @class */ (function () {
    function LodgingUrlGenerator(compiler) {
        this.route = routes_1.poisRoutes.detail;
        this.toUrl = compiler(this.route);
    }
    LodgingUrlGenerator.prototype.generate = function (poi) {
        return this.toUrl({
            id: poi.id,
            placeId: poi.containingPlaceId,
            slug: this.slug(poi.containingPlaces, poi),
            type: constants_1.poiTypeSlugMap.lodging,
        });
    };
    LodgingUrlGenerator.prototype.slug = function (places, poi) {
        var parts = places.filter(filterPlaceTypes_1.filterPlaceTypes)
            .map(function (p) { return p.name; })
            .reverse();
        parts.push(constants_1.poiTypes.sleeping.displayName);
        parts.push(poi.name);
        // Clean up, and filter out names that returned empty
        return parts.map(function (p) { return string_1.cleanString(p.toLowerCase()); })
            .filter(function (p) { return p; });
    };
    return LodgingUrlGenerator;
}());
exports.LodgingUrlGenerator = LodgingUrlGenerator;


/***/ }),

/***/ "wdAr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchResults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_gpt__ = __webpack_require__("v4Eu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_gpt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_gpt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_waypoint__ = __webpack_require__("TKwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_waypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_waypoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils_ads__ = __webpack_require__("YIyS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getResultCategory__ = __webpack_require__("nYNN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_removeHTML__ = __webpack_require__("6tpt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ad_adLabel__ = __webpack_require__("a9ep");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__listItem__ = __webpack_require__("Rx5D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css__ = __webpack_require__("TPfb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_css__);









var cleanTitle = function (title) { return title.replace(/\s-\sLonely\sPlanet/, ""); };
var showAd = function (index) { return index > 0 && index % 10 === 0; };
var SearchResults = function (_a) {
    var results = _a.results, onScroll = _a.onScroll, onClickthrough = _a.onClickthrough;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, results.length && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        results.map(function (result, index) {
            var body = result.body, highlights = result.highlights, id = result.id, opType = result.opType, title = result.title, thumbnail = result.thumbnail, url = result.url;
            var description = highlights.body || Object(__WEBPACK_IMPORTED_MODULE_5__utils_removeHTML__["a" /* default */])(body) || "";
            var descriptionPipe = description.indexOf("|");
            var descriptionShort = description.substr(descriptionPipe + 1, descriptionPipe + 251);
            var handleClick = function () {
                onClickthrough(id);
            };
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { key: title + "-" + id },
                showAd(index) && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_8__styles_css__["adSearchResult"] },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ad_adLabel__["a" /* AdLabel */], null, "Advertisement"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_gpt__["Bling"], { adUnitPath: __WEBPACK_IMPORTED_MODULE_3__shared_utils_ads__["h" /* adUnits */].searchInContent, sizeMapping: [
                            {
                                slot: [
                                    __WEBPACK_IMPORTED_MODULE_3__shared_utils_ads__["c" /* adMobileRectangle */],
                                    __WEBPACK_IMPORTED_MODULE_3__shared_utils_ads__["d" /* adMobileSquare */],
                                    __WEBPACK_IMPORTED_MODULE_3__shared_utils_ads__["g" /* adSuperzone */],
                                ],
                                viewport: [0, 0],
                            },
                            {
                                slot: [__WEBPACK_IMPORTED_MODULE_3__shared_utils_ads__["b" /* adBannerSmall */], __WEBPACK_IMPORTED_MODULE_3__shared_utils_ads__["g" /* adSuperzone */]],
                                viewport: [1390, 0],
                            },
                        ], targeting: Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils_ads__["j" /* generateAdTargeting */])({
                            position: __WEBPACK_IMPORTED_MODULE_3__shared_utils_ads__["e" /* adPositions */].inContent,
                        }) }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__listItem__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_8__styles_css__["listItem"], category: Object(__WEBPACK_IMPORTED_MODULE_4__utils_getResultCategory__["a" /* default */])(result), categoryLink: url, description: descriptionShort, link: url, thumbnail: thumbnail, title: cleanTitle(title), type: opType, onClick: handleClick })));
        }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_waypoint__, { onEnter: onScroll })))));
};



/***/ }),

/***/ "xGcm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("9Nd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var TextAccentRed = function (_a) {
    var children = _a.children, _b = _a.element, element = _b === void 0 ? "span" : _b, className = _a.className, rest = __rest(_a, ["children", "element", "className"]);
    var Component = element;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["textAccentRed"], className) }, rest), children));
};
/* harmony default export */ __webpack_exports__["a"] = (TextAccentRed);


/***/ }),

/***/ "xHHm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__ = __webpack_require__("Aukv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var InfoHeading = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_text__["Heading"], __assign({ size: 7, level: 5, weight: "medium" }, rest), children));
};
/* harmony default export */ __webpack_exports__["a"] = (InfoHeading);


/***/ }),

/***/ "xNQq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"styles__header___2bTmZ","heading":"styles__heading___mD4_3","italic":"styles__italic___NkP8B","headerButtons":"styles__headerButtons___3MnEi","headerButtonShare":"styles__headerButtonShare___2ZIlJ"};

/***/ }),

/***/ "xVEJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reducePropsToState */
/* unused harmony export handleStateChangeOnClient */
/* unused harmony export createScripts */
/* unused harmony export Asset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_side_effect__ = __webpack_require__("vAAJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_side_effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_side_effect__);

var reducePropsToState = function (propsList) { return propsList
    .map(function (prop) { return prop.src; }); };
var handleStateChangeOnClient = function () { return ({}); };
var createScripts = function (state) { return state; };
var mapStateOnServer = function (state) { return createScripts(state); };
var Asset = __WEBPACK_IMPORTED_MODULE_0_react_side_effect__(reducePropsToState, handleStateChangeOnClient, mapStateOnServer)(function () { return null; });
/* harmony default export */ __webpack_exports__["a"] = (Asset);


/***/ }),

/***/ "xX/R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navigationDesktopItem":"styles__navigationDesktopItem___32z84","navigationDesktopItemCart":"styles__navigationDesktopItemCart___1kuYJ","navigationDesktopItemAvatar":"styles__navigationDesktopItemAvatar___1eWiQ","navigationDesktopMenu":"styles__navigationDesktopMenu___13hEh","navigationDesktopMenuList":"styles__navigationDesktopMenuList___3V6L9","navigationDesktopMenuListLink":"styles__navigationDesktopMenuListLink___3cpNw","navigationDesktopMenuCallout":"styles__navigationDesktopMenuCallout___3WBNZ","navigationDesktopMenuCalloutButton":"styles__navigationDesktopMenuCalloutButton___Psl9p","navigationDesktopMenuCalloutLink":"styles__navigationDesktopMenuCalloutLink___3aCSH"};

/***/ }),

/***/ "xY00":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Make sure to prefix any AJAX calls with this API base
 */
exports.apiBase = "/dot-api/";
exports.poisRoutes = {
    detail: "/:slug(.*)*/a/:type/:id/:placeId",
    lodgingAvailability: exports.apiBase + "lodgings/availability/:lodgingId",
    nearby: exports.apiBase + "pois/:id/nearby",
};


/***/ }),

/***/ "xpuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return schemaDescription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__ = __webpack_require__("cRoh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stripHtml__ = __webpack_require__("OitI");


var schemaDescription = function (review, poiType) {
    var plainTextReview = Object(__WEBPACK_IMPORTED_MODULE_1__stripHtml__["a" /* default */])(review);
    if (poiType === "eating") {
        return __WEBPACK_IMPORTED_MODULE_0__shared_utils_lodash__["b" /* default */].truncate(plainTextReview, {
            length: 200,
            omission: "…",
        });
    }
    return plainTextReview;
};


/***/ }),

/***/ "xyyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_logo__ = __webpack_require__("48gv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_container__ = __webpack_require__("f+9y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_divider__ = __webpack_require__("mAV3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__button__ = __webpack_require__("GvR7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__link__ = __webpack_require__("NpMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__navigation__ = __webpack_require__("uqb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_css__ = __webpack_require__("zssY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_css__);










var globalHeaderLinks = [
    {
        href: "/",
        items: [
            {
                href: "/best-in-travel",
                text: "Best in travel 2018",
            },
            {
                href: "/video",
                text: "Video",
            },
            {
                href: "/thorntree",
                text: "Thorn Tree Community",
            },
            {
                href: "/news",
                text: "Travel News",
            },
            {
                href: "/kids",
                text: "Lonely Planet Kids",
            },
        ],
        text: "Latest",
    },
    {
        href: "/",
        items: [
            {
                href: "/travel-insurance",
                text: "Travel Insurance",
            },
            {
                href: "/flights",
                text: "Flights",
            },
            {
                href: "/hotels",
                text: "Hotels",
            },
            {
                href: "/tours",
                text: "Tours",
            },
            {
                href: "/car-rentals",
                text: "Car rentals",
            },
        ],
        text: "Travel",
    },
    {
        callout: {
            href: "https://shop.lonelyplanet.com/",
            text: "All merchandise",
        },
        href: "/",
        items: [
            {
                href: "https://shop.lonelyplanet.com/pages/deals",
                text: "Guide books",
            },
            {
                href: "https://shop.lonelyplanet.com/pages/deals",
                text: "Coffee table books",
            },
            {
                href: "https://shop.lonelyplanet.com/pages/deals",
                text: "Lonely Planet Kids",
            },
            {
                href: "https://shop.lonelyplanet.com/pages/deals",
                text: "Magazine",
            },
        ],
        text: "Shop",
    },
];
var profileLinks = [
    {
        href: "/profile/settings",
        text: "Settings",
    },
    {
        href: "/profile/lists",
        text: "Lists",
    },
    {
        href: "/profile/dashboard",
        text: "Community dashboard",
    },
    {
        href: "/profile/messages",
        messages: 2,
        text: "Messages",
    },
];
var hasCart = function () {
    if (!__WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a) {
        return false;
    }
    var hasShopCookie = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get("shopCartCookie");
    var isOnShop = window.location.origin === "https://shop.lonelyplanet.com";
    return (hasShopCookie || isOnShop);
};
var GlobalHeader = function (_a) {
    var _b = _a.links, links = _b === void 0 ? globalHeaderLinks : _b, _c = _a.theme, theme = _c === void 0 ? "light" : _c;
    return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__link__["a" /* Link */].Skip, null),
        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_container__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_9__styles_css__["globalHeader"], theme === "dark" && __WEBPACK_IMPORTED_MODULE_9__styles_css__["globalHeaderDark"], theme === "transparent" && __WEBPACK_IMPORTED_MODULE_9__styles_css__["globalHeaderTransparent"], theme === "legacy" && __WEBPACK_IMPORTED_MODULE_9__styles_css__["globalHeaderBlue"]), element: "header", role: "banner" },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__button__["a" /* Button */].Search, { className: __WEBPACK_IMPORTED_MODULE_9__styles_css__["globalHeaderButtonSearch"] }),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_backpack_ui_dist_components_logo___default.a, null),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__navigation__["a" /* Navigation */].Desktop, { className: __WEBPACK_IMPORTED_MODULE_9__styles_css__["globalHeaderNavigationDesktop"], links: links, profileLinks: profileLinks, hasCart: hasCart() }),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_divider__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_9__styles_css__["globalHeaderDivider"] }))));
};


/***/ }),

/***/ "y78e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AppProviders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_analytics__ = __webpack_require__("Kx1W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


function AppProviders(_a) {
    var children = _a.children;
    return (
    // TODO: remove <AnalyticsProvider> upon completion of transition to lp-analytics
    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_analytics__["b" /* AnalyticsProvider */], { trackers: [__WEBPACK_IMPORTED_MODULE_0__lonelyplanet_dotcom_analytics__["c" /* GoogleTagManager */]] }, children));
}


/***/ }),

/***/ "yScR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationDesktop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_flyout__ = __webpack_require__("rRvx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__link__ = __webpack_require__("NpMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__("xX/R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};





var NavigationDesktop = function (_a) {
    var links = _a.links, profileLinks = _a.profileLinks, _b = _a.hasCart, hasCart = _b === void 0 ? false : _b, className = _a.className, rest = __rest(_a, ["links", "profileLinks", "hasCart", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("nav", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(className), role: "navigation", "aria-label": "Main navigation" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", null,
            links.map(function (link) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopItem"], key: link.text },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__link__["a" /* Link */].Navigation, { href: link.href, "data-section": link.text, topLevel: true }, link.text),
                link.items.length > 0 && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_flyout__["a" /* Flyout */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopMenu"] },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopMenuList"] }, link.items.map(function (sublink) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { key: sublink.text },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__link__["a" /* Link */].Navigation, { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopMenuListLink"], href: sublink.href }, sublink.text))); })),
                    link.callout &&
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopMenuCallout"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopMenuCalloutButton"]), href: link.callout.href }, link.callout.text))))); }),
            hasCart &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopItem"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopItemCart"]), key: "Shopping cart" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__link__["a" /* Link */].Shop, { hasItems: true })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopItem"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopItemAvatar"]), key: "Profile" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__link__["a" /* Link */].Avatar, { href: "/profile", imageSrc: "https://community-media.lonelyplanet.com/users/avatars/" +
                        "c946fa97-b11f-4950-a43b-c41180c28cd7/large/" +
                        "YmxvYlR1ZSBPY3QgMTAgMjAxNyAxNjo0NTowMyBHTVQrMDAwMCAoVVRDKQ%3D%3D.jpg" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_flyout__["a" /* Flyout */], { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopMenu"] },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopMenuList"] }, profileLinks.map(function (sublink) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { key: sublink.text },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__link__["a" /* Link */].Navigation, { className: __WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopMenuListLink"], href: sublink.href }, sublink.text))); })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__link__["a" /* Link */].Navigation, { className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopMenuCallout"], __WEBPACK_IMPORTED_MODULE_4__styles_css__["navigationDesktopMenuCalloutLink"]), href: "/" }, "Sign out"))))));
};


/***/ }),

/***/ "yj6G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"searchInputCancelButton":"styles__searchInputCancelButton___dhWHs"};

/***/ }),

/***/ "yvDJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withInitialState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

function withInitialState(Component, viewModelFactory) {
    return function (props) {
        var view = {
            view: viewModelFactory(props),
        };
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component, __assign({}, view));
    };
}


/***/ }),

/***/ "z/Jy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"panel":"styles__panel___1Zq3m"};

/***/ }),

/***/ "z5qS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MapStatic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__("PtTN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var MapStatic = function (_a) {
    var coordinates = _a.coordinates, dimensions = _a.dimensions, className = _a.className, rest = __rest(_a, ["coordinates", "dimensions", "className"]);
    var token = "pk.eyJ1IjoibG9uZWx5cGxhbmV0IiwiYSI6Imh1ODUtdUEifQ.OLLon0V6rcoTyayXzzUzsg";
    var mapBaseUrl = "http://api.tiles.mapbox.com/v4/lonelyplanet.b963d424";
    var customMarkerUrl = "https://assets.staticlp.com/assets/mapPin-primary-small.png";
    var customMarker = "url-" + encodeURIComponent(customMarkerUrl) + "(" + coordinates + ")";
    var mapImageUrl = mapBaseUrl + "/" + customMarker + "/" + coordinates + ",10/" + dimensions + ".png?access_token=" + token;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__styles_css__["map"], __WEBPACK_IMPORTED_MODULE_2__styles_css__["mapStatic"], className) }, rest),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { src: mapImageUrl, alt: "" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("small", { hidden: true },
            "\u00A9 ",
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "https://www.mapbox.com/map-feedback/" }, "Mapbox"),
            "\u00A9 ",
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "http://www.openstreetmap.org/copyright" }, "OpenStreetMap contributors"))));
};


/***/ }),

/***/ "z6N1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, "profile"))); });


/***/ }),

/***/ "zN4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AvailabilityFetcher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_constants__ = __webpack_require__("e9aK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_providerLinkBuilder__ = __webpack_require__("Virx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





var AvailabilityFetcher = /** @class */ (function (_super) {
    __extends(AvailabilityFetcher, _super);
    function AvailabilityFetcher() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dates: {
                endDate: null,
                startDate: null,
            },
            focusedInput: null,
            loading: false,
            nights: null,
            price: "",
            unavailable: false,
            url: "",
        };
        _this.checkAvailiblity = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, startDate, endDate, id, dates, response, availabilityResponse;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.state.dates, startDate = _a.startDate, endDate = _a.endDate;
                        id = this.props.lodgingId;
                        dates = {
                            fromDate: startDate.format("YYYY-MM-DD"),
                            toDate: endDate.format("YYYY-MM-DD"),
                        };
                        return [4 /*yield*/, fetch(__WEBPACK_IMPORTED_MODULE_3__shared_constants__["a" /* apiBase */] + "lodgings/availability/" + id + "?fromDate=" + dates.fromDate + "&toDate=" + dates.toDate)];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        availabilityResponse = _b.sent();
                        return [2 /*return*/, availabilityResponse];
                }
            });
        }); };
        _this.setAvailability = function (availability) {
            _this.updateNights();
            _this.setState({
                price: "$" + availability.offerings[0].cost.amount,
                unavailable: false,
            });
        };
        _this.setAvailabilityCookie = function (dates) {
            if (dates) {
                var formatedDates = {
                    endDate: dates.endDate.format("YYYY-MM-DD"),
                    startDate: dates.startDate.format("YYYY-MM-DD"),
                };
                return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["set"]("availability", formatedDates);
            }
            return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["remove"]("availability");
        };
        _this.setAsUnavailable = function () {
            _this.setState({
                nights: null,
                price: null,
                unavailable: true,
            });
        };
        _this.updateNights = function () {
            var numNights = _this.getNumNights(_this.state.dates);
            _this.setState({ nights: numNights });
        };
        _this.updateUrl = function () {
            var provider = _this.props.provider;
            var startDate = _this.state.dates.startDate.format("YYYY-MM-DD");
            var endDate = _this.state.dates.endDate.format("YYYY-MM-DD");
            var providerUrl = Object(__WEBPACK_IMPORTED_MODULE_4__utils_providerLinkBuilder__["a" /* getProviderUrl */])({ startDate: startDate, endDate: endDate }, provider);
            _this.setState({ url: providerUrl });
        };
        _this.resetFields = function () {
            _this.setState({
                nights: null,
                price: null,
                unavailable: false,
            });
        };
        _this.hasValidDates = function () {
            return (_this.state.dates.startDate && _this.state.dates.endDate) && !__WEBPACK_IMPORTED_MODULE_1_moment__().isAfter(_this.state.dates.startDate);
        };
        _this.onDateChange = function (dates) {
            _this.setState({ dates: dates }, function () { return __awaiter(_this, void 0, void 0, function () {
                var availability;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.hasValidDates()) return [3 /*break*/, 2];
                            this.setAvailabilityCookie(this.state.dates);
                            this.toggleLoading();
                            return [4 /*yield*/, this.checkAvailiblity()];
                        case 1:
                            availability = _a.sent();
                            this.toggleLoading();
                            this.updateUrl();
                            if (availability.length) {
                                this.setAvailability(availability[0]);
                            }
                            else {
                                this.setAsUnavailable();
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            this.resetFields();
                            this.setAvailabilityCookie();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.onFocusChange = function (focusedInput) {
            return _this.setState({
                focusedInput: focusedInput,
            });
        };
        _this.getNumNights = function (dates) {
            return dates.endDate.diff(dates.startDate, "days") || null;
        };
        return _this;
    }
    AvailabilityFetcher.prototype.render = function () {
        var availabilityData = {
            dates: {
                endDate: this.state.dates.endDate && __WEBPACK_IMPORTED_MODULE_1_moment__(this.state.dates.endDate),
                startDate: this.state.dates.startDate && __WEBPACK_IMPORTED_MODULE_1_moment__(this.state.dates.startDate),
            },
            focusedInput: this.state.focusedInput,
            handleDateChange: this.onDateChange,
            handleFocusChange: this.onFocusChange,
            loading: this.state.loading,
            nights: this.state.nights,
            price: this.state.price,
            unavailable: this.state.unavailable,
            url: this.state.url || Object(__WEBPACK_IMPORTED_MODULE_4__utils_providerLinkBuilder__["a" /* getProviderUrl */])({}, this.props.provider),
        };
        return this.props.render(availabilityData);
    };
    AvailabilityFetcher.prototype.componentDidMount = function () {
        var _this = this;
        var availCookie = __WEBPACK_IMPORTED_MODULE_0_js_cookie__["getJSON"]("availability");
        if (availCookie) {
            this.setState({
                dates: {
                    endDate: availCookie.endDate && __WEBPACK_IMPORTED_MODULE_1_moment__(availCookie.endDate),
                    startDate: availCookie.startDate && __WEBPACK_IMPORTED_MODULE_1_moment__(availCookie.startDate),
                },
            }, function () { return _this.onDateChange(_this.state.dates); });
        }
    };
    AvailabilityFetcher.prototype.toggleLoading = function () {
        this.setState({
            loading: !this.state.loading,
        });
    };
    return AvailabilityFetcher;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));

/* harmony default export */ __webpack_exports__["a"] = (AvailabilityFetcher);


/***/ }),

/***/ "zssY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"globalHeader":"styles__globalHeader___3PbEY","globalHeaderTransparent":"styles__globalHeaderTransparent___3j4zQ","globalHeaderDark":"styles__globalHeaderDark___3mP0R","globalHeaderBlue":"styles__globalHeaderBlue___v37ws","globalHeaderContainer":"styles__globalHeaderContainer___3H2RI","globalHeaderDivider":"styles__globalHeaderDivider___GUZTc","globalHeaderButtonSearch":"styles__globalHeaderButtonSearch___2FejB","globalHeaderNavigationDesktop":"styles__globalHeaderNavigationDesktop___2QjEZ"};

/***/ }),

/***/ "zuOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony export (immutable) */ __webpack_exports__["c"] = post;
/* harmony export (immutable) */ __webpack_exports__["b"] = patch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__("j9g7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function get(url) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url, {
                        credentials: "same-origin",
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function post(url, data) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url, {
                        body: JSON.stringify(data),
                        credentials: "include",
                        headers: new Headers({
                            "Content-Type": "application/json",
                            accept: "application/json",
                        }),
                        method: "POST",
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    if (response.status === 204) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function patch(url, data) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url, {
                        body: JSON.stringify(data),
                        credentials: "include",
                        headers: new Headers({
                            "Content-Type": "application/json",
                            accept: "application/json",
                        }),
                        method: "PATCH",
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}


/***/ })

},["Df23"]);


// WEBPACK FOOTER //
// app.3aa4a45f5af8b34f295b.js